'use client'
import {
  SeatsChart_default
} from "./chunk-F7WCXMYZ.mjs";
import {
  BookingPageSkeleton_default
} from "./chunk-ZCNSKF47.mjs";
import {
  useTicketing
} from "./chunk-POZFG435.mjs";
import {
  addBaseUrl,
  removeBaseUrl
} from "./chunk-HHM5XRXW.mjs";
import {
  Back_default
} from "./chunk-YL5YCJF5.mjs";
import {
  BookingWrapper_default,
  WbkContactUs_default
} from "./chunk-4JT4AM7Z.mjs";
import {
  TicketTypeName_default
} from "./chunk-B7WBL44R.mjs";
import {
  ALDANA_SLUG
} from "./chunk-OMQ4LRG6.mjs";
import {
  addons_default
} from "./chunk-SBVHDSIP.mjs";
import {
  soldout_default
} from "./chunk-VUVIFRCT.mjs";
import {
  context_default,
  defaultState,
  useBooking_default
} from "./chunk-NFYYQXAH.mjs";
import {
  getAvailableTickets,
  getEventLimits,
  getTicketTypesForSeatIoCategory,
  groupTicketsByGroupName,
  hasSomeTicketsForSale,
  listTicketsByGroup,
  parseEventToAnalyticsEvent
} from "./chunk-HGCJUMLB.mjs";
import {
  getActualProductPrice,
  getOriginalProductPrice,
  groupAddonsByGroupName
} from "./chunk-6NSJHEQW.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/booking/Page.tsx
import { useEffect as useEffect10 } from "react";
import { useGetEventPerks, useGetTicketingEvent } from "@wbk/api/hooks";
import { PurchasePriorityCheck } from "@wbk/subscription";
import { WithGrecaptcha } from "@wbk/api/grecaptcha";
import { useAnalytics as useAnalytics3 } from "@wbk/analytics";
import { NafathCheckPoint, useAuth as useAuth7 } from "@wbk/auth";
import { WbkPaymentProvider } from "@wbk/payment";
import { Link as Link2, Trans as Trans5, useRouter as useRouter17 } from "@wbk/config";
import { Button as Button23, Typography as Typography7, WebviewUnload } from "@wbk/ui";

// src/context/booking/provider.tsx
import { useEffect as useEffect2, useMemo, useState } from "react";
import { useAnalytics } from "@wbk/analytics";
import { FormProvider, useForm } from "react-hook-form";
import { checkout } from "@wbk/api";
import { Exception } from "@wbk/logger";
import { createCookie, parseDateString, stringToBase64 } from "@wbk/utils";
import { ProfileCheckPoint, useAuth } from "@wbk/auth";
import { usePageShow } from "@wbk/hooks";
import { useGetEventQuestions, useGetWalletHistory } from "@wbk/api/hooks";
import { useSubscriptionBenefits, useSubscriptionTicketBenefits } from "@wbk/subscription";
import { MAX_PAYMENT_AMOUNT, usePayment } from "@wbk/payment";
import { useAppSource, useRouter, useTranslation as useTranslation3 } from "@wbk/config";

// src/components/booking/questions/QuestionsModal.tsx
import { useEffect, useRef } from "react";
import { ResponsiveModal } from "@wbk/ui";
import { useTranslation as useTranslation2 } from "@wbk/config";

// src/components/booking/questions/Question.tsx
import { useTranslation } from "@wbk/config";
import { ExclamationIcon } from "@wbk/svg";
import { Input, RadioGroup, Select, ToggleGroup, Tooltip, Typography } from "@wbk/ui";
import { Controller, useFormContext } from "react-hook-form";
import { EMAIL_PATTERN } from "@wbk/utils";
import { jsx, jsxs } from "react/jsx-runtime";
var Question = ({ question }) => {
  const { t } = useTranslation("ticketing_common");
  const { control } = useFormContext();
  const isRequired = question.mandatory === "on";
  const label = /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(Typography, { as: "span", variant: "label-M", children: question.title }),
    question.tip && /* @__PURE__ */ jsx(Tooltip, { content: question.tip, children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(ExclamationIcon, {}) }) })
  ] });
  const isInvalid = question.type === "dropdown" && !question.dropdown_question_options || question.type === "radio-button" && !question.radiobutton_question_options;
  if (isInvalid)
    return null;
  return /* @__PURE__ */ jsx(
    Controller,
    {
      control,
      name: `questions.${question._id}`,
      shouldUnregister: true,
      rules: {
        required: isRequired ? t("ticketing_common:validation.required") : false,
        pattern: question.validation === "email" ? { value: EMAIL_PATTERN, message: t("ticketing_common:validation.invalid_email") } : void 0,
        validate: (value) => {
          return isRequired ? !!value.trim() : true;
        }
      },
      defaultValue: "",
      render: ({ field, fieldState: { error } }) => {
        switch (question.type) {
          case "dropdown": {
            const options = question.dropdown_question_options.replace(/\s+/g, "").split(",").map((op) => ({ value: op, text: op, id: op }));
            return /* @__PURE__ */ jsx(
              Select,
              __spreadProps(__spreadValues({
                portal: false,
                label,
                options,
                error: error == null ? void 0 : error.message
              }, field), {
                onChange: (op) => field.onChange(op == null ? void 0 : op.value)
              })
            );
          }
          case "yes-no": {
            const options = [
              { value: "yes", text: t("ticketing_common:yes") },
              { value: "no", text: t("ticketing_common:no") }
            ];
            return /* @__PURE__ */ jsx(
              RadioGroup,
              __spreadValues({
                groupClassName: "flex gap-2 space-y-0",
                className: "h-11 grow",
                label,
                options,
                error: error == null ? void 0 : error.message
              }, field)
            );
          }
          case "radio-button": {
            const options = question.radiobutton_question_options.replace(/\s+/g, "").split(",").map((op) => ({
              value: op,
              text: op
            }));
            return /* @__PURE__ */ jsx(
              ToggleGroup,
              __spreadValues({
                type: "single",
                label,
                options,
                error: error == null ? void 0 : error.message
              }, field)
            );
          }
          default:
            return /* @__PURE__ */ jsx(
              Input,
              __spreadValues({
                label,
                error: error == null ? void 0 : error.message,
                type: question.validation === "numeric" ? "number" : question.validation === "email" ? "email" : "text"
              }, field)
            );
        }
      }
    }
  );
};
var Question_default = Question;

// src/components/booking/questions/QuestionsModal.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var QuestionsModal = (_a) => {
  var _b = _a, { questions, open, onClose } = _b, props = __objRest(_b, ["questions", "open", "onClose"]);
  const { t } = useTranslation2("ticketing_booking");
  const modalRef = useRef(void 0);
  useEffect(() => {
    var _a2, _b2;
    if (open) {
      (_a2 = modalRef.current) == null ? void 0 : _a2.open();
    } else {
      (_b2 = modalRef.current) == null ? void 0 : _b2.close();
    }
  }, [open]);
  return /* @__PURE__ */ jsx2(
    ResponsiveModal,
    __spreadProps(__spreadValues({}, props), {
      ref: modalRef,
      className: "overflow-visible",
      onClose,
      title: t("ticketing_booking:questions_title"),
      body: () => /* @__PURE__ */ jsx2("div", { className: "space-y-4", children: questions.map((question) => {
        return /* @__PURE__ */ jsx2(Question_default, { question }, question._id);
      }) }),
      cancel: false,
      action: {
        label: t("ticketing_booking:submit"),
        form: "ticket-checkout-form",
        theme: "primary"
      },
      size: "lg",
      closeButton: true
    })
  );
};
var QuestionsModal_default = QuestionsModal;

// src/context/booking/provider.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var BookingProvider = (_a) => {
  var _b = _a, {
    event,
    perks: eventPerks,
    isStream,
    isSeason,
    children
  } = _b, otherData = __objRest(_b, [
    "event",
    "perks",
    "isStream",
    "isSeason",
    "children"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
  const { user } = useAuth();
  const isMatch = !!((_a2 = event == null ? void 0 : event.home_team) == null ? void 0 : _a2._id) && !!((_b2 = event == null ? void 0 : event.away_team) == null ? void 0 : _b2._id);
  const prevSelected = [(_c = event == null ? void 0 : event.away_team) == null ? void 0 : _c._id, (_d = event == null ? void 0 : event.home_team) == null ? void 0 : _d._id].includes(
    (user == null ? void 0 : user.favorite_team) || ""
  );
  const showTeams = isMatch && !prevSelected;
  const isSeated = event.is_seated && !event.is_best_available_checkout;
  const [data, setData] = useState(__spreadValues(__spreadProps(__spreadValues({}, defaultState), {
    isSeason,
    event,
    checkoutMode: showTeams ? "teams" : (event == null ? void 0 : event.time_slots) ? "calendar" : "tickets",
    favoriteTeam: prevSelected ? user == null ? void 0 : user.favorite_team : void 0,
    isPerks: !!(eventPerks == null ? void 0 : eventPerks.length)
  }), otherData));
  const methods = useForm({
    defaultValues: {
      acceptedTerms: {
        webookTerms: false,
        resellTerms: !!event.is_live_streaming,
        subscriptionTerms: false,
        sendTicketsTerms: false,
        consent: true
      },
      questions: {}
    }
  });
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showProfile, setShowProfile] = useState();
  const [showQuestions, setShowQuestions] = useState();
  const {
    coupon,
    saudi_redeem,
    saudi_redeem_total,
    enable_wallet_credits,
    paymentMethod,
    isSubscriptionCreditsEnabled,
    setSelectedTicketIds,
    onApplePayPayment,
    cardType,
    isValid,
    error: paymentError
  } = usePayment({
    paytabs: {
      onBeforeSubmit: () => {
        setCheckoutLoading(true);
        return true;
      },
      onCallback: ({ token }) => {
        methods.setValue("payment_token", token);
        methods.handleSubmit(() => initCheckout())();
      }
    },
    applePay: {
      onPaymentAuthorized: onApplePayPaymentAuthorized,
      onPaymentSuccess: onApplePayPaymentSuccess,
      onPaymentFailed: () => {
        setCheckoutLoading(false);
      }
    }
  });
  const { cartEvent, beginCheckout, viewSummaryEvent } = useAnalytics();
  const { bookingSource } = useAppSource();
  const { locale, push, baseUrl } = useRouter();
  const { t } = useTranslation3("ticketing_booking");
  const { data: walletData } = useGetWalletHistory({ lang: locale });
  const { benefitValue } = useSubscriptionBenefits({
    action: "innovation_fee",
    event,
    valueType: "min"
  });
  useEffect2(() => {
    methods.setValue("payment_method", paymentMethod, { shouldValidate: true });
  }, [paymentMethod, isValid]);
  const isQuestionsRequired = !!((_e = event.questions) == null ? void 0 : _e.available);
  const { data: questions } = useGetEventQuestions(
    { slug: event.slug, lang: locale },
    { enabled: isQuestionsRequired }
  );
  const subscriptionBookingLimit = useSubscriptionTicketBenefits({
    action: event.is_live_streaming ? "streaming" : "booking_limit",
    event,
    selectedTickets: ((_f = data.seatTickets.selectedSeats) == null ? void 0 : _f.length) > 0 ? data.seatTickets.selectedTickets : data.plainTickets,
    selectedSlot: data.time_slots ? {
      _id: (_i = (_h = (_g = Object.values(data.time_slots)) == null ? void 0 : _g[0]) == null ? void 0 : _h[0]) == null ? void 0 : _i._id
    } : void 0
  });
  const selectedPlanFee = (_n = (_m = (_j = event.subscription_benefits) == null ? void 0 : _j.innovation_fee) == null ? void 0 : _m[((_l = (_k = data.subscription) == null ? void 0 : _k.plan) == null ? void 0 : _l._id) || ""]) == null ? void 0 : _n.value;
  const planFee = typeof selectedPlanFee === "number" ? selectedPlanFee : benefitValue;
  const feeType = (_o = event.fees) == null ? void 0 : _o.fee_type;
  const feeAmount = ((_p = event.fees) == null ? void 0 : _p.amount) || 0;
  const feeVat = ((_q = event.fees) == null ? void 0 : _q.vat) || 0;
  const ticketFee = feeType === "order" ? 0 : typeof planFee === "number" ? planFee : feeAmount;
  const ticketFeeVat = feeType === "order" ? 0 : typeof planFee === "number" ? 0 : feeVat;
  const orderFee = feeType === "order" ? feeAmount : 0;
  const orderFeeVat = feeType === "order" ? feeVat : 0;
  const addAddon = (addon, quantity) => {
    setData((prev) => {
      const exists = prev.addons.findIndex((a) => a._id === addon._id);
      if (exists >= 0) {
        return __spreadProps(__spreadValues({}, prev), {
          addons: prev.addons.map(
            (a) => a._id === addon._id ? __spreadProps(__spreadValues({}, a), { qty: a.qty + quantity }) : a
          )
        });
      }
      return __spreadProps(__spreadValues({}, prev), {
        addons: prev.addons.concat(__spreadProps(__spreadValues({}, addon), { qty: quantity }))
      });
    });
  };
  const removeAddon = (addon, quantity) => {
    setData((prev) => {
      const exists = prev.addons.find((a) => a._id === addon._id);
      const remove = exists && exists.qty - quantity <= 0;
      if (remove) {
        return __spreadProps(__spreadValues({}, prev), {
          addons: prev.addons.filter((a) => a._id !== addon._id)
        });
      }
      return __spreadProps(__spreadValues({}, prev), {
        addons: prev.addons.map(
          (a) => a._id === addon._id ? __spreadProps(__spreadValues({}, a), { qty: Math.max(a.qty - quantity, 0) }) : a
        )
      });
    });
  };
  const eventTickets = useMemo(() => {
    var _a3, _b3;
    const firstSlot = (_b3 = (_a3 = Object.values(data.time_slots || {})) == null ? void 0 : _a3[0]) == null ? void 0 : _b3[0];
    const seenIds = /* @__PURE__ */ new Set();
    const validPerkTickets = [];
    for (const perk of eventPerks || []) {
      const isExcludedPerk = !perk.event_tickets.some(
        (t2) => event.event_tickets.some((tt) => tt._id === t2._id)
      );
      if (isExcludedPerk) {
        continue;
      }
      for (const ticket of perk.event_tickets) {
        if (!seenIds.has(ticket._id)) {
          seenIds.add(ticket._id);
          validPerkTickets.push(ticket);
        }
      }
    }
    const perkTickets = data.isPerks ? validPerkTickets : null;
    const tickets = perkTickets || (firstSlot == null ? void 0 : firstSlot.event_tickets) || event.event_tickets || [];
    return tickets.map((ticket) => __spreadProps(__spreadValues({}, ticket), {
      qty: 0,
      priceWithFee: Number(ticket.price) + ticketFee,
      vatWithFee: Number(ticket.vat) + ticketFeeVat,
      originalPriceWithFee: Number(ticket.original_price) + ticketFee
    }));
  }, [data.isPerks, data.time_slots, event.event_tickets, ticketFee, ticketFeeVat, eventPerks]);
  useEffect2(() => {
    const selectedIds = isSeated ? data.seatTickets.selectedTickets.map((ticket) => ticket.ticket_id) : data.plainTickets.map((ticket) => ticket._id);
    setSelectedTicketIds(selectedIds);
  }, [data.seatTickets, data.plainTickets, isSeated]);
  const addPlain = (ticket, quantity) => {
    setData((prev) => {
      const exists = prev.plainTickets.findIndex((t2) => t2._id === ticket._id);
      if (exists >= 0) {
        return __spreadProps(__spreadValues({}, prev), {
          plainTickets: prev.plainTickets.map(
            (t2) => t2._id === ticket._id ? __spreadProps(__spreadValues({}, t2), { qty: t2.qty + quantity }) : t2
          )
        });
      }
      return __spreadProps(__spreadValues({}, prev), {
        plainTickets: [...prev.plainTickets, __spreadProps(__spreadValues({}, ticket), { qty: quantity })]
      });
    });
    cartEvent({
      item: ticket,
      quantity,
      type: "add",
      event: parseEventToAnalyticsEvent(event)
    });
  };
  const replacePlain = (ticket, quantity) => {
    setData((prev) => {
      var _a3;
      return __spreadProps(__spreadValues({}, prev), {
        plainTickets: [__spreadProps(__spreadValues({}, ticket), { qty: quantity })],
        streamingBenefitsEnabled: !isStream ? false : !!((_a3 = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _a3[ticket.subscription_ticket_type_id || ""])
      });
    });
    cartEvent({
      item: ticket,
      quantity,
      type: "add",
      event: parseEventToAnalyticsEvent(event)
    });
  };
  const removePlain = (ticket, quantity) => {
    setData((prev) => {
      const exists = prev.plainTickets.find((t2) => t2._id === ticket._id);
      const remove = exists && exists.qty - quantity <= 0;
      if (remove) {
        return __spreadProps(__spreadValues({}, prev), {
          plainTickets: prev.plainTickets.filter((t2) => t2._id !== ticket._id)
        });
      }
      return __spreadProps(__spreadValues({}, prev), {
        plainTickets: prev.plainTickets.map(
          (t2) => t2._id === ticket._id ? __spreadProps(__spreadValues({}, t2), { qty: Math.max(t2.qty - quantity, 0) }) : t2
        )
      });
    });
    cartEvent({
      item: ticket,
      quantity,
      type: "remove",
      event: parseEventToAnalyticsEvent(event)
    });
  };
  const addSeat = (seat) => {
    if (!data.event)
      return;
    const ticket = eventTickets.find((t2) => {
      if (seat.selectedTicketType && !t2.ticket_type)
        return false;
      return t2.ticket_type ? Number(t2.seats_io_category) === seat.category.key && t2.ticket_type.slug === seat.selectedTicketType : Number(t2.seats_io_category) === seat.category.key;
    });
    if (ticket) {
      const selectedSeat = __spreadProps(__spreadValues({}, seat), {
        chart: __spreadProps(__spreadValues({}, seat.chart), {
          // config leads to: Converting circular structure to JSON
          config: {}
        })
      });
      setData((prev) => {
        if (seat.numSelected) {
          const exists = prev.seatTickets.selectedTickets.find(
            (t2) => t2.ticket_type ? t2._id === seat.id && t2.ticket_type.slug === seat.selectedTicketType : t2._id === seat.id
          );
          if (exists) {
            return __spreadProps(__spreadValues({}, prev), {
              seatTickets: __spreadProps(__spreadValues({}, prev.seatTickets), {
                selectedSeats: prev.seatTickets.selectedSeats.concat(selectedSeat),
                selectedTickets: prev.seatTickets.selectedTickets.map(
                  (t2) => t2._id === exists._id ? __spreadProps(__spreadValues({}, t2), { qty: Number(seat.numSelected) }) : t2
                )
              })
            });
          }
        }
        return __spreadProps(__spreadValues({}, prev), {
          seatTickets: __spreadProps(__spreadValues({}, prev.seatTickets), {
            selectedSeats: prev.seatTickets.selectedSeats.concat(selectedSeat),
            selectedTickets: prev.seatTickets.selectedTickets.concat(__spreadProps(__spreadValues({}, ticket), {
              uuid: seat.uuid,
              _id: seat.id,
              ticket_id: ticket._id,
              category: seat.category,
              labels: seat.labels,
              seat_id: seat.id,
              qty: 1
            }))
          })
        });
      });
      cartEvent({
        item: ticket,
        quantity: 1,
        type: "add",
        event: parseEventToAnalyticsEvent(event)
      });
    }
  };
  const removeSeat = (seat) => {
    if (!data.event)
      return;
    const seatId = (seat2, idField = "uuid") => `${seat2[idField]}${seat2.selectedTicketType ? "_" + seat2.selectedTicketType : ""}`;
    const ticketId = (ticket2) => `${ticket2.seat_id}${ticket2.ticket_type ? "_" + ticket2.ticket_type.slug : ""}`;
    setData((prev) => {
      const existTicket = prev.seatTickets.selectedTickets.find(
        (t2) => ticketId(t2) === seatId(seat, "id")
      );
      if (existTicket && existTicket.qty > 1) {
        const existSeat = prev.seatTickets.selectedSeats.findIndex(
          (t2) => seatId(t2) === seatId(seat)
        );
        return __spreadProps(__spreadValues({}, prev), {
          seatTickets: __spreadProps(__spreadValues({}, prev.seatTickets), {
            selectedSeats: [
              ...prev.seatTickets.selectedSeats.slice(0, existSeat),
              ...prev.seatTickets.selectedSeats.slice(existSeat + 1)
            ],
            selectedTickets: prev.seatTickets.selectedTickets.map(
              (t2) => ticketId(t2) === ticketId(existTicket) ? __spreadProps(__spreadValues({}, t2), { qty: t2.qty - 1 }) : t2
            )
          })
        });
      }
      return __spreadProps(__spreadValues({}, prev), {
        seatTickets: __spreadProps(__spreadValues({}, prev.seatTickets), {
          selectedSeats: prev.seatTickets.selectedSeats.filter((s) => seatId(s) !== seatId(seat)),
          selectedTickets: prev.seatTickets.selectedTickets.filter(
            (t2) => ticketId(t2) !== seatId(seat, "id")
          )
        })
      });
    });
    const ticket = eventTickets.find((t2) => Number(t2.seats_io_category) === seat.category.key);
    if (ticket) {
      cartEvent({
        item: ticket,
        type: "remove",
        event: parseEventToAnalyticsEvent(event)
      });
    }
  };
  const removeAllSeats = () => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      seatTickets: __spreadProps(__spreadValues({}, prev.seatTickets), {
        selectedSeats: [],
        selectedTickets: []
      })
    }));
  };
  const addMerchandiseProduct = (item) => {
    setData((prev) => {
      const existingIndex = prev.merchandise.findIndex(
        (prod) => {
          var _a3;
          return item.variation ? item.variation.ID === ((_a3 = prod.variation) == null ? void 0 : _a3.ID) : item.product.ID === prod.product.ID;
        }
      );
      if (existingIndex >= 0) {
        return __spreadProps(__spreadValues({}, prev), {
          merchandise: prev.merchandise.map(
            (p, index) => index === existingIndex ? __spreadProps(__spreadValues({}, p), { qty: p.qty + item.qty }) : p
          )
        });
      }
      return __spreadProps(__spreadValues({}, prev), {
        merchandise: prev.merchandise.concat(item)
      });
    });
  };
  const removeMerchandiseProduct = (productId, removeAll) => {
    setData((prev) => {
      return __spreadProps(__spreadValues({}, prev), {
        merchandise: prev.merchandise.map((item) => {
          var _a3;
          const isSame = ((_a3 = item.variation) == null ? void 0 : _a3.ID) === productId || item.product.ID === productId;
          return isSame ? __spreadProps(__spreadValues({}, item), { qty: item.qty - (removeAll ? item.qty : 1) }) : item;
        }).filter((item) => item.qty > 0)
      });
    });
  };
  const clearAll = () => {
    const currenTickets = data.seatTickets.selectedTickets.length ? data.seatTickets.selectedTickets : data.plainTickets;
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      time_slots: void 0,
      plainTickets: [],
      seatTickets: __spreadProps(__spreadValues({}, prev.seatTickets), {
        selectedSeats: [],
        selectedTickets: []
      })
    }));
    for (const ticket of currenTickets) {
      cartEvent({
        item: ticket,
        quantity: ticket.qty,
        type: "remove",
        event: parseEventToAnalyticsEvent(event)
      });
    }
  };
  const onSeatsInitialized = (props) => {
    if (props.token) {
      createCookie({
        name: "holdToken",
        value: props.token,
        path: window.location.pathname
      });
    }
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      sessionEnd: Date.now() + (props.expiresInSeconds || 0) * 1e3,
      seatTickets: __spreadValues(__spreadValues({}, prev.seatTickets), props)
    }));
  };
  const setChart = (chart) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), { chart }));
  };
  const setCheckoutMode = (mode) => {
    var _a3, _b3;
    setData((prev) => __spreadProps(__spreadValues({}, prev), { checkoutMode: mode }));
    const selectedSlot = (_b3 = (_a3 = Object.values(data.time_slots || {})) == null ? void 0 : _a3[0]) == null ? void 0 : _b3[0];
    if (mode === "summary") {
      viewSummaryEvent({
        items: isSeated ? data.seatTickets.selectedTickets : data.plainTickets,
        coupon,
        event: __spreadProps(__spreadValues({}, parseEventToAnalyticsEvent(event)), {
          start_date_time: selectedSlot ? new Date(parseDateString(selectedSlot.time_from)).getTime() / 1e3 : data.event.start_date_time
        })
      });
    }
  };
  usePageShow({
    onShow: () => {
      window.location.reload();
    }
  });
  const setTicketErrors = (errors) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), { ticket_errors: errors }));
  };
  const selectSlot = (slot) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      time_slots: slot
    }));
  };
  const setSlotState = (_r) => {
    var state = __objRest(_r, []);
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      slotState: __spreadValues(__spreadValues({}, prev.slotState), state)
    }));
  };
  const setFavoriteTeam = (team) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), {
      favoriteTeam: team
    }));
  };
  const setSubscription = (subscription) => {
    setData((prev) => __spreadProps(__spreadValues({}, prev), { subscription }));
  };
  const limits = useMemo(() => {
    return getEventLimits({ event, isSeason });
  }, [event, isSeason]);
  const totalTickets = useMemo(() => {
    if (data.plainTickets.length > 0) {
      return data.plainTickets.reduce((acc, ticket) => acc + ticket.qty, 0);
    }
    return data.seatTickets.selectedTickets.reduce((acc, ticket) => acc + ticket.qty, 0);
  }, [data.plainTickets, data.seatTickets.selectedTickets]);
  const perks = useMemo(() => {
    var _a3;
    let discount = 0;
    let vatDiscount = 0;
    const userPerks = (_a3 = eventPerks || []) == null ? void 0 : _a3.filter(
      (perk) => perk.discount_percentage > 0 && eventTickets.some((t2) => perk.eligible_event_ticket_ids.includes(t2._id))
    );
    const appliedPerks = [];
    const tickets = isStream || !isSeated ? data.plainTickets : data.seatTickets.selectedTickets;
    const totalPerksPerTicket = {};
    for (const perk of userPerks) {
      let eligibleQty = perk.user_remaining_tickets;
      const ticketsQty = {};
      for (const ticket of tickets) {
        const id = ticket._id;
        const ticketId = ticket.ticket_id || ticket._id;
        const appliedQty = Math.min(eligibleQty, ticket.qty);
        const totalQty = totalPerksPerTicket[id] || 0;
        const isPerkApplied = perk.eligible_event_ticket_ids.includes(ticketId) && totalQty < perk.user_remaining_tickets;
        if (isPerkApplied && eligibleQty > 0) {
          const currentQty = ticketsQty[id] || 0;
          const updatedQty = currentQty + appliedQty;
          ticketsQty[id] = updatedQty;
          eligibleQty -= appliedQty;
          totalPerksPerTicket[id] = updatedQty;
          const percent = perk.discount_percentage / 100;
          discount += Number(ticket.price) * appliedQty * percent;
          vatDiscount += Number(ticket.vat) * appliedQty * percent;
        }
      }
      if (Object.keys(ticketsQty).length > 0) {
        appliedPerks.push({ perk, ticketsQty });
      }
    }
    return { appliedPerks, userPerks, totalPerksPerTicket, discount, vatDiscount };
  }, [
    eventPerks,
    isStream,
    isSeated,
    data.plainTickets,
    data.seatTickets.selectedTickets,
    eventTickets
  ]);
  const orderFeesIncluded = useMemo(() => {
    var _a3, _b3;
    const selectedTicketsIds = isSeated ? data.seatTickets.selectedTickets.map((t2) => t2.ticket_id) : data.plainTickets.map((t2) => t2._id);
    const feesTicketsSet = new Set(((_a3 = event.fees) == null ? void 0 : _a3.fee_ticket_type) || []);
    return ((_b3 = event.fees) == null ? void 0 : _b3.fee_type) === "order" && selectedTicketsIds.some((id) => feesTicketsSet.has(id));
  }, [event.fees, isSeated, data.plainTickets, data.seatTickets.selectedTickets]);
  const _s = useMemo(() => {
    var _a3;
    const tickets = isStream || !isSeated ? data.plainTickets : data.seatTickets.selectedTickets;
    const walletBalance = (walletData == null ? void 0 : walletData.total_balance) || 0;
    const walletCreditsAmount = enable_wallet_credits ? walletBalance : 0;
    let gross = 0;
    let gross_discount = 0;
    let vat = 0;
    let vat_discount = 0;
    if (data.subscription) {
      gross += data.subscription.plan.price || 0;
      vat += data.subscription.plan.vat || 0;
    }
    gross_discount += perks.discount;
    vat_discount += perks.vatDiscount;
    const eventVatPercent = Number(event == null ? void 0 : event.vat_percent) || 15;
    const vatPercentage = eventVatPercent / 100;
    for (const item of data.merchandise) {
      const salePrice = getActualProductPrice(item.product, item.variation) * item.qty;
      const itemVat = salePrice - salePrice / (1 + vatPercentage);
      const itemGross = salePrice - itemVat;
      gross += itemGross;
      vat += itemVat;
    }
    for (const item of data.addons) {
      const salePrice = item.price * item.qty;
      const vatAmount = salePrice * vatPercentage / (1 + vatPercentage);
      vat += vatAmount;
      gross += salePrice - vatAmount;
    }
    for (const ticket of tickets) {
      const hasDiscount = ticket.price !== ticket.original_price;
      const singlePrice = Number(ticket.price) * ticket.qty;
      const singleVat = Number(ticket.vat) * ticket.qty;
      if (hasDiscount) {
        gross += singlePrice;
        vat += singleVat;
      } else {
        const original_price = Number(ticket.original_price) * ticket.qty;
        gross += original_price;
        vat += singleVat;
      }
      const isCouponDiscounted = coupon.ticket_ids.includes(ticket.ticket_id || ticket._id);
      if (isCouponDiscounted) {
        gross_discount += singlePrice * coupon.discount / 100;
        vat_discount += singleVat * coupon.discount / 100;
      }
    }
    let appliedBundleId;
    if (!coupon.discount) {
      for (const bundle of (event == null ? void 0 : event.ticket_packages) || []) {
        if (bundle.status !== "active")
          continue;
        if (bundle.type === "ticket") {
          let availableBundleAmount = Number(bundle.max_per_order || 0);
          for (const [ticketId, bundleRatio] of Object.entries(bundle.event_tickets || {})) {
            if (!availableBundleAmount)
              break;
            const ratio = Number(bundleRatio);
            const { ticket, qty } = tickets.reduce(
              (acc, ticket2) => {
                if ((ticket2.ticket_id || ticket2._id) === ticketId) {
                  acc.ticket = ticket2;
                  acc.qty += ticket2.qty;
                }
                return acc;
              },
              { ticket: void 0, qty: 0 }
            );
            if (!ticket)
              continue;
            const applicableQty = Math.min(Math.floor(qty / (ratio + 1)), availableBundleAmount);
            const ticketPrice = Number(ticket.price || ticket.original_price) * applicableQty;
            const ticketVat = Number(ticket.vat) * applicableQty;
            gross_discount += ticketPrice * Number(bundle.discount) / 100;
            vat_discount += ticketVat * Number(bundle.discount) / 100;
            if (applicableQty > 0) {
              availableBundleAmount -= applicableQty;
              appliedBundleId = bundle._id;
              break;
            }
          }
          if (appliedBundleId)
            break;
        }
        if (bundle.type === "order") {
          let isValidBundle = false;
          for (const ticketId in bundle.event_tickets) {
            const min = Number(bundle.event_tickets[ticketId]);
            if (min > 0) {
              const totalPurchasedTickets = tickets.reduce(
                (acc, ticket) => (ticket.ticket_id || ticket._id) === ticketId ? acc + ticket.qty : acc,
                0
              );
              isValidBundle = totalPurchasedTickets > 0 && totalPurchasedTickets >= min;
              if (!isValidBundle) {
                isValidBundle = false;
                break;
              }
            }
          }
          if (isValidBundle) {
            const discount = Number(bundle.discount) / 100;
            gross_discount = gross * discount;
            vat_discount = vat * discount;
            appliedBundleId = bundle._id;
            break;
          }
        }
      }
    }
    const totalFee = feeType === "order" && orderFeesIncluded ? orderFee + orderFeeVat : (ticketFee + ticketFeeVat) * totalTickets;
    const net = gross + vat + totalFee;
    const totalDiscount = gross_discount + vat_discount;
    const totalVat = vat - vat_discount;
    let net_after_discount = Math.max(0, net - totalDiscount);
    const withdrawn_saudi_rewards = Math.min(saudi_redeem_total, net_after_discount);
    net_after_discount -= withdrawn_saudi_rewards;
    const withdrawn_wallet_credits = Math.min(walletCreditsAmount, net_after_discount);
    net_after_discount -= withdrawn_wallet_credits;
    const withdrawn_subscription_credits = isSubscriptionCreditsEnabled ? net_after_discount : 0;
    net_after_discount -= withdrawn_subscription_credits;
    const appliedBundle2 = appliedBundleId ? (_a3 = event == null ? void 0 : event.ticket_packages) == null ? void 0 : _a3.find((pkg) => pkg._id === appliedBundleId) : void 0;
    return {
      gross,
      gross_after_discount: gross - gross_discount,
      totalFee,
      vat: totalVat,
      discount_total: gross_discount,
      net,
      net_after_discount,
      withdrawn_wallet_credits,
      withdrawn_saudi_rewards,
      withdrawn_subscription_credits,
      appliedBundle: appliedBundle2
    };
  }, [
    isStream,
    isSeated,
    event == null ? void 0 : event.vat_percent,
    event == null ? void 0 : event.ticket_packages,
    data.plainTickets,
    data.seatTickets.selectedTickets,
    data.subscription,
    data.merchandise,
    data.addons,
    walletData == null ? void 0 : walletData.total_balance,
    enable_wallet_credits,
    perks.discount,
    perks.vatDiscount,
    coupon.discount,
    coupon.ticket_ids,
    feeType,
    orderFeesIncluded,
    orderFee,
    orderFeeVat,
    ticketFee,
    ticketFeeVat,
    totalTickets,
    saudi_redeem_total,
    isSubscriptionCreditsEnabled
  ]), { appliedBundle } = _s, totals = __objRest(_s, ["appliedBundle"]);
  const initCheckout = (updatedUser) => __async(void 0, null, function* () {
    const currentUser = (updatedUser == null ? void 0 : updatedUser._id) ? updatedUser : user;
    const visaForm = typeof showProfile === "undefined" && event.require_visa;
    if (visaForm) {
      return setShowProfile(true);
    }
    if (data.merchandise.length > 0 && !(currentUser == null ? void 0 : currentUser.city)) {
      return setShowProfile(true);
    }
    if (isQuestionsRequired && !!(questions == null ? void 0 : questions.length) && !showQuestions) {
      return setShowQuestions(true);
    } else {
      setShowQuestions(false);
    }
    return proceedToPayment();
  });
  const proceedToPayment = () => __async(void 0, null, function* () {
    const notFree = totals.net_after_discount > 0;
    if (paymentMethod === "apple_pay" && notFree) {
      return handleApplePayPayment();
    }
    checkoutToServer();
  });
  const handleApplePayPayment = () => __async(void 0, null, function* () {
    var _a3;
    try {
      yield onApplePayPayment({ totals });
    } catch (error2) {
      const err = error2;
      setCheckoutLoading(false);
      if ((_a3 = err == null ? void 0 : err.message) == null ? void 0 : _a3.includes("JSON")) {
        return setError(new Error(t("ticketing_booking:missing_url_message")));
      }
      setError(err);
    }
  });
  function onApplePayPaymentAuthorized() {
    return __async(this, null, function* () {
      var _a3, _b3;
      const order = getCheckoutPayload();
      setError(null);
      setCheckoutLoading(true);
      return checkout({
        order,
        isSeat: ((_b3 = (_a3 = data.seatTickets) == null ? void 0 : _a3.selectedSeats) == null ? void 0 : _b3.length) > 0,
        locale,
        email: user == null ? void 0 : user.email,
        v2: !isSeated
      });
    });
  }
  function onApplePayPaymentSuccess({ order_id }) {
    push(`/${locale}/payment-success/${stringToBase64(order_id)}`);
  }
  const checkoutToServer = () => __async(void 0, null, function* () {
    var _a3;
    try {
      const order = getCheckoutPayload();
      setError(null);
      setCheckoutLoading(true);
      const orderObj = yield checkout({
        order,
        isSeason,
        isSeat: event.is_seated,
        locale,
        email: user == null ? void 0 : user.email,
        isBestAvailable: event.is_best_available_checkout,
        usePaymentApi: !!order.is_wallet || totals.net_after_discount <= 0
      });
      if (orderObj.booked_type === "free" || paymentMethod === "managed_form" && !orderObj.redirect_url) {
        push(`/${locale}/payment-success/${stringToBase64(orderObj.order_id)}`);
        return;
      }
      if (!orderObj.redirect_url) {
        throw new Exception({
          error: new Error(t("ticketing_booking:missing_url_message")),
          name: "CheckoutNoRedirectUrlException"
        });
      }
      const search = window.location.search || "";
      createCookie({
        name: "last_book_page",
        value: removeBaseUrl(window.location.pathname + search, baseUrl),
        expiration: 0.01
      });
      window.location.href = orderObj.redirect_url;
    } catch (error2) {
      const err = error2;
      setCheckoutLoading(false);
      if ((_a3 = err == null ? void 0 : err.message) == null ? void 0 : _a3.includes("JSON")) {
        return setError(new Error(t("ticketing_booking:missing_url_message")));
      }
      setError(err);
    }
  });
  const getCheckoutPayload = () => {
    var _a3, _b3;
    const timeSlot = data.time_slots ? (_b3 = (_a3 = Object.values(data.time_slots)) == null ? void 0 : _a3[0]) == null ? void 0 : _b3[0] : null;
    const time_slot_id = timeSlot == null ? void 0 : timeSlot._id;
    let order = {
      event_id: event == null ? void 0 : event._id,
      redirect: window.origin + addBaseUrl(`/${locale}/payment-success`, baseUrl),
      redirect_failed: window.origin + addBaseUrl(`/${locale}/payment-failed`, baseUrl),
      booking_source: bookingSource,
      lang: locale,
      payment_method: paymentMethod,
      time_slot_id,
      is_wallet: enable_wallet_credits,
      saudi_redeem,
      is_mada: cardType === "mada",
      is_amex: cardType === "amex"
    };
    if (methods.getValues("payment_token")) {
      order.payment_token = methods.getValues("payment_token");
    }
    if (isQuestionsRequired) {
      order.questions = methods.getValues("questions");
    }
    if (isSeason) {
      order.season_id = event == null ? void 0 : event._id;
    }
    if (event == null ? void 0 : event.has_consent) {
      order.consent = methods.getValues("acceptedTerms.consent");
    }
    order.perks = perks.appliedPerks.map(({ perk, ticketsQty }) => ({
      id: perk._id,
      tickets: Object.entries(ticketsQty).map(([ticketId, qty]) => ({
        qty,
        id: ticketId
      }))
    }));
    order.merchandise = data.merchandise.map((item) => {
      var _a4;
      return { product_id: ((_a4 = item.variation) == null ? void 0 : _a4.ID) || item.product.ID, quantity: item.qty };
    });
    order.addons = data.addons.map((addon) => {
      return { id: addon._id, qty: addon.qty };
    });
    if (data.subscription) {
      order.subscription_plan_id = data.subscription.plan._id;
    }
    const jeresy = methods.getValues().jeresy;
    if (!isSeated || isStream) {
      order.tickets = [];
      for (const t2 of data.plainTickets) {
        const perkQty = perks.totalPerksPerTicket[t2._id] || 0;
        const item = {
          qty: Math.max(0, t2.qty - perkQty),
          id: t2._id,
          jersey: jeresy == null ? void 0 : jeresy[t2._id]
        };
        if (item.qty > 0) {
          order.tickets.push(item);
        }
      }
    } else {
      const perkedSeats = __spreadValues({}, perks.totalPerksPerTicket);
      const seatsWithPerks = data.seatTickets.selectedSeats.map((s) => {
        var _a4;
        const isPerked = perkedSeats[s.id] > 0;
        const qty = s.numSelected || 1;
        if (isPerked) {
          const perkId = (_a4 = perks.appliedPerks.find((p) => p.ticketsQty[s.id])) == null ? void 0 : _a4.perk._id;
          if (perkId) {
            perkedSeats[s.id] -= Math.max(0, qty);
            s.perkId = perkId;
          }
        }
        return __spreadProps(__spreadValues({}, s), {
          jersey: jeresy == null ? void 0 : jeresy[s.uuid]
        });
      });
      order = __spreadProps(__spreadValues({}, order), {
        holdToken: data.seatTickets.holdToken,
        selectedSeats: JSON.stringify(seatsWithPerks),
        event_id: event == null ? void 0 : event._id,
        season_id: event == null ? void 0 : event._id
      });
    }
    if (coupon.promo_code) {
      order.promo_code = coupon.promo_code;
    }
    beginCheckout({
      items: isSeated ? data.seatTickets.selectedTickets : data.plainTickets,
      coupon,
      event: parseEventToAnalyticsEvent(event)
    });
    return order;
  };
  const hasTicketErrors = useMemo(() => {
    return !!data.ticket_errors && Object.values(data.ticket_errors).filter(Boolean).length > 0;
  }, [data.ticket_errors]);
  const paymentAmountLimit = totals.net_after_discount <= MAX_PAYMENT_AMOUNT;
  const disabledCheckout = !methods.formState.isValid || hasTicketErrors || !paymentAmountLimit || !data.plainTickets.length && !data.seatTickets.selectedSeats.length || !isValid;
  return /* @__PURE__ */ jsxs2(
    context_default.Provider,
    {
      value: __spreadProps(__spreadValues({}, data), {
        user,
        eventTickets,
        appliedBundle,
        userPerks: perks.userPerks,
        appliedPerks: perks.appliedPerks,
        totals,
        totalTickets,
        isSeated,
        addPlain,
        replacePlain,
        removePlain,
        addSeat,
        removeSeat,
        onSeatsInitialized,
        setChart,
        setCheckoutMode,
        removeAllSeats,
        clearAll,
        addAddon,
        removeAddon,
        setTicketErrors,
        selectSlot,
        setSlotState,
        checkout: () => initCheckout(),
        setFavoriteTeam,
        checkoutLoading,
        hasTicketErrors,
        checkoutError: error || paymentError,
        canCheckout: !disabledCheckout,
        subscriptionBookingLimit,
        limits,
        addMerchandiseProduct,
        removeMerchandiseProduct,
        setSubscription
      }),
      children: [
        /* @__PURE__ */ jsx3(
          ProfileCheckPoint,
          {
            show: !!showProfile,
            onClose: () => {
              setCheckoutLoading(false);
              setShowProfile(void 0);
            },
            onSuccess: (user2) => {
              setShowProfile(false);
              initCheckout(user2);
            },
            showVisaCheckbox: !!event.require_visa
          }
        ),
        /* @__PURE__ */ jsxs2(FormProvider, __spreadProps(__spreadValues({}, methods), { children: [
          /* @__PURE__ */ jsx3(
            QuestionsModal_default,
            {
              questions: questions || [],
              open: !!showQuestions,
              onClose: () => {
                setCheckoutLoading(false);
                setShowQuestions(false);
              }
            }
          ),
          children
        ] }))
      ]
    }
  );
};
var provider_default = BookingProvider;

// src/components/booking/countdown/CountdownSection.tsx
import { useCallback, useEffect as useEffect3, useMemo as useMemo3 } from "react";
import { formatDate as formatDate2 } from "@wbk/utils";
import { useCountDown, useDeviceDetect } from "@wbk/hooks";
import { useRouter as useRouter3, useTranslation as useTranslation4 } from "@wbk/config";
import { usePayment as usePayment2 } from "@wbk/payment";

// src/components/booking/summary/TimeSlotRange.tsx
import { useMemo as useMemo2 } from "react";
import { formatDate } from "@wbk/utils";
import { useRouter as useRouter2 } from "@wbk/config";
var TimeSlotRange = () => {
  const { locale } = useRouter2();
  const { time_slots } = useBooking_default();
  const fromTo = useMemo2(() => {
    var _a, _b, _c, _d;
    if (time_slots) {
      const slot = (_b = (_a = Object.values(time_slots)) == null ? void 0 : _a[0]) == null ? void 0 : _b[0];
      const from = (_c = slot == null ? void 0 : slot.time_from) == null ? void 0 : _c.split(" ");
      const to = (_d = slot == null ? void 0 : slot.time_to) == null ? void 0 : _d.split(" ");
      if (slot) {
        return ` | ${from[1] || from[0]} - ${to[1] || to[0]}`;
      }
    }
    return "";
  }, [time_slots]);
  if (time_slots) {
    return `${formatDate(Object.keys(time_slots)[0], `${locale}-GB`, {
      dateStyle: "medium",
      timeZone: void 0
    })}${fromTo}`;
  }
  return null;
};
var TimeSlotRange_default = TimeSlotRange;

// src/components/booking/countdown/CountdownSection.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var CountdownSection = () => {
  const {
    event,
    checkoutMode,
    time_slots,
    setCheckoutMode,
    clearAll,
    seatTickets,
    sessionEnd,
    setSubscription,
    isSeated
  } = useBooking_default();
  const { baseUrl } = useRouter3();
  const { replace } = useRouter3();
  const { isWebView } = useDeviceDetect();
  const { t } = useTranslation4(["ticketing_common", "ticketing_booking"]);
  const { count, set, stop } = useCountDown({
    id: "booking-count-down",
    initialSeconds: (sessionEnd - Date.now()) / 1e3
  });
  const { setSaudiRedeem, saudi_redeem } = usePayment2();
  const withTimeSlots = !!event.time_slots;
  useEffect3(() => {
    if (isSeated && seatTickets.expiresInSeconds) {
      set(seatTickets.expiresInSeconds);
    }
  }, [isSeated, seatTickets.expiresInSeconds]);
  useEffect3(() => {
    const endAt = sessionEnd;
    const isPast = Date.now() > endAt;
    const shouldReload = count <= 0 || isPast;
    if (shouldReload) {
      stop();
      window.location.reload();
    }
  }, [count]);
  const timerValue = useMemo3(() => {
    const current = Date.now() / 1e3;
    const future = current + count;
    const diff = future - current;
    return formatDate2(diff, "en", {
      minute: "2-digit",
      second: "2-digit"
    });
  }, [count]);
  const backText = useMemo3(() => {
    if (checkoutMode === "summary") {
      const text = isSeated ? "change_seats" : "change_tickets";
      return t(`ticketing_booking:${text}`);
    }
    if (time_slots && checkoutMode === "tickets") {
      return /* @__PURE__ */ jsx4(TimeSlotRange_default, {});
    }
    return t("ticketing_common:back");
  }, [checkoutMode, time_slots, t, isSeated]);
  const clearSaudiRewardsRedeem = () => {
    if (saudi_redeem) {
      setSaudiRedeem(__spreadProps(__spreadValues({}, saudi_redeem), { quantity: 0 }));
    }
  };
  const handleGoBack = useCallback(() => {
    var _a, _b;
    if (checkoutMode === "addons") {
      setCheckoutMode("tickets");
      clearSaudiRewardsRedeem();
      return;
    } else if (checkoutMode === "summary") {
      const toAddons = !!((_a = event == null ? void 0 : event.webook_authors) == null ? void 0 : _a.length);
      setCheckoutMode(toAddons ? "addons" : "tickets");
      if (!toAddons) {
        setSubscription(void 0);
        clearSaudiRewardsRedeem();
      }
      return;
    } else if (time_slots) {
      setCheckoutMode("calendar");
      clearAll();
      return;
    }
    if (isWebView) {
      return (_b = window.ReactNativeWebView) == null ? void 0 : _b.postMessage(
        JSON.stringify({
          eventName: "CLOSE_WEBVIEW"
        })
      );
    }
    const pathname = removeBaseUrl(window.location.pathname, baseUrl);
    const previousPath = pathname.split("/").slice(0, -1).join("/") || "/";
    replace(previousPath);
  }, [checkoutMode, withTimeSlots, isWebView, clearAll]);
  return /* @__PURE__ */ jsxs3("section", { className: "bg-body container sticky top-0 z-30 flex max-w-screen-2xl items-center justify-between py-2 lg:relative", children: [
    /* @__PURE__ */ jsx4(Back_default, { text: backText, onClick: handleGoBack }),
    /* @__PURE__ */ jsx4("div", { className: "shrink-0 text-xs", children: count <= 0 ? t("ticketing_booking:time_out") : t("ticketing_booking:time_left", { time: timerValue }) })
  ] });
};
var CountdownSection_default = CountdownSection;

// src/components/booking/Booking.tsx
import { useDeviceDetect as useDeviceDetect5 } from "@wbk/hooks";
import { Divider } from "@wbk/ui";

// src/components/booking/BookingFooter.tsx
import { Button as Button6, FixedBar, Typography as Typography4 } from "@wbk/ui";
import { useFormContext as useFormContext3 } from "react-hook-form";
import { scrollToTop as scrollToTop2 } from "@wbk/utils";
import { ShieldIcon, SubscriptionIcon } from "@wbk/svg";
import { useTranslation as useTranslation11 } from "@wbk/config";

// src/components/booking/summary/ProceedButton.tsx
import { ApplePayIcon, LockIcon, StcPayIcon } from "@wbk/svg";
import { Button } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { usePayment as usePayment3 } from "@wbk/payment";
import { useTranslation as useTranslation5 } from "@wbk/config";
import { Fragment, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var ProceedToPaymentButton = ({ className }) => {
  const { t } = useTranslation5("ticketing_booking");
  const { event, totals, checkoutLoading, canCheckout } = useBooking_default();
  const { paymentMethod } = usePayment3();
  const inlinePaytabs = paymentMethod === "managed_form";
  if (paymentMethod === "apple_pay" && totals.net_after_discount > 0) {
    return /* @__PURE__ */ jsxs4(
      Button,
      {
        theme: "action",
        type: "submit",
        form: "ticket-checkout-form",
        id: "proceed-to-payment",
        className: twMerge(
          "w-full items-center py-3 font-semibold leading-none",
          "data-[disabled=true]:!bg-input-disabled data-[disabled=true]:!text-text-disabled",
          className
        ),
        loading: checkoutLoading,
        "data-disabled": !canCheckout,
        children: [
          t("ticketing_booking:pay_with"),
          /* @__PURE__ */ jsx5(ApplePayIcon, { className: "h-8 w-11" })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx5(
    Button,
    {
      loading: checkoutLoading,
      className: twMerge(
        "w-full gap-2 py-3 text-center font-semibold data-[benefit=true]:enabled:bg-[#ED0E34] data-[stc=true]:enabled:bg-[#4F008F]",
        "data-[disabled=true]:!bg-input-disabled data-[disabled=true]:!text-text-disabled",
        className
      ),
      form: inlinePaytabs ? "paytabs-form" : "ticket-checkout-form",
      type: "submit",
      id: "proceed-to-payment",
      "data-testid": "ticketing_summary_proceed_to_payment",
      "data-benefit": paymentMethod === "benefit",
      "data-stc": paymentMethod === "stc",
      "data-event-name": event == null ? void 0 : event.title,
      "data-event-venue": event == null ? void 0 : event.venue_name,
      "data-disabled": !canCheckout,
      children: paymentMethod === "benefit" ? /* @__PURE__ */ jsxs4(Fragment, { children: [
        /* @__PURE__ */ jsx5(
          "img",
          {
            src: "/@wbk/payment/benefit_pay.png",
            className: "xs:inline hidden h-5 w-5 shrink-0",
            alt: t("payment_common:benefit")
          }
        ),
        /* @__PURE__ */ jsxs4("span", { className: "whitespace-nowrap", children: [
          t("ticketing_booking:pay_with"),
          " ",
          t("payment_common:benefit")
        ] })
      ] }) : paymentMethod === "stc" ? /* @__PURE__ */ jsxs4(Fragment, { children: [
        /* @__PURE__ */ jsx5(StcPayIcon, { className: "xs:inline hidden h-8 w-8 shrink-0", white: true }),
        /* @__PURE__ */ jsxs4("span", { className: "whitespace-nowrap", children: [
          t("ticketing_booking:pay_with"),
          " ",
          t("payment_common:stc_pay")
        ] })
      ] }) : totals.net_after_discount > 0 && !inlinePaytabs ? /* @__PURE__ */ jsxs4(Fragment, { children: [
        /* @__PURE__ */ jsx5(LockIcon, { className: `h-4 w-4 pb-0.5 ${!canCheckout ? "grayscale" : ""}` }),
        /* @__PURE__ */ jsx5("span", { className: "whitespace-nowrap", children: t("ticketing_booking:proceed") })
      ] }) : /* @__PURE__ */ jsx5("span", { className: "whitespace-nowrap", children: t("ticketing_booking:confirm_booking") })
    }
  );
};
var ProceedButton_default = ProceedToPaymentButton;

// src/components/booking/tickets/FooterAction.tsx
import { useEffect as useEffect4, useMemo as useMemo4, useState as useState2 } from "react";
import { Button as Button3 } from "@wbk/ui";
import { scrollToTop } from "@wbk/utils";
import { TicketBookingLimitsTrigger } from "@wbk/subscription";
import { useTranslation as useTranslation7 } from "@wbk/config";

// src/components/booking/tickets/ZoneEntryModal.tsx
import { useTranslation as useTranslation6 } from "@wbk/config";
import { useDeviceDetect as useDeviceDetect2 } from "@wbk/hooks";
import { ExclamationTriangleIcon } from "@wbk/svg";
import { BottomSheet, Button as Button2, ImageWithFallback, Modal, Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var ZoneEntryModal = ({ render, onProceed }) => {
  const { isMobile } = useDeviceDetect2();
  const { event } = useBooking_default();
  const { t } = useTranslation6(["ticketing_booking"]);
  const body = /* @__PURE__ */ jsxs5("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsx6(ExclamationTriangleIcon, { className: "h-16 w-16" }),
    /* @__PURE__ */ jsx6(Typography2, { as: "h2", variant: "heading-M", children: t("ticketing_booking:zone_entry.title") }),
    event.zone && /* @__PURE__ */ jsxs5("div", { className: "gap-S flex items-center", children: [
      /* @__PURE__ */ jsx6(
        ImageWithFallback,
        {
          src: event.zone.logo,
          alt: "Zone Entry",
          width: 48,
          height: 48,
          className: "h-12 w-12"
        }
      ),
      /* @__PURE__ */ jsx6(Typography2, { as: "span", variant: "label-M", children: event.zone.title })
    ] }),
    /* @__PURE__ */ jsx6(Typography2, { variant: "label-M", children: t("ticketing_booking:zone_entry.description") })
  ] });
  const footer = ({ close }) => {
    return /* @__PURE__ */ jsxs5("div", { className: "gap-M px-L py-M flex flex-col md:flex-row-reverse", children: [
      /* @__PURE__ */ jsx6(
        Button2,
        {
          className: "h-12",
          theme: "action",
          onClick: () => {
            close();
            onProceed();
          },
          children: t("ticketing_booking:zone_entry.proceed")
        }
      ),
      /* @__PURE__ */ jsx6(Button2, { className: "h-12", theme: "action", shape: "text", onClick: close, children: t("ticketing_booking:zone_entry.back") })
    ] });
  };
  return isMobile ? /* @__PURE__ */ jsx6(
    BottomSheet,
    {
      render,
      body: () => body,
      stickyFooter: footer,
      sectionClassName: "p-6 pb-44",
      className: "z-[100]"
    }
  ) : /* @__PURE__ */ jsx6(
    Modal,
    {
      render,
      body: () => body,
      stickyFooter: footer,
      className: "p-6 pb-28",
      size: "2xl"
    }
  );
};
var ZoneEntryModal_default = ZoneEntryModal;

// src/components/booking/tickets/FooterAction.tsx
import { Fragment as Fragment2, jsx as jsx7 } from "react/jsx-runtime";
var TicketsFooterAction = () => {
  var _a;
  const [showTickets, setShowTickets] = useState2(false);
  const {
    event,
    setCheckoutMode,
    totalTickets,
    subscriptionBookingLimit,
    setSubscription,
    plainTickets,
    seatTickets,
    isSeated,
    hasTicketErrors
  } = useBooking_default();
  const { t } = useTranslation7(["ticketing_booking", "subscription_common"]);
  const hasMerchandise = !!((_a = event.webook_authors) == null ? void 0 : _a.length) || !!event.has_addons;
  const mustHavePlan = subscriptionBookingLimit.mustUpgradeToPlans.mustHavePlan;
  const mustUpgrade = subscriptionBookingLimit.mustUpgradeToPlans.shouldUpgrade;
  const showUpgrade = (mustUpgrade || mustHavePlan) && totalTickets > 0;
  const showZoneEntryModal = useMemo4(() => {
    const requireEntry = isSeated ? seatTickets.selectedTickets.some((ticket) => ticket.requires_entry_ticket) : plainTickets.some((ticket) => ticket.requires_entry_ticket);
    return !!event.zone && requireEntry;
  }, [isSeated, event.zone, plainTickets, seatTickets.selectedTickets]);
  useEffect4(() => {
    if (showTickets && totalTickets <= 0) {
      setShowTickets(false);
    }
  }, [showTickets, totalTickets]);
  const handleNext = () => {
    setCheckoutMode(hasMerchandise ? "addons" : "summary");
    setTimeout(scrollToTop, 0);
  };
  const tickets = useMemo4(() => {
    var _a2;
    const ticks = isSeated ? seatTickets.selectedTickets : plainTickets;
    const grouped = {};
    for (const ticket of ticks) {
      if (grouped[ticket.ticket_id || ticket._id]) {
        grouped[ticket.ticket_id || ticket._id].qty += ticket.qty;
      } else {
        grouped[ticket.ticket_id || ticket._id] = {
          title: ((_a2 = ticket.subscription_ticket_type) == null ? void 0 : _a2.title) || ticket.title,
          qty: ticket.qty
        };
      }
    }
    return Object.values(grouped);
  }, [isSeated, plainTickets, seatTickets.selectedTickets]);
  return /* @__PURE__ */ jsx7(Fragment2, { children: showUpgrade ? /* @__PURE__ */ jsx7(
    TicketBookingLimitsTrigger,
    {
      className: "h-12 w-full",
      selectedTickets: tickets,
      ticketBenefits: subscriptionBookingLimit,
      event,
      onSelect: (data) => {
        setSubscription(data);
        handleNext();
      }
    }
  ) : /* @__PURE__ */ jsx7(
    ZoneEntryModal_default,
    {
      onProceed: handleNext,
      render: ({ open }) => /* @__PURE__ */ jsx7(
        Button3,
        {
          theme: "action",
          className: "h-12 w-full",
          onClick: () => {
            if (showZoneEntryModal) {
              return open();
            }
            handleNext();
          },
          disabled: !totalTickets || hasTicketErrors,
          "data-testid": "ticketing_tickets_go_to_summary_button",
          children: /* @__PURE__ */ jsx7("p", { className: "line-clamp-1 font-semibold", children: hasMerchandise ? t("ticketing_booking:next_addons") : t("ticketing_booking:next_payment") })
        }
      )
    }
  ) });
};
var FooterAction_default = TicketsFooterAction;

// src/components/booking/tickets/TicketsSummaryMenu.tsx
import { useState as useState3 } from "react";
import { Button as Button4, Popover } from "@wbk/ui";
import { motion } from "motion/react";
import { CloseIcon, FlatTicketIcon } from "@wbk/svg";
import { CurrencyPriceLabel as CurrencyPriceLabel2 } from "@wbk/currency";
import { TotalFees } from "@wbk/payment";
import { useTranslation as useTranslation9 } from "@wbk/config";

// src/components/booking/tickets/TicketSummaryRow.tsx
import { Fragment as Fragment3 } from "react";
import { Controller as Controller2, useFormContext as useFormContext2 } from "react-hook-form";
import { Input as Input2, Menu } from "@wbk/ui";
import { addVatToPrice } from "@wbk/utils";
import { CurrencyPriceLabel } from "@wbk/currency";
import { usePayment as usePayment4 } from "@wbk/payment";
import { useTranslation as useTranslation8 } from "@wbk/config";
import { Fragment as Fragment4, jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var TicketSummaryRow = ({ ticket, isSeated, hideExtras }) => {
  const { event, ticket_errors } = useBooking_default();
  const { coupon } = usePayment4();
  const { t } = useTranslation8(["ticketing_common", "ticketing_booking"]);
  const {
    control,
    formState: { errors }
  } = useFormContext2();
  const hasDiscount = ticket.price !== ticket.original_price;
  const hasCoupon = coupon.ticket_ids.includes((ticket == null ? void 0 : ticket._id) || "");
  const isAffectedByDiscount = hasDiscount || hasCoupon;
  const hasMerch = ticket.has_merch === "true";
  const hasName = ticket.has_name === "true";
  const totalMerches = Array.from({ length: ticket.qty });
  const originalPrice = addVatToPrice(ticket.originalPriceWithFee, +(event == null ? void 0 : event.vat_percent));
  const price = Number(ticket.priceWithFee) + Number(ticket.vatWithFee);
  const netTotal = price - price * (coupon.discount / 100);
  const ticketError = (ticket_errors == null ? void 0 : ticket_errors[ticket.seats_io_category || ""]) || (ticket_errors == null ? void 0 : ticket_errors[ticket._id]);
  return /* @__PURE__ */ jsxs6(Fragment3, { children: [
    /* @__PURE__ */ jsxs6("li", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsxs6("div", { className: "flex grow items-center gap-1 text-xs sm:gap-2 md:text-sm", children: [
        /* @__PURE__ */ jsx8("span", { className: "min-w-3 shrink-0", children: ticket.qty }),
        /* @__PURE__ */ jsx8("span", { children: "x" }),
        /* @__PURE__ */ jsx8(
          "div",
          {
            className: "flex h-5 w-5 shrink-0 items-center justify-center rounded p-1 text-[11px]",
            style: { background: ticket.ticket_color, color: ticket.text_color },
            children: (ticket == null ? void 0 : ticket.shortcode) || ticket.title.slice(0, 2).toUpperCase()
          }
        ),
        /* @__PURE__ */ jsxs6("div", { children: [
          /* @__PURE__ */ jsx8("div", { className: "inline-block gap-1 text-xs md:text-sm", children: /* @__PURE__ */ jsxs6("p", { children: [
            /* @__PURE__ */ jsx8("span", { className: "ltr:mr-1 rtl:ml-1", children: ticket.title }),
            isSeated && ticket.labels && /* @__PURE__ */ jsx8(Fragment4, { children: /* @__PURE__ */ jsx8("span", { children: ticket.labels.section ? `(${t("ticketing_booking:section")}: ${ticket.labels.section || "-"} - ${t("ticketing_booking:seat")}: ${ticket.labels.own || "-"})` : `- ${ticket.labels.own || " "}` }) })
          ] }) }),
          !!ticketError && /* @__PURE__ */ jsx8("p", { className: "text-error text-xs", children: ticketError })
        ] })
      ] }),
      /* @__PURE__ */ jsxs6("div", { className: "text-end", children: [
        /* @__PURE__ */ jsx8("div", { className: isAffectedByDiscount ? "text-xs line-through opacity-60" : "font-bold", children: /* @__PURE__ */ jsx8(
          CurrencyPriceLabel,
          {
            className: "text-xs font-normal md:text-sm",
            originalPrice: isAffectedByDiscount ? originalPrice : price,
            currency: ticket.currency,
            zeroAsFree: true
          }
        ) }),
        isAffectedByDiscount ? /* @__PURE__ */ jsx8(
          CurrencyPriceLabel,
          {
            originalPrice: netTotal,
            currency: ticket.currency,
            className: "text-xs font-normal md:text-sm",
            zeroAsFree: true
          }
        ) : null
      ] })
    ] }),
    !hideExtras && /* @__PURE__ */ jsx8("li", { className: "space-y-2", children: (hasMerch || hasName) && totalMerches.map((_, index) => {
      const id = isSeated ? ticket == null ? void 0 : ticket.uuid : ticket._id;
      return /* @__PURE__ */ jsxs6(Fragment3, { children: [
        hasName && /* @__PURE__ */ jsxs6("div", { className: "flex gap-2", children: [
          /* @__PURE__ */ jsx8(
            Controller2,
            {
              name: `jeresy.${id}.[${index}].fan_firstname`,
              control,
              rules: {
                required: t("ticketing_common:validation.required"),
                maxLength: {
                  value: 25,
                  message: t("ticketing_common:validation.max_length", { max: 25 })
                }
              },
              render: ({ field }) => {
                var _a, _b, _c, _d;
                return /* @__PURE__ */ jsx8(
                  Input2,
                  __spreadProps(__spreadValues({}, field), {
                    value: field.value || "",
                    placeholder: t("ticketing_common:auth.first_name"),
                    groupClassName: "grow",
                    className: "p-2 text-sm",
                    error: (_d = (_c = (_b = (_a = errors == null ? void 0 : errors.jeresy) == null ? void 0 : _a[id]) == null ? void 0 : _b[index]) == null ? void 0 : _c.fan_firstname) == null ? void 0 : _d.message
                  })
                );
              }
            }
          ),
          /* @__PURE__ */ jsx8(
            Controller2,
            {
              name: `jeresy.${id}.[${index}].fan_lastname`,
              control,
              rules: {
                required: t("ticketing_common:validation.required"),
                maxLength: {
                  value: 25,
                  message: t("ticketing_common:validation.max_length", { max: 25 })
                }
              },
              render: ({ field }) => {
                var _a, _b, _c, _d;
                return /* @__PURE__ */ jsx8(
                  Input2,
                  __spreadProps(__spreadValues({}, field), {
                    value: field.value || "",
                    placeholder: t("ticketing_common:auth.last_name"),
                    groupClassName: "grow",
                    className: "p-2 text-sm",
                    error: (_d = (_c = (_b = (_a = errors == null ? void 0 : errors.jeresy) == null ? void 0 : _a[id]) == null ? void 0 : _b[index]) == null ? void 0 : _c.fan_lastname) == null ? void 0 : _d.message
                  })
                );
              }
            }
          )
        ] }),
        hasMerch && /* @__PURE__ */ jsxs6("div", { className: "relative flex items-baseline justify-between", children: [
          /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx8("div", { className: "border-input-border -mt-4 h-6 w-6 border-b border-dashed ltr:ml-2 ltr:border-l rtl:mr-2 rtl:border-r" }),
            /* @__PURE__ */ jsx8("svg", { width: "18", height: "18", viewBox: "0 0 17 17", fill: "none", children: /* @__PURE__ */ jsx8(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.2768 3.61352C11.0144 4.42197 9.87093 5.03051 8.50001 5.03051C7.12908 5.03051 5.98556 4.42197 5.72324 3.61352H4.98713C4.93815 3.60804 4.8884 3.60795 4.83883 3.61352H4.83334C4.63218 3.61352 4.45182 3.70261 4.32959 3.8435L1.44087 5.5113C1.12201 5.6954 1.01275 6.10312 1.19685 6.42199L2.30102 8.33446C2.48511 8.65332 2.89284 8.76257 3.2117 8.57847L4.16667 8.02712V14.2802C4.16667 14.6484 4.46515 14.9468 4.83334 14.9468H12.1667C12.5349 14.9468 12.8333 14.6484 12.8333 14.2802V8.02637L13.7896 8.57847C14.1085 8.76257 14.5162 8.65332 14.7003 8.33446L15.8045 6.42199C15.9886 6.10312 15.8793 5.6954 15.5604 5.5113L12.6691 3.84198C12.5469 3.70198 12.3671 3.61352 12.1667 3.61352H12.1625C12.1129 3.60795 12.0632 3.60804 12.0142 3.61352H11.2768Z",
                fill: ticket.ticket_color || "currentColor"
              }
            ) }),
            /* @__PURE__ */ jsx8("span", { className: "text-sm", children: t("ticketing_booking:jersey_gift") })
          ] }),
          /* @__PURE__ */ jsx8(
            Controller2,
            {
              name: `jeresy.${id}.[${index}].merch_size`,
              control,
              rules: { required: t("ticketing_common:validation.required") },
              render: ({ field }) => {
                var _a, _b, _c, _d;
                return /* @__PURE__ */ jsx8(
                  Menu,
                  __spreadProps(__spreadValues({
                    trigger: {
                      className: "p-0.5",
                      placeholder: t("ticketing_booking:select_size")
                    }
                  }, field), {
                    onChange: (selected) => {
                      field.onChange(selected.value);
                    },
                    options: ["S", "M", "L", "XL", "XXL"].map((size) => ({
                      text: /* @__PURE__ */ jsx8("p", { className: "min-w-14 text-center", children: size }),
                      value: size
                    })),
                    error: (_d = (_c = (_b = (_a = errors == null ? void 0 : errors.jeresy) == null ? void 0 : _a[id]) == null ? void 0 : _b[index]) == null ? void 0 : _c.merch_size) == null ? void 0 : _d.message
                  })
                );
              }
            }
          )
        ] })
      ] }, index);
    }) })
  ] });
};
var TicketSummaryRow_default = TicketSummaryRow;

// src/components/booking/tickets/TicketsSummaryMenu.tsx
import { Fragment as Fragment5, jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var TicketsSummaryMenu = () => {
  const [showTickets, setShowTickets] = useState3(false);
  const { plainTickets, seatTickets, totals, event, totalTickets, checkoutMode, isSeated } = useBooking_default();
  const { t } = useTranslation9(["ticketing_common", "ticketing_booking", "subscription_common"]);
  const showModes = ["tickets", "addons", "summary"];
  if (!showModes.includes(checkoutMode))
    return /* @__PURE__ */ jsx9("div", {});
  const Content = /* @__PURE__ */ jsxs7(
    "div",
    {
      "data-disabled": totalTickets <= 0,
      className: "data-[disabled=true]:text-text-secondary line-clamp-2 flex items-center gap-2 text-start",
      children: [
        /* @__PURE__ */ jsx9(FlatTicketIcon, { className: "hidden h-8 w-8 md:block" }),
        totalTickets > 0 ? /* @__PURE__ */ jsxs7("div", { children: [
          /* @__PURE__ */ jsx9("p", { className: "flex items-center gap-1 text-xs", children: t("ticketing_common:tickets_total", { count: totalTickets }) }),
          /* @__PURE__ */ jsx9(
            CurrencyPriceLabel2,
            {
              originalPrice: totals.net_after_discount,
              currency: event == null ? void 0 : event.currency,
              zeroAsFree: true,
              className: "text-sm font-semibold"
            }
          )
        ] }) : /* @__PURE__ */ jsx9("p", { className: "text-xs md:text-sm", children: t("ticketing_booking:select_ticket_continue") })
      ]
    }
  );
  return /* @__PURE__ */ jsxs7(Fragment5, { children: [
    /* @__PURE__ */ jsx9("div", { className: "hidden lg:block", children: Content }),
    /* @__PURE__ */ jsx9(
      Popover,
      {
        className: "bg-body/10 relative z-[99] mb-3 flex h-screen w-screen items-end backdrop-blur-sm [&>div]:p-0",
        align: "start",
        open: showTickets && totalTickets > 0,
        onOpenChange: (e) => setShowTickets(e),
        onClick: () => setShowTickets(false),
        content: /* @__PURE__ */ jsxs7(
          motion.div,
          {
            className: "bg-body relative z-50 mx-auto w-full overflow-hidden",
            initial: { height: 0 },
            animate: { height: showTickets ? "auto" : 0 },
            onClick: (e) => e.stopPropagation(),
            children: [
              /* @__PURE__ */ jsx9("div", { className: "flex justify-end p-1", children: /* @__PURE__ */ jsx9(
                "button",
                {
                  className: "m-1 flex items-center justify-center rounded-full p-2 font-bold",
                  onClick: () => setShowTickets(false),
                  "aria-label": "Close Tickets Summary",
                  children: /* @__PURE__ */ jsx9(CloseIcon, { className: "h-3 w-3" })
                }
              ) }),
              /* @__PURE__ */ jsx9(
                "ul",
                {
                  className: "h-full max-h-[calc(100vh-260px)] space-y-1 overflow-y-auto px-2 pt-2",
                  id: "event-tickets-popover",
                  children: isSeated ? seatTickets.selectedTickets.map((ticket, idx) => /* @__PURE__ */ jsx9(TicketSummaryRow_default, { ticket, isSeated: true, hideExtras: true }, ticket._id + idx)) : plainTickets.map((ticket, idx) => /* @__PURE__ */ jsx9(TicketSummaryRow_default, { ticket, hideExtras: true }, idx))
                }
              ),
              /* @__PURE__ */ jsx9("hr", { className: "border-body-level-2 my-4 border-dashed" }),
              /* @__PURE__ */ jsxs7("div", { className: "space-y-1 px-2 pb-2", children: [
                /* @__PURE__ */ jsxs7("div", { className: "flex items-center justify-between text-xs", children: [
                  /* @__PURE__ */ jsx9("p", { children: t("ticketing_booking:subtotal") }),
                  /* @__PURE__ */ jsx9(
                    CurrencyPriceLabel2,
                    {
                      zeroAsFree: true,
                      originalPrice: totals.gross,
                      discountPrice: totals.gross_after_discount,
                      currency: event == null ? void 0 : event.currency
                    }
                  )
                ] }),
                (event == null ? void 0 : event.fees) && totals.totalFee > 0 && /* @__PURE__ */ jsx9(
                  TotalFees,
                  {
                    title: event.fees.title,
                    description: event.fees.description,
                    amount: totals.totalFee,
                    currency: event == null ? void 0 : event.currency
                  }
                ),
                /* @__PURE__ */ jsxs7("div", { className: "flex items-center justify-between text-xs", children: [
                  /* @__PURE__ */ jsx9("p", { children: `${t("ticketing_booking:vat")} ${(event == null ? void 0 : event.vat_percent) ? `${event == null ? void 0 : event.vat_percent}%` : ""}` }),
                  /* @__PURE__ */ jsx9(
                    CurrencyPriceLabel2,
                    {
                      originalPrice: totals.vat,
                      currency: event == null ? void 0 : event.currency,
                      zeroAsFree: true
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs7("div", { className: "flex flex-wrap items-center justify-between font-semibold", children: [
                  /* @__PURE__ */ jsx9("p", { children: t("ticketing_booking:total") }),
                  /* @__PURE__ */ jsx9(
                    CurrencyPriceLabel2,
                    {
                      originalPrice: totals.net,
                      discountPrice: totals.net_after_discount,
                      currency: event == null ? void 0 : event.currency,
                      zeroAsFree: true
                    }
                  )
                ] })
              ] })
            ]
          }
        ),
        children: /* @__PURE__ */ jsx9("div", { className: "w-full flex-1 grow lg:hidden", children: /* @__PURE__ */ jsx9(
          Button4,
          {
            theme: "transparent",
            shape: "text",
            disabled: totalTickets <= 0,
            className: "h-12 w-full p-1 text-start enabled:shrink-0 disabled:bg-transparent lg:p-2",
            children: /* @__PURE__ */ jsxs7("div", { className: "flex w-full items-center justify-between gap-2", children: [
              Content,
              /* @__PURE__ */ jsx9(
                "svg",
                {
                  width: "10",
                  height: "7",
                  "data-hide": !showTickets,
                  "data-invisible": totalTickets <= 0,
                  className: "shrink-0 transition data-[invisible=true]:invisible data-[hide=true]:rotate-180",
                  children: /* @__PURE__ */ jsx9(
                    "path",
                    {
                      d: "M9.91148 5.92015L5.30211 0.792139C5.16825 0.643212 4.93098 0.624239 4.77216 0.749759L4.74901 0.769661L0.0892809 5.91931C-0.0450745 6.06785 -0.0255751 6.29039 0.132834 6.41637C0.200789 6.47042 0.287 6.50008 0.376106 6.50008H9.6239C9.83161 6.50008 10 6.34219 10 6.14742C10 6.06425 9.96865 5.98375 9.91148 5.92015Z",
                      fill: "currentColor"
                    }
                  )
                }
              )
            ] })
          }
        ) })
      }
    )
  ] });
};
var TicketsSummaryMenu_default = TicketsSummaryMenu;

// src/components/booking/resell/Button.tsx
import { useResellConfig, useRouter as useRouter4, useTranslation as useTranslation10 } from "@wbk/config";
import { Button as Button5, Typography as Typography3 } from "@wbk/ui";
import { jsx as jsx10 } from "react/jsx-runtime";
var ResellButton = (_a) => {
  var _b = _a, { slug, title } = _b, props = __objRest(_b, ["slug", "title"]);
  const { t } = useTranslation10("ticketing_event");
  const { locale } = useRouter4();
  const { domain } = useResellConfig();
  return /* @__PURE__ */ jsx10(
    Button5,
    __spreadProps(__spreadValues({
      className: "h-12 w-full",
      as: "a",
      href: `${domain}/${locale}/events/${slug}`,
      target: "_blank",
      rel: "noopener noreferrer"
    }, props), {
      children: title || /* @__PURE__ */ jsx10(Typography3, { variant: "body-L", strong: true, children: t("ticketing_event:resell.check_tickets") })
    })
  );
};
var Button_default = ResellButton;

// src/components/booking/BookingFooter.tsx
import { jsx as jsx11, jsxs as jsxs8 } from "react/jsx-runtime";
var BookingFooter = () => {
  var _a;
  const { t } = useTranslation11(["subscription_common", "ticketing_booking", "ticketing_event"]);
  const { soldout } = soldout_default();
  const { watch } = useFormContext3();
  const [selectedTeam, teamTerms] = watch(["favorite_team", "team_terms"]);
  const {
    event,
    setCheckoutMode,
    checkoutMode,
    time_slots,
    subscriptionBookingLimit,
    addons,
    merchandise,
    showResell
  } = useBooking_default();
  const mustHavePlan = subscriptionBookingLimit.mustUpgradeToPlans.mustHavePlan;
  const mustUpgrade = subscriptionBookingLimit.mustUpgradeToPlans.shouldUpgrade;
  const showUpgrade = (mustUpgrade || !!mustHavePlan) && checkoutMode === "tickets";
  const handleGoNext = (mode) => {
    setCheckoutMode(mode);
    setTimeout(scrollToTop2, 0);
  };
  return /* @__PURE__ */ jsx11(FixedBar, { className: "bg-body border-paper border-t", children: /* @__PURE__ */ jsxs8(BookingWrapper_default, { mode: checkoutMode, className: "relative z-50 mx-auto grow overflow-hidden", children: [
    showUpgrade && /* @__PURE__ */ jsx11(
      "div",
      {
        className: "animate-in slide-in-from-bottom-6 fade-in-100 rounded-t-lg bg-violet-700 lg:rounded-t-none",
        style: { background: (_a = mustHavePlan == null ? void 0 : mustHavePlan.plan_group) == null ? void 0 : _a.background_color },
        children: /* @__PURE__ */ jsxs8("div", { className: "container flex items-center gap-4 p-4 text-sm lg:text-base", children: [
          mustHavePlan ? /* @__PURE__ */ jsx11("img", { src: mustHavePlan.icon, width: 24, height: 24, className: "h-6 w-6", alt: "" }) : /* @__PURE__ */ jsx11(SubscriptionIcon, { className: "text-primary h-5 w-5 shrink-0" }),
          /* @__PURE__ */ jsx11("p", { children: mustHavePlan ? t("subscription_common:must_have_plan_title", {
            plan: mustHavePlan.plan_group.name
          }) : t("subscription_common:upgrade_subscription_to_book_tickets") })
        ] })
      }
    ),
    /* @__PURE__ */ jsxs8("div", { className: "container mx-auto flex items-center justify-between gap-4 pt-2", children: [
      !soldout && /* @__PURE__ */ jsx11("div", { className: "hidden w-full sm:block", children: /* @__PURE__ */ jsx11(TicketsSummaryMenu_default, {}) }),
      /* @__PURE__ */ jsx11(
        "div",
        {
          "data-resell": showResell,
          className: "block min-w-32 data-[resell=false]:w-full sm:hidden",
          children: showResell ? /* @__PURE__ */ jsx11(
            Button_default,
            {
              slug: event.slug,
              theme: "action",
              shape: "outlined",
              className: "block h-12 px-2.5 py-1",
              title: /* @__PURE__ */ jsxs8("div", { children: [
                /* @__PURE__ */ jsx11(Typography4, { variant: "body-S", className: "whitespace-nowrap", children: /* @__PURE__ */ jsx11("span", { children: t("ticketing_event:resell.resell_tickets") }) }),
                /* @__PURE__ */ jsxs8(Typography4, { variant: "body-XXS", className: "text-success text-nowrap", children: [
                  /* @__PURE__ */ jsx11(ShieldIcon, { className: "-mt-px inline h-4 w-4" }),
                  /* @__PURE__ */ jsx11("span", { className: "ms-1", children: t("ticketing_event:resell.verified") })
                ] })
              ] })
            }
          ) : /* @__PURE__ */ jsx11(TicketsSummaryMenu_default, {})
        }
      ),
      /* @__PURE__ */ jsxs8("div", { className: "flex w-full items-center justify-end sm:gap-6", children: [
        /* @__PURE__ */ jsx11("div", { className: "hidden max-w-fit sm:block", children: showResell && /* @__PURE__ */ jsx11(
          Button_default,
          {
            slug: event.slug,
            theme: "action",
            shape: "outlined",
            className: "block h-12 px-6 py-1",
            title: /* @__PURE__ */ jsxs8("div", { children: [
              /* @__PURE__ */ jsx11(Typography4, { children: t("ticketing_event:resell.resell_tickets") }),
              /* @__PURE__ */ jsxs8(Typography4, { variant: "body-XXS", className: "text-success text-nowrap", children: [
                /* @__PURE__ */ jsx11(ShieldIcon, { className: "-mt-px inline h-4 w-4" }),
                /* @__PURE__ */ jsx11("span", { className: "ms-1", children: t("ticketing_event:resell.verified") })
              ] })
            ] })
          }
        ) }),
        /* @__PURE__ */ jsx11("div", { className: "w-full whitespace-nowrap sm:min-w-60 sm:max-w-60", children: checkoutMode === "teams" ? /* @__PURE__ */ jsx11(
          Button6,
          {
            theme: "action",
            className: "h-12 w-full font-semibold",
            disabled: !selectedTeam || !teamTerms,
            form: "booking-form-teams",
            "data-testid": "ticketing_teams_confirm_team_button",
            children: t("ticketing_booking:next_tickets")
          }
        ) : checkoutMode === "calendar" ? /* @__PURE__ */ jsx11(
          Button6,
          {
            theme: "action",
            className: "h-12 w-full font-semibold",
            onClick: () => {
              if (time_slots) {
                handleGoNext("tickets");
              }
            },
            "data-testid": "ticketing_calendar_to_tickets_button",
            disabled: !time_slots,
            children: t("ticketing_booking:next_tickets")
          }
        ) : checkoutMode === "addons" ? /* @__PURE__ */ jsx11(
          Button6,
          {
            theme: "action",
            className: "h-12 w-full font-semibold",
            onClick: () => handleGoNext("summary"),
            children: t(
              `ticketing_booking:${!!addons.length || !!merchandise.length ? "next_payment" : "merchandise.skip_to_payment"}`
            )
          }
        ) : checkoutMode === "tickets" ? /* @__PURE__ */ jsx11(FooterAction_default, {}) : /* @__PURE__ */ jsx11(ProceedButton_default, { className: "h-12 py-1" }) })
      ] })
    ] })
  ] }) });
};
var BookingFooter_default = BookingFooter;

// src/components/booking/BookingSection.tsx
import { useEffect as useEffect7 } from "react";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";
import { useTranslation as useTranslation19 } from "@wbk/config";
import { parseDateString as parseDateString3 } from "@wbk/utils";

// src/components/common/EmptyTickets.tsx
import { TicketWarningIcon } from "@wbk/svg";
import { useTranslation as useTranslation12 } from "@wbk/config";
import { jsx as jsx12, jsxs as jsxs9 } from "react/jsx-runtime";
var EmptyTickets = ({ text }) => {
  const { t } = useTranslation12("ticketing_booking");
  return /* @__PURE__ */ jsxs9("div", { className: "text-error mx-auto w-full max-w-2xl space-y-2 p-2 text-center", children: [
    /* @__PURE__ */ jsx12(TicketWarningIcon, { className: "mx-auto h-24 w-24" }),
    /* @__PURE__ */ jsx12("p", { className: "text-lg font-bold", children: text || t("ticketing_booking:no_tickets_available") })
  ] });
};
var EmptyTickets_default = EmptyTickets;

// src/components/booking/tickets/TicketsList.tsx
import { useMemo as useMemo6 } from "react";
import { useTranslation as useTranslation14 } from "@wbk/config";

// src/components/booking/perks/PerksDescription.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var PerksDescription = () => {
  const { userPerks } = useBooking_default();
  if (!(userPerks == null ? void 0 : userPerks.length))
    return null;
  return /* @__PURE__ */ jsx13("ul", { children: userPerks.map((perk) => {
    return /* @__PURE__ */ jsx13("li", { children: /* @__PURE__ */ jsx13("p", { className: "text-text-700 text-lg", children: perk.description }) }, perk._id);
  }) });
};
var PerksDescription_default = PerksDescription;

// src/components/booking/tickets/TicketRow.tsx
import { useEffect as useEffect5, useMemo as useMemo5, useState as useState5 } from "react";
import { motion as motion3 } from "motion/react";
import { addVatToPrice as addVatToPrice2 } from "@wbk/utils";
import { AddIcon, ChevronIcon, MinusIcon, SubscriptionIcon as SubscriptionIcon2 } from "@wbk/svg";
import { Button as Button8 } from "@wbk/ui";
import { CurrencyPriceLabel as CurrencyPriceLabel3 } from "@wbk/currency";
import { useTranslation as useTranslation13 } from "@wbk/config";

// src/components/booking/tickets/TicketGallery.tsx
import { useState as useState4 } from "react";
import { AnimatePresence, motion as motion2 } from "motion/react";
import { EyeIcon } from "@wbk/svg";
import { Button as Button7, Gallery } from "@wbk/ui";
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var TicketGallery = ({ galleryImages, title }) => {
  const [currentIndex, setCurrentIndex] = useState4(0);
  if (galleryImages.length === 0)
    return null;
  return /* @__PURE__ */ jsxs10("div", { className: "relative mx-auto aspect-[3/2] w-full max-w-[358px] shrink-0 self-start overflow-hidden rounded-md lg:max-w-[115px]", children: [
    /* @__PURE__ */ jsx14(AnimatePresence, { mode: "popLayout", children: /* @__PURE__ */ jsx14(
      motion2.img,
      {
        src: galleryImages[currentIndex],
        alt: `Ticket ${currentIndex + 1}`,
        className: "h-full w-full rounded-md object-cover",
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        transition: { duration: 0.2 }
      },
      galleryImages[currentIndex]
    ) }),
    /* @__PURE__ */ jsx14(
      Gallery,
      {
        startIndex: currentIndex,
        render: ({ open }) => {
          return /* @__PURE__ */ jsx14(
            Button7,
            {
              theme: "black",
              className: "absolute inset-0 cursor-pointer items-center justify-center opacity-0 transition-opacity hover:opacity-35 lg:flex",
              onClick: open,
              tabIndex: -1,
              children: /* @__PURE__ */ jsx14(EyeIcon, {})
            }
          );
        },
        slides: galleryImages.map((img) => ({
          src: img,
          title
        }))
      }
    ),
    galleryImages.length > 1 && /* @__PURE__ */ jsx14("div", { className: "bg-body-dark/10 absolute bottom-0 left-0 h-2 w-full lg:h-1", children: /* @__PURE__ */ jsx14(
      motion2.div,
      {
        className: "bg-primary h-full",
        initial: { width: "100%" },
        animate: { width: "0%" },
        transition: { duration: 5, ease: "linear" },
        onAnimationComplete: () => setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryImages.length)
      },
      currentIndex
    ) })
  ] });
};
var TicketGallery_default = TicketGallery;

// src/components/booking/tickets/TicketRow.tsx
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var TicketRow = ({ ticket }) => {
  var _a, _b, _c, _d, _e;
  const {
    plainTickets,
    addPlain,
    removePlain,
    checkoutError,
    ticket_errors,
    setTicketErrors,
    event,
    time_slots,
    limits,
    subscriptionBookingLimit,
    userPerks,
    isPerks,
    isSeated
  } = useBooking_default();
  const { t } = useTranslation13(["ticketing_common", "ticketing_booking"]);
  const [open, setOpen] = useState5(false);
  const timeSlotCapacity = (_b = (_a = Object.values(time_slots || {})) == null ? void 0 : _a[0]) == null ? void 0 : _b[0];
  const slotCapacity = Number(timeSlotCapacity == null ? void 0 : timeSlotCapacity[ticket._id]);
  const ticketlimit = useMemo5(() => {
    var _a2, _b2;
    if (isPerks) {
      const eligiblePerk = userPerks.find(
        (perk) => perk.eligible_event_ticket_ids.includes(ticket._id)
      );
      return (eligiblePerk == null ? void 0 : eligiblePerk.user_remaining_tickets) || 0;
    }
    const subscriptionLimit = (_a2 = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _a2[ticket.subscription_ticket_type_id];
    if (typeof subscriptionLimit === "number") {
      return null;
    }
    if (((_b2 = event == null ? void 0 : event.subscription_ticket_type_limits) == null ? void 0 : _b2.length) > 0) {
      const maxLimit = limits.perSubscriptionTicketType[ticket.subscription_ticket_type_id];
      if (slotCapacity >= -1) {
        return Math.min(slotCapacity, maxLimit);
      }
      return maxLimit;
    }
    if (subscriptionBookingLimit.isActive) {
      return 0;
    }
    const ticketLimit = Number(ticket.max_per_order);
    if (slotCapacity >= -1) {
      return Math.min(ticketLimit, slotCapacity);
    }
    return Math.min(ticketLimit, Number(ticket.remaining));
  }, [
    isPerks,
    subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue,
    subscriptionBookingLimit.isActive,
    ticket.subscription_ticket_type_id,
    ticket.max_per_order,
    ticket.remaining,
    ticket._id,
    (_c = event == null ? void 0 : event.subscription_ticket_type_limits) == null ? void 0 : _c.length,
    slotCapacity,
    userPerks,
    limits.perSubscriptionTicketType
  ]);
  const hasOffer = ticket.price !== ticket.original_price;
  const price = Number(ticket.priceWithFee) + Number(ticket.vatWithFee);
  const soldOut = time_slots ? (timeSlotCapacity == null ? void 0 : timeSlotCapacity.is_soldout) || slotCapacity <= 0 : ticket.sold_out;
  const shouldHide = slotCapacity && slotCapacity < 0;
  const quantity = useMemo5(() => {
    var _a2, _b2, _c2;
    let ticketQty = 0;
    let subscriptionQty = 0;
    let allQty = 0;
    for (const tick of plainTickets) {
      if (tick._id === ticket._id) {
        ticketQty += tick.qty;
      }
      if (tick.subscription_ticket_type_id === ticket.subscription_ticket_type_id) {
        subscriptionQty += tick.qty;
      }
      allQty += tick.qty;
    }
    let reachedMax = false;
    const subscriptionLimit = (_a2 = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _a2[ticket.subscription_ticket_type_id];
    const fallBackSubscriptionLimit = ((_b2 = event.subscription_ticket_type_limits) == null ? void 0 : _b2.length) > 0;
    if (typeof subscriptionLimit === "number" || fallBackSubscriptionLimit) {
      const subHeighestLimit = (subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.upgradablePlans[ticket.subscription_ticket_type_id]) || [];
      const currentBenefitValue = ((_c2 = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _c2[ticket.subscription_ticket_type_id]) || 0;
      const highestSubLimit = Math.max(
        ...subHeighestLimit.map((plan) => plan.value),
        currentBenefitValue
      );
      const heightestReached = highestSubLimit > 0 && subscriptionQty >= highestSubLimit;
      reachedMax = typeof ticketlimit === "number" && subscriptionQty >= ticketlimit || heightestReached;
    } else {
      const maxPerOrder = limits.total;
      const orderMax = typeof maxPerOrder === "number" && allQty >= maxPerOrder;
      const ticketMax = typeof ticketlimit === "number" && ticketQty >= ticketlimit;
      reachedMax = orderMax || ticketMax;
    }
    return {
      ticket: ticketQty,
      /** Total tickets of the same subscription ticket type id */
      subscription: subscriptionQty,
      all: allQty,
      reachedMax
    };
  }, [
    (_d = event.subscription_ticket_type_limits) == null ? void 0 : _d.length,
    limits.total,
    plainTickets,
    subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue,
    subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.upgradablePlans,
    ticket._id,
    ticket.subscription_ticket_type_id,
    ticketlimit
  ]);
  const subLimit = (_e = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _e[ticket.subscription_ticket_type_id];
  const mustHavePlan = !!subscriptionBookingLimit.mustUpgradeToPlans.mustHavePlan;
  const mustUpgrade = typeof subLimit === "number" && quantity.subscription > subLimit;
  const showUpgrade = mustUpgrade || mustHavePlan;
  const errors = __spreadValues(__spreadValues({}, ticket_errors), checkoutError == null ? void 0 : checkoutError.ticketErrors);
  const ticketError = errors == null ? void 0 : errors[ticket._id];
  useEffect5(() => {
    const shouldCheck = quantity.ticket > 0 && +ticket.min_per_order > 0;
    if (shouldCheck) {
      const belowMin = quantity.ticket < +ticket.min_per_order;
      if (belowMin) {
        setTicketErrors(__spreadProps(__spreadValues({}, errors), {
          [ticket._id]: t("ticketing_booking:minimum_tickets", { count: +ticket.min_per_order })
        }));
      } else if (ticketError) {
        setTicketErrors(__spreadProps(__spreadValues({}, errors), { [ticket._id]: "" }));
      }
    }
  }, [isSeated, quantity.ticket, t, ticket._id, ticket.min_per_order, ticketError]);
  if (shouldHide)
    return null;
  return /* @__PURE__ */ jsxs11(
    "li",
    {
      id: ticket._id,
      className: `border-paper overflow-hidden rounded-lg border ${ticketError ? "text-error" : ""}`,
      children: [
        ticket.subscription_ticket_type && /* @__PURE__ */ jsx15(
          TicketTypeName_default,
          {
            zone: event.zone,
            ticket,
            showIcon: true,
            className: "border-paper border-b p-4"
          }
        ),
        /* @__PURE__ */ jsxs11("div", { className: "p-4", children: [
          /* @__PURE__ */ jsxs11("div", { className: "mb-4 flex grow items-start gap-4", children: [
            /* @__PURE__ */ jsx15(
              "div",
              {
                className: "mt-1 flex w-6 shrink-0 items-center justify-center rounded p-1 text-xs md:w-8 md:text-sm",
                style: { background: ticket.ticket_color, color: ticket.text_color },
                children: (ticket == null ? void 0 : ticket.shortcode) || ticket.title.slice(0, 2).toUpperCase()
              }
            ),
            /* @__PURE__ */ jsxs11("div", { children: [
              /* @__PURE__ */ jsx15("p", { className: "text-sm sm:text-base sm:font-semibold", children: ticket.title }),
              hasOffer && !soldOut && /* @__PURE__ */ jsx15(
                CurrencyPriceLabel3,
                {
                  className: "text-text/60 text-xs line-through",
                  originalPrice: addVatToPrice2(ticket == null ? void 0 : ticket.originalPriceWithFee, +(event == null ? void 0 : event.vat_percent)),
                  currency: ticket.currency,
                  zeroAsFree: true
                }
              ),
              /* @__PURE__ */ jsx15(
                CurrencyPriceLabel3,
                {
                  className: "text-sm",
                  originalPrice: price,
                  currency: ticket.currency,
                  zeroAsFree: true
                }
              )
            ] })
          ] }),
          !!ticketError && /* @__PURE__ */ jsx15("p", { className: "text-error", children: ticketError }),
          /* @__PURE__ */ jsxs11("div", { className: "flex items-center justify-between", children: [
            ticket.description ? /* @__PURE__ */ jsxs11(
              Button8,
              {
                onClick: () => setOpen((prev) => !prev),
                shape: "text",
                theme: "transparent",
                "aria-label": "expand description",
                className: "-mx-1 flex items-center gap-1 p-1 text-sm underline",
                children: [
                  /* @__PURE__ */ jsx15("span", { children: t("ticketing_booking:more_details") }),
                  /* @__PURE__ */ jsx15(ChevronIcon, { className: `h-3 w-3 ${open ? "-rotate-90" : "rotate-90"}` })
                ]
              }
            ) : /* @__PURE__ */ jsx15("div", {}),
            soldOut ? /* @__PURE__ */ jsx15("span", { className: "text-lg text-red-500", children: t("ticketing_booking:sold_out") }) : /* @__PURE__ */ jsxs11("div", { className: "flex items-center gap-3 font-sans text-3xl leading-none", children: [
              /* @__PURE__ */ jsx15(
                Button8,
                {
                  onClick: () => {
                    removePlain(ticket, 1);
                    if (quantity.ticket === 1) {
                      setTicketErrors(__spreadProps(__spreadValues({}, errors), { [ticket._id]: "" }));
                    }
                  },
                  disabled: quantity.ticket <= 0,
                  shape: "outlined",
                  theme: "action",
                  "data-testid": "ticketing_tickets_decrease_tickets_button",
                  "data-event-name": event.title,
                  "data-ticket-name": ticket.title,
                  "data-ticket-group": ticket.group_name_en,
                  className: "remove-from-cart flex h-8 w-8 items-center justify-center p-1",
                  children: /* @__PURE__ */ jsx15(MinusIcon, {})
                }
              ),
              /* @__PURE__ */ jsx15("div", { className: "text-xl font-semibold", children: quantity.ticket }),
              /* @__PURE__ */ jsxs11(
                Button8,
                {
                  onClick: () => addPlain(ticket, 1),
                  disabled: quantity.reachedMax,
                  className: "add-to-cart relative flex h-8 w-8 items-center justify-center overflow-visible p-1",
                  "data-testid": "ticketing_tickets_increase_tickets_button",
                  "data-event-name": event.title,
                  "data-ticket-name": ticket.title,
                  "data-ticket-group": ticket.group_name_en,
                  shape: "outlined",
                  theme: "action",
                  children: [
                    /* @__PURE__ */ jsx15(AddIcon, {}),
                    /* @__PURE__ */ jsx15("span", { className: "absolute top-0 -translate-y-1/2 ltr:left-full ltr:-translate-x-1/2 rtl:right-full rtl:translate-x-1/2", children: /* @__PURE__ */ jsx15(
                      SubscriptionIcon2,
                      {
                        "data-visible": showUpgrade,
                        className: "text-primary h-5 w-5 shrink-0 scale-0 transition-transform duration-500 data-[visible=true]:scale-100"
                      }
                    ) })
                  ]
                }
              )
            ] })
          ] }),
          !!ticket.description && /* @__PURE__ */ jsx15(
            motion3.div,
            {
              initial: { height: 0 },
              animate: { height: open ? "auto" : 0 },
              className: "text-text max-w-full overflow-hidden whitespace-pre-wrap",
              transition: { duration: 0.25, ease: "easeInOut" },
              "data-testid": "collapsable-text",
              children: /* @__PURE__ */ jsxs11("div", { className: "flex flex-col-reverse gap-3 pt-4 md:flex-row", children: [
                /* @__PURE__ */ jsx15("div", { dangerouslySetInnerHTML: { __html: ticket.description }, className: "grow" }),
                /* @__PURE__ */ jsx15(TicketGallery_default, { title: ticket.title, galleryImages: ticket.gallery_images })
              ] })
            }
          )
        ] })
      ]
    },
    ticket._id
  );
};
var TicketRow_default = TicketRow;

// src/components/booking/tickets/GroupedTickets.tsx
import { jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
var GroupedTickets = ({ groupName, tickets }) => {
  return /* @__PURE__ */ jsxs12("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsxs12("div", { className: "pt-2", children: [
      /* @__PURE__ */ jsx16("h3", { className: "text-xl", children: groupName }),
      tickets[0].group_rt_description && /* @__PURE__ */ jsx16(
        "div",
        {
          className: "prose max-w-full",
          dangerouslySetInnerHTML: { __html: tickets[0].group_rt_description }
        }
      )
    ] }),
    /* @__PURE__ */ jsx16("ul", { className: "space-y-4", children: tickets.map((ticket) => {
      return /* @__PURE__ */ jsx16(TicketRow_default, { ticket }, ticket._id);
    }) })
  ] });
};
var GroupedTickets_default = GroupedTickets;

// src/components/booking/tickets/TicketsList.tsx
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var TicketsList = () => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { eventTickets, subscriptionBookingLimit, user, userPerks } = useBooking_default();
  const { t } = useTranslation14(["subscription_common", "ticketing_booking", "currency_common"]);
  const tickets = useMemo6(() => {
    let filtered = eventTickets;
    if (userPerks.length > 0) {
      const perkIds = userPerks.flatMap((perk) => perk.eligible_event_ticket_ids);
      filtered = eventTickets.filter((ticket) => perkIds.includes(ticket._id));
    }
    return listTicketsByGroup(filtered);
  }, [eventTickets, userPerks]);
  const isBasic = !!((_b = (_a = user == null ? void 0 : user.user_subscriptions) == null ? void 0 : _a[0]) == null ? void 0 : _b.plan) && !!((_d = (_c = user == null ? void 0 : user.user_subscriptions) == null ? void 0 : _c[0]) == null ? void 0 : _d.plan.is_basic_plan);
  return /* @__PURE__ */ jsxs13("div", { className: "space-y-2 pb-4", children: [
    /* @__PURE__ */ jsxs13("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsx17("h2", { className: "text-2xl", children: t("ticketing_booking:select_tickets") }),
      !isBasic && (subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.isActive) && /* @__PURE__ */ jsx17("p", { className: "text-text-secondary text-sm", children: t("subscription_common:current_benefits_limit_mini", {
        plan: (_h = (_g = (_f = (_e = subscriptionBookingLimit.subscriptions) == null ? void 0 : _e[0]) == null ? void 0 : _f.plan) == null ? void 0 : _g.plan_group) == null ? void 0 : _h.name,
        benefits: subscriptionBookingLimit.userCurrentBenefits.join(" -- ")
      }).replace(/--/g, " & ") }),
      /* @__PURE__ */ jsx17(PerksDescription_default, {})
    ] }),
    tickets.groupedTickets.length > 0 && /* @__PURE__ */ jsx17("div", { className: "space-y-4 pb-2", children: tickets.groupedTickets.map(([groupName, tickets2]) => /* @__PURE__ */ jsx17(GroupedTickets_default, { groupName, tickets: tickets2 }, groupName)) }),
    tickets.ungroupedTickets.length > 0 && /* @__PURE__ */ jsx17("ul", { className: "space-y-4", children: tickets.ungroupedTickets.map((ticket) => /* @__PURE__ */ jsx17(TicketRow_default, { ticket }, ticket._id)) })
  ] });
};
var TicketsList_default = TicketsList;

// src/components/booking/tickets/SeatsIO.tsx
import { useMemo as useMemo8, useState as useState7 } from "react";
import { eraseCookie } from "@wbk/utils";
import { PinchZoomIcon } from "@wbk/svg";
import { useCurrency } from "@wbk/currency";
import { useRouter as useRouter6, useTranslation as useTranslation16 } from "@wbk/config";

// src/components/booking/interest/Form.tsx
import { useEffect as useEffect6, useRef as useRef2 } from "react";
import { useTicketInterest } from "@wbk/api/hooks";
import { useAuth as useAuth2 } from "@wbk/auth";
import { useDeviceDetect as useDeviceDetect3 } from "@wbk/hooks";
import {
  BottomSheet as BottomSheet2,
  Button as Button9,
  Input as Input3,
  MobileInput,
  Modal as Modal2,
  Select as Select2,
  Toast,
  ToggleGroup as ToggleGroup2
} from "@wbk/ui";
import { COUNTRIES, dateAdd, parseDateString as parseDateString2 } from "@wbk/utils";
import { Controller as Controller3, useForm as useForm2 } from "react-hook-form";
import { twMerge as twMerge2 } from "tailwind-merge";
import { useGeolocation, useRouter as useRouter5, useTranslation as useTranslation15 } from "@wbk/config";
import { Fragment as Fragment6, jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var MIN_AGE_ALLOWED = 13;
var InterestForm = ({ onClose, className, seatKey }) => {
  var _a, _b, _h, _i, _j, _k, _l, _m, _n;
  const { isMobile } = useDeviceDetect3();
  const { event, isSeason } = useBooking_default();
  const { user } = useAuth2();
  const { locale } = useRouter5();
  const show = !!seatKey;
  const { t } = useTranslation15(["auth_common", "ticketing_booking"]);
  const { mutateAsync, isPending, error } = useTicketInterest();
  const { country: detectedCountry } = useGeolocation();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    control,
    watch
  } = useForm2({
    defaultValues: {
      first_name: (user == null ? void 0 : user.first_name) || "",
      last_name: (user == null ? void 0 : user.last_name) || "",
      email: (user == null ? void 0 : user.email) || "",
      gender: (user == null ? void 0 : user.gender) || "",
      dob: (user == null ? void 0 : user.dob) ? parseDateString2(user == null ? void 0 : user.dob) : "",
      nationality: (user == null ? void 0 : user.nationality) || "",
      country: (user == null ? void 0 : user.country) || ""
    }
  });
  const selectedCountry = watch("dialCountry") || detectedCountry;
  const toast = useRef2(void 0);
  useEffect6(() => {
    var _a2;
    const country = COUNTRIES.find(
      (c) => c.code === (user == null ? void 0 : user.cell_country_code) || (detectedCountry == null ? void 0 : detectedCountry.code)
    );
    if (country) {
      setValue("dialCountry", country);
      setValue("phone", ((_a2 = user == null ? void 0 : user.cell_number) == null ? void 0 : _a2.replace(`+${country == null ? void 0 : country.dial_code}`, "")) || "");
    }
  }, [detectedCountry == null ? void 0 : detectedCountry.code, user == null ? void 0 : user.cell_country_code, user == null ? void 0 : user.cell_number]);
  const onSubmit = (data) => __async(void 0, null, function* () {
    var _a2;
    try {
      const body = {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone_number: data.phone || "",
        type: isSeason ? "season" : "event",
        box_seatio_key: seatKey || "",
        slug: event.slug || "",
        dob: data.dob,
        gender: data.gender,
        nationality: data.nationality,
        lang: locale
      };
      yield mutateAsync(body);
      (_a2 = toast.current) == null ? void 0 : _a2.publish({
        icon: true,
        title: t("ticketing_booking:interest.success")
      });
      onClose == null ? void 0 : onClose();
    } catch (err) {
    }
  });
  const Body3 = /* @__PURE__ */ jsxs14(
    "form",
    {
      id: "box-interest-form",
      onSubmit: handleSubmit(onSubmit),
      className: twMerge2("space-y-4 px-6 pb-24 pt-6", className),
      children: [
        /* @__PURE__ */ jsxs14("div", { children: [
          /* @__PURE__ */ jsx18("h2", { className: "pb-1 text-2xl font-semibold", children: t("ticketing_booking:interest.interest_title") }),
          /* @__PURE__ */ jsx18("p", { className: "text-text-secondary text-sm", children: t("ticketing_booking:interest.interest_desc") })
        ] }),
        /* @__PURE__ */ jsxs14("fieldset", { className: "flex flex-col gap-2 py-1 sm:flex-row", children: [
          /* @__PURE__ */ jsx18("div", { className: "grow", children: /* @__PURE__ */ jsx18(
            Input3,
            __spreadProps(__spreadValues({
              id: "first_name",
              label: t("auth_common:first_name")
            }, register("first_name", {
              required: t("auth_common:validation.required"),
              maxLength: {
                value: 25,
                message: t("auth_common:validation.max_length", { max: 25 })
              }
            })), {
              onChange: (value) => {
                setValue("first_name", value);
              },
              error: (_a = errors.first_name) == null ? void 0 : _a.message
            })
          ) }),
          /* @__PURE__ */ jsx18("div", { className: "grow", children: /* @__PURE__ */ jsx18(
            Input3,
            __spreadProps(__spreadValues({
              id: "last_name",
              autoComplete: "off",
              label: t("auth_common:last_name")
            }, register("last_name", {
              required: t("auth_common:validation.required"),
              maxLength: {
                value: 25,
                message: t("auth_common:validation.max_length", { max: 25 })
              }
            })), {
              onChange: (value) => {
                setValue("last_name", value);
              },
              error: (_b = errors.last_name) == null ? void 0 : _b.message
            })
          ) })
        ] }),
        /* @__PURE__ */ jsx18(
          Controller3,
          {
            control,
            name: "email",
            rules: { required: t("common:validation.required") },
            defaultValue: (user == null ? void 0 : user.email) || "",
            render: (_c) => {
              var { field: _d } = _c, props = __objRest(_d, []);
              var _a2;
              return /* @__PURE__ */ jsx18(
                Input3,
                __spreadProps(__spreadValues({
                  id: "email",
                  autoComplete: "off",
                  label: t("auth_common:email")
                }, props), {
                  error: (_a2 = errors.email) == null ? void 0 : _a2.message
                })
              );
            }
          }
        ),
        /* @__PURE__ */ jsx18(
          Controller3,
          {
            name: "phone",
            control,
            rules: {
              required: t("auth_common:validation.required"),
              validate: (value) => {
                var _a2, _b2;
                const hasValidation = (_a2 = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _a2.length;
                if (hasValidation) {
                  const validStart = (_b2 = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _b2.some(
                    (start) => value == null ? void 0 : value.startsWith(start)
                  );
                  return validStart || t("auth_common:validation.invalid_mobile");
                }
                return true;
              }
            },
            render: (_e) => {
              var { field: _f } = _e, _g = _f, { value } = _g, props = __objRest(_g, ["value"]);
              var _a2, _b2, _c;
              return /* @__PURE__ */ jsx18(
                MobileInput,
                __spreadProps(__spreadValues({}, props), {
                  label: t("auth_common:mobile"),
                  portal: false,
                  country: selectedCountry,
                  mobile: value || "",
                  onChange: (name, value2) => {
                    if (name === "country") {
                      setValue("dialCountry", value2);
                    } else {
                      setValue("phone", value2);
                    }
                  },
                  error: (_a2 = errors == null ? void 0 : errors.phone) == null ? void 0 : _a2.message,
                  placeholder: selectedCountry ? `${((_b2 = selectedCountry == null ? void 0 : selectedCountry.mobile_starts_with) == null ? void 0 : _b2[0]) || ""}${"x".repeat(
                    (((_c = selectedCountry.phone_number_lengths) == null ? void 0 : _c[0]) || 7) - 1
                  )}` : ""
                })
              );
            }
          },
          selectedCountry == null ? void 0 : selectedCountry.code
        ),
        /* @__PURE__ */ jsx18(
          Input3,
          __spreadProps(__spreadValues({
            type: "date",
            className: "w-full uppercase",
            pattern: "\\d{4}-\\d{2}-\\d{2}",
            min: (_j = (_i = (_h = dateAdd({
              date: /* @__PURE__ */ new Date(),
              value: -150,
              interval: "year"
            })) == null ? void 0 : _h.toISOString()) == null ? void 0 : _i.split("T")) == null ? void 0 : _j[0],
            max: (_m = (_l = (_k = dateAdd({
              date: /* @__PURE__ */ new Date(),
              value: -MIN_AGE_ALLOWED,
              interval: "year"
            })) == null ? void 0 : _k.toISOString()) == null ? void 0 : _l.split("T")) == null ? void 0 : _m[0],
            label: t("auth_common:birthdate")
          }, register("dob", {
            required: t("auth_common:validation.required")
          })), {
            onChange: (value) => {
              setValue("dob", value);
            },
            error: (_n = errors.dob) == null ? void 0 : _n.message
          })
        ),
        /* @__PURE__ */ jsx18(
          Controller3,
          {
            name: "gender",
            control,
            rules: { required: t("auth_common:validation.required") },
            render: ({ field }) => {
              var _a2;
              return /* @__PURE__ */ jsx18(
                ToggleGroup2,
                __spreadProps(__spreadValues({
                  label: t("auth_common:gender"),
                  options: [
                    { text: t("auth_common:male"), value: "male" },
                    { text: t("auth_common:female"), value: "female" }
                  ]
                }, field), {
                  type: "single",
                  error: (_a2 = errors.gender) == null ? void 0 : _a2.message
                })
              );
            }
          }
        ),
        /* @__PURE__ */ jsx18(
          Controller3,
          {
            name: "nationality",
            control,
            rules: { required: t("auth_common:validation.required") },
            defaultValue: "",
            render: (_o) => {
              var { field: _p } = _o, _q = _p, { onChange } = _q, props = __objRest(_q, ["onChange"]);
              var _a2;
              return /* @__PURE__ */ jsx18(
                Select2,
                __spreadProps(__spreadValues({
                  id: "nationality"
                }, props), {
                  autoComplete: "off",
                  portal: false,
                  onChange: (selected) => onChange((selected == null ? void 0 : selected.value) || ""),
                  label: t("auth_common:nationality"),
                  placeholder: t("auth_common:nationality"),
                  options: COUNTRIES.map((c) => ({
                    id: c.code,
                    value: c.code,
                    text: c[`name_${locale}`] || c.name,
                    icon: /* @__PURE__ */ jsx18(
                      "img",
                      {
                        className: "shrink-0",
                        src: `https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/${c.code.toLowerCase()}.png`,
                        width: 20,
                        height: 14,
                        alt: c.name
                      }
                    )
                  })),
                  error: (_a2 = errors == null ? void 0 : errors.nationality) == null ? void 0 : _a2.message
                })
              );
            }
          }
        ),
        error && /* @__PURE__ */ jsx18("p", { className: "text-error text-sm", children: error.message })
      ]
    }
  );
  const footer = ({ close }) => /* @__PURE__ */ jsxs14("div", { className: "flex items-center justify-end gap-4 p-4", children: [
    /* @__PURE__ */ jsx18(Button9, { theme: "white", shape: "text", type: "button", onClick: close, children: t("auth_common:cancel") }),
    /* @__PURE__ */ jsx18(
      Button9,
      {
        type: "submit",
        theme: "white",
        form: "box-interest-form",
        loading: isPending,
        className: "text-lg font-bold",
        children: t("ticketing_booking:interest.submit")
      }
    )
  ] });
  return /* @__PURE__ */ jsxs14(Fragment6, { children: [
    /* @__PURE__ */ jsx18(Toast, { ref: toast }),
    isMobile ? /* @__PURE__ */ jsx18(
      BottomSheet2,
      {
        rounded: true,
        body: () => Body3,
        show,
        onClose,
        stickyFooter: footer,
        className: "z-[100]"
      }
    ) : /* @__PURE__ */ jsx18(
      Modal2,
      {
        closeButton: true,
        className: "overflow-auto",
        show,
        zIndex: 999,
        body: () => Body3,
        onClose,
        stickyFooter: footer
      }
    )
  ] });
};
var Form_default = InterestForm;

// src/components/booking/tickets/TicketsExpandableList.tsx
import { useMemo as useMemo7, useState as useState6 } from "react";
import { motion as motion4 } from "motion/react";
import { twMerge as twMerge3 } from "tailwind-merge";
import { CurrencyPriceLabel as CurrencyPriceLabel4 } from "@wbk/currency";
import { ChevronIcon as ChevronIcon2 } from "@wbk/svg";
import { usePayment as usePayment5 } from "@wbk/payment";
import { addVatToPrice as addVatToPrice3 } from "@wbk/utils";
import { Fragment as Fragment7, jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var TicketsExpandableList = ({ floated, className }) => {
  const [open, setOpen] = useState6(false);
  const { eventTickets } = useBooking_default();
  const toggle = () => setOpen((prev) => !prev);
  const tickets = useMemo7(() => {
    const available = getAvailableTickets(eventTickets);
    const grouped = Object.entries(groupTicketsByGroupName(available));
    const ungrouped = available.filter((e) => !e.has_group);
    return {
      available,
      grouped,
      ungrouped
    };
  }, [eventTickets]);
  if (!tickets.available.length)
    return null;
  const Content = /* @__PURE__ */ jsxs15("div", { className: "p-2", children: [
    tickets.grouped.map(([title, tickets2], idx) => {
      var _a;
      const groupDesc = (_a = tickets2 == null ? void 0 : tickets2[0]) == null ? void 0 : _a.group_rt_description;
      return /* @__PURE__ */ jsxs15("ul", { className: "text-sm", children: [
        /* @__PURE__ */ jsx19("p", { className: "font-semibold", children: title }),
        groupDesc && /* @__PURE__ */ jsx19("div", { className: "text-xs", dangerouslySetInnerHTML: { __html: groupDesc } }),
        tickets2.map((ticket, idx2) => {
          return /* @__PURE__ */ jsx19(PriceItem, { ticket }, idx2);
        })
      ] }, title + idx);
    }),
    tickets.ungrouped.length > 0 && /* @__PURE__ */ jsx19("ul", { className: "px-1 text-sm", children: tickets.ungrouped.map((ticket, idx) => {
      return /* @__PURE__ */ jsx19(PriceItem, { ticket }, idx);
    }) })
  ] });
  return /* @__PURE__ */ jsxs15("div", { className: twMerge3("relative lg:mb-4", className), children: [
    /* @__PURE__ */ jsxs15(
      "button",
      {
        "data-open": open,
        className: "border-paper relative z-50 flex w-full items-center gap-2 border-b-0 p-2.5 hover:opacity-80 lg:rounded-t-lg lg:border-b-0 data-[open=true]:lg:border",
        onClick: toggle,
        children: [
          /* @__PURE__ */ jsx19("div", { className: "line-clamp-1 flex grow gap-3 whitespace-nowrap", children: tickets.available.map((ticket) => /* @__PURE__ */ jsxs15("div", { className: "flex items-center gap-1.5", children: [
            /* @__PURE__ */ jsx19(
              "div",
              {
                className: "flex h-5 w-5 shrink-0 items-center justify-center rounded p-1 text-[10px] sm:text-xs",
                style: { background: ticket.ticket_color, color: ticket.text_color },
                children: (ticket == null ? void 0 : ticket.shortcode) || ticket.title.slice(0, 2).toUpperCase()
              }
            ),
            /* @__PURE__ */ jsx19(
              CurrencyPriceLabel4,
              {
                className: "[&_svg]:h-3 [&_svg]:w-3",
                originalPrice: (ticket.priceWithFee + ticket.vatWithFee) * Math.max(+ticket.min_per_order, 1),
                currency: ticket.currency
              }
            )
          ] }, ticket._id)) }),
          /* @__PURE__ */ jsx19(ChevronIcon2, { className: "h-3 w-3 shrink-0 rotate-90" })
        ]
      }
    ),
    floated ? /* @__PURE__ */ jsxs15(Fragment7, { children: [
      /* @__PURE__ */ jsx19(
        motion4.div,
        {
          className: "bg-body/90 absolute top-10 z-[9999] mx-auto w-full overflow-hidden backdrop-blur-lg",
          initial: { height: 0 },
          animate: { height: open ? "auto" : 0 },
          children: /* @__PURE__ */ jsx19(
            "div",
            {
              "data-open": open,
              className: "mini-scrollbar border-t-text/10 border-paper h-full max-h-[calc(100vh-360px)] rounded-b-lg data-[open=true]:overflow-y-auto lg:border",
              children: Content
            }
          )
        }
      ),
      open && /* @__PURE__ */ jsxs15(Fragment7, { children: [
        /* @__PURE__ */ jsx19(
          "div",
          {
            className: "fixed inset-0 top-20 z-40 backdrop-blur-[3px]",
            onPointerUp: () => {
              setOpen(false);
            }
          }
        ),
        /* @__PURE__ */ jsx19("style", { children: "body{overflow:hidden}" })
      ] })
    ] }) : /* @__PURE__ */ jsx19(
      motion4.div,
      {
        initial: { height: 0 },
        animate: { height: open ? "auto" : 0 },
        className: "relative overflow-hidden rounded-lg",
        transition: { duration: 0.25, ease: "easeInOut" },
        children: Content
      }
    )
  ] });
};
var PriceItem = ({ ticket }) => {
  const { event } = useBooking_default();
  const { coupon } = usePayment5();
  const { title, description, ticket_color, text_color } = ticket;
  const hasDiscount = ticket.price !== ticket.original_price;
  const hasCoupon = coupon.ticket_ids.includes((ticket == null ? void 0 : ticket._id) || "");
  const isAffectedByDiscount = hasDiscount || hasCoupon;
  const originalPrice = addVatToPrice3(ticket.originalPriceWithFee, +(event == null ? void 0 : event.vat_percent));
  const price = Number(ticket.priceWithFee) + Number(ticket.vatWithFee);
  const netTotal = price - price * (coupon.discount / 100);
  return /* @__PURE__ */ jsx19("li", { className: "py-2", children: /* @__PURE__ */ jsxs15("div", { className: "flex w-full gap-2", children: [
    /* @__PURE__ */ jsx19(
      "div",
      {
        className: "flex h-5 w-5 shrink-0 items-center justify-center rounded p-1 text-[10px] sm:text-xs",
        style: { background: ticket_color, color: text_color },
        children: title.slice(0, 2).toUpperCase()
      }
    ),
    /* @__PURE__ */ jsxs15("div", { className: "grow text-sm", children: [
      /* @__PURE__ */ jsx19("p", { children: title }),
      description && /* @__PURE__ */ jsx19("div", { className: "text-xs", dangerouslySetInnerHTML: { __html: description } })
    ] }),
    /* @__PURE__ */ jsx19(
      CurrencyPriceLabel4,
      {
        className: "shrink-0 [&_svg]:h-3 [&_svg]:w-3",
        originalPrice: isAffectedByDiscount ? originalPrice : price,
        discountPrice: netTotal,
        currency: event.currency
      }
    )
  ] }) });
};
var TicketsExpandableList_default = TicketsExpandableList;

// src/components/booking/tickets/SeatsIO.tsx
import { Fragment as Fragment8, jsx as jsx20, jsxs as jsxs16 } from "react/jsx-runtime";
var SeatsIO = () => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const {
    event,
    addSeat,
    removeSeat,
    onSeatsInitialized,
    setChart,
    user,
    time_slots,
    limits,
    eventTickets,
    seatTickets,
    removeAllSeats,
    favoriteTeam,
    subscriptionBookingLimit,
    userPerks,
    isPerks
  } = useBooking_default();
  const {
    seats: { colorScheme }
  } = useTicketing();
  const { locale } = useRouter6();
  const { t } = useTranslation16(["ticketing_booking"]);
  const [mounted, setMounted] = useState7(false);
  const withTimeSlots = !!event.time_slots;
  const { exchangePrice, symbol, currency } = useCurrency();
  const [seatKey, setSeatKey] = useState7();
  const isBasic = !!((_b = (_a = user == null ? void 0 : user.user_subscriptions) == null ? void 0 : _a[0]) == null ? void 0 : _b.plan) && !!((_d = (_c = user == null ? void 0 : user.user_subscriptions) == null ? void 0 : _c[0]) == null ? void 0 : _d.plan.is_basic_plan);
  const pricing = useMemo8(() => {
    return eventTickets.map((t2) => {
      const ticketTypes = t2.ticket_type ? getTicketTypesForSeatIoCategory(eventTickets, Number(t2.seats_io_category)) : void 0;
      return {
        category: t2.seats_io_category,
        price: t2.ticket_type ? void 0 : +t2.priceWithFee + +t2.vatWithFee,
        originalPrice: t2.ticket_type || +t2.originalPriceWithFee === +t2.priceWithFee ? void 0 : +t2.originalPriceWithFee,
        ticketTypes
      };
    });
  }, [eventTickets]);
  const maxSeats = useMemo8(() => {
    var _a2;
    if (isPerks) {
      const maxSeats2 = [
        { total: Math.max(...userPerks.map((p) => p.user_remaining_tickets), 0) }
      ];
      for (const t2 of eventTickets) {
        const appliedPerk = userPerks.find((p) => p.event_tickets.some((et) => et._id === t2._id));
        if (!appliedPerk)
          continue;
        maxSeats2.push({
          category: t2.seats_io_category,
          quantity: String(appliedPerk.user_remaining_tickets)
        });
      }
      return maxSeats2;
    }
    const hasSubs = Object.keys(subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue).length > 0;
    if (hasSubs) {
      const upgradable = Object.values(subscriptionBookingLimit.upgradablePlans).flat();
      const fallbackCurrent = Object.values(subscriptionBookingLimit.benefitValue).filter(
        (b) => typeof b === "number"
      );
      return Math.max(...upgradable.map((e) => e.value), ...fallbackCurrent, 0);
    }
    const ticketTypeHasLimit = eventTickets.some((t2) => {
      var _a3;
      return !!((_a3 = t2.ticket_type) == null ? void 0 : _a3.limit);
    });
    if (ticketTypeHasLimit) {
      const ticketType = {};
      for (const t2 of eventTickets) {
        if ((_a2 = t2.ticket_type) == null ? void 0 : _a2.limit) {
          ticketType[t2.ticket_type.slug] = t2.ticket_type.limit;
        }
      }
      const ticketTypeLimits = Object.entries(ticketType).map(([slug, limit]) => ({
        ticketType: slug,
        quantity: Number(limit)
      }));
      return ticketTypeLimits;
    }
    const ignoreTotal = eventTickets.some((ticket) => ticket.ignore_user_order_limit);
    const categoryLimits = eventTickets.map((t2) => ({
      category: t2.seats_io_category,
      quantity: t2.max_per_order
    }));
    if (!ignoreTotal && limits.total > 0) {
      return categoryLimits.concat({ total: limits.total });
    }
    return categoryLimits;
  }, [
    eventTickets,
    limits.total,
    subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue,
    subscriptionBookingLimit.upgradablePlans,
    userPerks,
    isPerks
  ]);
  const messages = useMemo8(() => {
    return {
      row: t("ticketing_booking:seats.row"),
      restrictedView: t("ticketing_booking:seats.restrictedView"),
      done: t("ticketing_booking:seats.done")
    };
  }, [t]);
  const allChannels = useMemo8(() => {
    var _a2, _b2, _c2, _d2, _e2;
    const searchParams = new URLSearchParams(window.location.search);
    const hasSpecialChannel = searchParams.get("channel");
    const specialChannels = hasSpecialChannel ? hasSpecialChannel.split(",") : [];
    const perksChannels = (userPerks == null ? void 0 : userPerks.flatMap((p) => p.channels)) || [];
    if (isPerks) {
      return perksChannels;
    }
    if (specialChannels.length > 0) {
      return specialChannels;
    }
    const commonKeys = ["NO_CHANNEL"];
    const eventCommon = ((_a2 = event.channel_keys) == null ? void 0 : _a2.common) || [];
    const eventGlobal = ((_b2 = event.channel_keys) == null ? void 0 : _b2.global) || [];
    if (typeof eventCommon === "string") {
      commonKeys.push(eventCommon);
    } else {
      commonKeys.push(...eventCommon);
    }
    if (typeof eventGlobal === "string") {
      commonKeys.push(eventGlobal);
    } else {
      commonKeys.push(...eventGlobal);
    }
    const favTeamId = favoriteTeam || "";
    let userFavoriteKeys = event.channel_keys && ((_d2 = (_c2 = event.channel_keys) == null ? void 0 : _c2[favTeamId]) == null ? void 0 : _d2.length) > 0 ? event.channel_keys[favTeamId] : [];
    if (typeof userFavoriteKeys === "string") {
      userFavoriteKeys = [userFavoriteKeys];
    }
    if ((_e2 = user == null ? void 0 : user.early_bird) == null ? void 0 : _e2.length) {
      const eventChannels = user == null ? void 0 : user.early_bird.filter(
        (e) => !!e.channel && (e.event_id === event._id || e.season_id === event._id)
      );
      const channels = eventChannels.map((e) => e.channel);
      commonKeys.push(...channels);
    }
    return commonKeys.concat(userFavoriteKeys);
  }, [event._id, event.channel_keys, favoriteTeam, user == null ? void 0 : user.early_bird, userPerks, isPerks]);
  const eventKey = useMemo8(() => {
    var _a2, _b2, _c2, _d2;
    if (withTimeSlots) {
      const slot = (_b2 = (_a2 = Object.values(time_slots || {})) == null ? void 0 : _a2[0]) == null ? void 0 : _b2[0];
      return slot == null ? void 0 : slot.seatio_event_key;
    }
    return ((_c2 = event.seats_io) == null ? void 0 : _c2.season_key) || ((_d2 = event.seats_io) == null ? void 0 : _d2.event_key);
  }, [(_e = event.seats_io) == null ? void 0 : _e.event_key, (_f = event.seats_io) == null ? void 0 : _f.season_key, time_slots, withTimeSlots]);
  const handleAddSeat = (seat) => {
    var _a2;
    const ticket = eventTickets.find((t2) => {
      if (seat.selectedTicketType && !t2.ticket_type)
        return false;
      return t2.ticket_type ? Number(t2.seats_io_category) === seat.category.key && t2.ticket_type.slug === seat.selectedTicketType : Number(t2.seats_io_category) === seat.category.key;
    });
    if (ticket && ((_a2 = ticket == null ? void 0 : ticket.ticket_type) == null ? void 0 : _a2.slug) === "interest") {
      setSeatKey(seat == null ? void 0 : seat.uuid);
      seat.deselect();
    } else {
      addSeat(seat);
    }
  };
  return /* @__PURE__ */ jsxs16(Fragment8, { children: [
    /* @__PURE__ */ jsx20(
      Form_default,
      {
        seatKey,
        onClose: () => {
          setSeatKey(void 0);
        }
      }
    ),
    /* @__PURE__ */ jsxs16("div", { className: "space-y-1 pb-2", children: [
      /* @__PURE__ */ jsx20("h2", { className: "text-2xl", children: t("ticketing_booking:select_tickets") }),
      !isBasic && (subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.isActive) && /* @__PURE__ */ jsx20("p", { className: "text-text-secondary text-sm", children: t("subscription_common:current_benefits_limit_mini", {
        plan: (_j = (_i = (_h = (_g = subscriptionBookingLimit.subscriptions) == null ? void 0 : _g[0]) == null ? void 0 : _h.plan) == null ? void 0 : _i.plan_group) == null ? void 0 : _j.name,
        benefits: subscriptionBookingLimit.userCurrentBenefits.join(" -- ")
      }).replace(/--/g, " & ") }),
      /* @__PURE__ */ jsx20(PerksDescription_default, {})
    ] }),
    /* @__PURE__ */ jsxs16(
      "div",
      {
        "data-testid": "seat-chart",
        "data-sub": subscriptionBookingLimit.isActive,
        className: "border-paper relative mb-12 h-[calc(100vh-360px)] data-[sub=true]:h-[calc(100vh-430px)] lg:mb-4 lg:!h-full lg:rounded-xl lg:border",
        children: [
          /* @__PURE__ */ jsx20(TicketsExpandableList_default, { floated: true }),
          /* @__PURE__ */ jsxs16("div", { className: "relative h-full overflow-hidden", children: [
            mounted && /* @__PURE__ */ jsx20("div", { className: "absolute top-0 z-10 flex w-full justify-center lg:hidden", children: /* @__PURE__ */ jsxs16("div", { className: "text-text-secondary flex items-center gap-1", children: [
              /* @__PURE__ */ jsx20("p", { className: "text-xs lg:text-sm", children: t("ticketing_booking:drag_to_zoom") }),
              /* @__PURE__ */ jsx20(PinchZoomIcon, {})
            ] }) }),
            /* @__PURE__ */ jsx20(
              SeatsChart_default,
              {
                provider: event.seats_provider,
                language: locale || "en",
                pricing,
                event: eventKey,
                objectWithoutPricingSelectable: false,
                objectWithoutCategorySelectable: false,
                priceFormatter: (price) => {
                  if (currency.shortCode === "SAR") {
                    return "[SAR]" + exchangePrice(price, event.currency);
                  }
                  return t("ticketing_common:price", {
                    price: exchangePrice(price, event.currency),
                    currency: symbol
                  });
                },
                region: "eu",
                onSessionInitialized: (data) => {
                  removeAllSeats();
                  onSeatsInitialized(data);
                  setMounted(true);
                },
                onObjectSelected: handleAddSeat,
                onObjectDeselected: (seat, seatInfo) => {
                  removeSeat(__spreadProps(__spreadValues({}, seat), {
                    selectedTicketType: (seatInfo == null ? void 0 : seatInfo.ticketType) || seat.selectedTicketType
                  }));
                },
                maxSelectedObjects: maxSeats,
                messages,
                onHoldTokenExpired: () => {
                  eraseCookie("holdToken");
                  onSeatsInitialized({ expiresInSeconds: 0.5 });
                },
                onChartRendered: (chart) => {
                  setChart(chart);
                },
                session: seatTickets.holdToken ? "manual" : "start",
                holdToken: seatTickets.holdToken,
                channels: allChannels.length > 0 ? allChannels : null,
                colorScheme
              }
            )
          ] })
        ]
      }
    )
  ] });
};
var SeatsIO_default = SeatsIO;

// src/components/booking/perks/PerksBanner.tsx
import { useState as useState8 } from "react";
import { ChevronIcon as ChevronIcon3, DiscountIcon, StrokeCheckIcon } from "@wbk/svg";
import { motion as motion5 } from "motion/react";
import { twMerge as twMerge4 } from "tailwind-merge";
import { useTranslation as useTranslation17 } from "@wbk/config";
import { jsx as jsx21, jsxs as jsxs17 } from "react/jsx-runtime";
var PerksBanner = ({ className }) => {
  const { userPerks, eventTickets, appliedPerks } = useBooking_default();
  const { t } = useTranslation17("ticketing_booking");
  const [expanded, setExpanded] = useState8(true);
  if (!(userPerks == null ? void 0 : userPerks.length))
    return null;
  return /* @__PURE__ */ jsxs17(
    "div",
    {
      className: twMerge4(
        "border-text/20 overflow-hidden rounded-xl border bg-[#14532D]",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs17(
          "button",
          {
            "aria-expanded": expanded,
            "aria-controls": "perks-info",
            className: "group flex w-full items-center gap-3 px-6 py-4 text-start",
            onClick: () => setExpanded(!expanded),
            children: [
              /* @__PURE__ */ jsx21(DiscountIcon, { className: "shrink-0" }),
              /* @__PURE__ */ jsx21("p", { className: "grow lg:text-lg", children: t("ticketing_booking:perks.promotion_available", { count: userPerks.length }) }),
              /* @__PURE__ */ jsx21(ChevronIcon3, { className: "h-4 w-4 shrink-0 rotate-90 transition-transform group-aria-expanded:-rotate-90" })
            ]
          }
        ),
        /* @__PURE__ */ jsx21(
          motion5.div,
          {
            animate: { height: expanded ? "auto" : 0 },
            transition: { ease: "linear", duration: 0.2 },
            className: "overflow-hidden bg-black/20",
            id: "perks-info",
            children: /* @__PURE__ */ jsxs17("div", { className: "space-y-6 p-6", children: [
              /* @__PURE__ */ jsx21("ul", { className: "space-y-3", children: userPerks.map((perk) => {
                const isApplied = appliedPerks.some((p) => p.perk._id === perk._id);
                const tickets = eventTickets.filter(
                  (ticket) => perk.eligible_event_ticket_ids.includes(ticket._id)
                );
                const ticketTitle = tickets.map((t2) => t2.title).join(` ${t("ticketing_booking:perks.or")} `);
                return /* @__PURE__ */ jsxs17("li", { className: "flex items-center gap-3", children: [
                  /* @__PURE__ */ jsx21(DiscountIcon, { className: "shrink-0" }),
                  /* @__PURE__ */ jsxs17("div", { className: "grow", children: [
                    /* @__PURE__ */ jsx21("p", { className: "lg:text-lg", children: perk.title }),
                    /* @__PURE__ */ jsx21("p", { className: "text-sm", children: t("ticketing_booking:perks.benefits", {
                      count: perk.user_remaining_tickets,
                      name: ticketTitle,
                      discount: `${perk.discount_percentage}%`
                    }) })
                  ] }),
                  isApplied && /* @__PURE__ */ jsxs17("div", { className: "flex shrink-0 items-center gap-1 text-[#22C55E]", children: [
                    /* @__PURE__ */ jsx21(StrokeCheckIcon, { className: "shrink-0" }),
                    /* @__PURE__ */ jsx21("span", { className: "text-sm", children: t("ticketing_booking:perks.applied") })
                  ] })
                ] }, perk._id);
              }) }),
              /* @__PURE__ */ jsx21("p", { className: "text-text-700 text-xs", children: t("ticketing_booking:perks.tc") })
            ] })
          }
        )
      ]
    }
  );
};
var PerksBanner_default = PerksBanner;

// src/components/booking/resell/Status.tsx
import { useTranslation as useTranslation18 } from "@wbk/config";
import { Typography as Typography5 } from "@wbk/ui";
import { twMerge as twMerge5 } from "tailwind-merge";
import { ShieldIcon as ShieldIcon2 } from "@wbk/svg";
import { jsx as jsx22, jsxs as jsxs18 } from "react/jsx-runtime";
var ResellStatus = ({ event, className }) => {
  const { t } = useTranslation18("ticketing_event");
  return /* @__PURE__ */ jsxs18("div", { className: twMerge5("space-y-4 pb-4", className), children: [
    /* @__PURE__ */ jsx22(Typography5, { variant: "heading-XS", children: t("ticketing_event:resell.other_options") }),
    /* @__PURE__ */ jsx22(Button_default, { slug: event.slug, className: "h-12 w-full max-w-md" }),
    /* @__PURE__ */ jsxs18(Typography5, { variant: "body-S", className: "text-success max-w-md text-center", children: [
      /* @__PURE__ */ jsx22(ShieldIcon2, { className: "inline h-5 w-5" }),
      /* @__PURE__ */ jsx22("span", { className: "ms-1", children: t("ticketing_event:resell.guarentee") })
    ] })
  ] });
};
var Status_default = ResellStatus;

// src/components/booking/BookingSection.tsx
import { Fragment as Fragment9, jsx as jsx23, jsxs as jsxs19 } from "react/jsx-runtime";
var BookingSection = () => {
  const { event, showResell, time_slots, isSeated } = useBooking_default();
  const { ticketsSummaryEvent } = useAnalytics2();
  const { t } = useTranslation19("ticketing_booking");
  const { soldout } = soldout_default();
  useEffect7(() => {
    var _a, _b, _c;
    if (event) {
      const selectedSlot = (_b = (_a = Object.values(time_slots || {})) == null ? void 0 : _a[0]) == null ? void 0 : _b[0];
      ticketsSummaryEvent({
        event: __spreadProps(__spreadValues({}, event), {
          zone: (_c = event.zone) == null ? void 0 : _c.slug,
          start_date_time: selectedSlot ? new Date(parseDateString3(selectedSlot.time_from)).getTime() / 1e3 : event.start_date_time
        }),
        price: event.event_start_price + event.event_start_price_vat
      });
    }
  }, []);
  return /* @__PURE__ */ jsxs19("div", { children: [
    !!soldout && showResell && /* @__PURE__ */ jsx23(Status_default, { event, className: "mx-auto max-w-md" }),
    soldout ? /* @__PURE__ */ jsx23("div", { className: "border-paper relative inset-0 z-10 flex min-h-[300px] grow items-center justify-center space-y-6 rounded-xl border", children: /* @__PURE__ */ jsx23(EmptyTickets_default, { text: t("ticketing_booking:no_tickets_available") }) }) : /* @__PURE__ */ jsxs19(Fragment9, { children: [
      isSeated ? /* @__PURE__ */ jsx23(SeatsIO_default, {}) : /* @__PURE__ */ jsx23(TicketsList_default, {}),
      /* @__PURE__ */ jsx23(PerksBanner_default, { className: "mt-4 lg:hidden" })
    ] })
  ] });
};
var BookingSection_default = BookingSection;

// src/components/booking/teams/TeamsSelection.tsx
import { Controller as Controller4, useFormContext as useFormContext4 } from "react-hook-form";
import { Checkbox, ToggleGroup as ToggleGroup3 } from "@wbk/ui";
import { useUpdateProfile } from "@wbk/api/hooks";
import { scrollIntoElementId } from "@wbk/utils";
import { CheckIcon } from "@wbk/svg";
import { Trans, useRouter as useRouter7, useTranslation as useTranslation20 } from "@wbk/config";
import { Fragment as Fragment10, jsx as jsx24, jsxs as jsxs20 } from "react/jsx-runtime";
var TeamsSelection = () => {
  var _a, _b, _c, _d, _h, _i;
  const { user, setCheckoutMode, event, setFavoriteTeam } = useBooking_default();
  const { locale } = useRouter7();
  const { t } = useTranslation20(["ticketing_common", "ticketing_booking"]);
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useFormContext4();
  const { mutateAsync: updateProfile, error } = useUpdateProfile({ lang: locale });
  const errorMsg = (error == null ? void 0 : error.message) || t("ticketing_common:unknown_error");
  const onSubmit = (data) => __async(void 0, null, function* () {
    try {
      updateProfile({ user: __spreadProps(__spreadValues({}, user), { favorite_team: data.favorite_team }) });
    } finally {
      setFavoriteTeam(data.favorite_team);
      setCheckoutMode((event == null ? void 0 : event.time_slots) ? "calendar" : "tickets");
      setTimeout(() => {
        scrollIntoElementId("main");
      }, 0);
    }
  });
  const teamOptions = [
    {
      value: ((_a = event == null ? void 0 : event.home_team) == null ? void 0 : _a._id) || "",
      text: /* @__PURE__ */ jsxs20(Fragment10, { children: [
        /* @__PURE__ */ jsx24(CheckIcon, { className: "text-primary [&>path]:fill-primary-contrast absolute top-2 group-data-[state=off]:opacity-0 ltr:right-2 rtl:left-2" }),
        /* @__PURE__ */ jsx24(
          "img",
          {
            src: (_b = event == null ? void 0 : event.home_team) == null ? void 0 : _b.logo,
            width: 100,
            height: 100,
            className: "mx-auto grow object-cover",
            alt: ""
          }
        ),
        /* @__PURE__ */ jsx24("p", { className: "text-text", children: event == null ? void 0 : event.home_team.name })
      ] })
    },
    {
      value: ((_c = event == null ? void 0 : event.away_team) == null ? void 0 : _c._id) || "",
      text: /* @__PURE__ */ jsxs20(Fragment10, { children: [
        /* @__PURE__ */ jsx24(CheckIcon, { className: "text-primary [&>path]:fill-primary-contrast absolute top-2 group-data-[state=off]:opacity-0 ltr:right-2 rtl:left-2" }),
        /* @__PURE__ */ jsx24(
          "img",
          {
            src: (_d = event == null ? void 0 : event.away_team) == null ? void 0 : _d.logo,
            width: 100,
            height: 100,
            className: "mx-auto object-cover",
            alt: ""
          }
        ),
        /* @__PURE__ */ jsx24("p", { className: "text-text", children: event == null ? void 0 : event.away_team.name })
      ] })
    }
  ];
  return /* @__PURE__ */ jsx24("form", { id: "booking-form-teams", className: "space-y-4", onSubmit: handleSubmit(onSubmit), children: /* @__PURE__ */ jsxs20("div", { className: "border-paper space-y-4 rounded-xl border p-4", children: [
    /* @__PURE__ */ jsxs20("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsx24("h2", { className: "text-2xl", children: t("ticketing_booking:select_your_team") }),
      /* @__PURE__ */ jsx24("p", { className: "text-text-secondary pb-4 text-sm lg:text-base", children: t("ticketing_booking:select_team_text") })
    ] }),
    /* @__PURE__ */ jsx24(
      Controller4,
      {
        name: "favorite_team",
        control,
        defaultValue: "",
        rules: {
          required: t("ticketing_common:validation.required")
        },
        render: ({ field }) => {
          const _a2 = field, { onChange, value } = _a2, props = __objRest(_a2, ["onChange", "value"]);
          return /* @__PURE__ */ jsx24(
            ToggleGroup3,
            __spreadProps(__spreadValues({}, props), {
              label: "",
              type: "single",
              value,
              options: teamOptions,
              onChange,
              separator: /* @__PURE__ */ jsx24("span", { className: "self-center", children: "VS" }),
              groupClassName: "mx-auto flex max-w-xl pb-4 flex-nowrap",
              className: "border-paper data-[state=on]:border-primary data-[state=on]:bg-action/10 group max-w-full border-2 data-[state=on]:border-2"
            })
          );
        }
      }
    ),
    /* @__PURE__ */ jsx24(
      Controller4,
      {
        name: "team_terms",
        control,
        rules: {
          required: t("ticketing_common:validation.required")
        },
        defaultValue: false,
        render: (_e) => {
          var { field: _f } = _e, _g = _f, { onChange, value } = _g, props = __objRest(_g, ["onChange", "value"]);
          var _a2;
          return /* @__PURE__ */ jsx24(
            Checkbox,
            __spreadProps(__spreadValues({}, props), {
              label: /* @__PURE__ */ jsx24("p", { className: "text-sm lg:text-base", children: /* @__PURE__ */ jsx24(Trans, { i18nKey: "favorite_team_terms", ns: "ticketing_booking", children: /* @__PURE__ */ jsx24("strong", {}) }) }),
              className: "ltr:mt-0.5",
              groupClassName: "px-1",
              checked: value,
              onChange: (v) => onChange(v),
              error: (_a2 = errors.team_terms) == null ? void 0 : _a2.message,
              "data-testid": "ticketing_teams_terms_checkbox"
            })
          );
        }
      }
    ),
    (((_h = errors.favorite_team) == null ? void 0 : _h.message) || error && errorMsg) && /* @__PURE__ */ jsx24("p", { className: "text-error text-center", children: ((_i = errors.favorite_team) == null ? void 0 : _i.message) || errorMsg })
  ] }) });
};
var TeamsSelection_default = TeamsSelection;

// src/components/booking/calendar/CalendarSlots.tsx
import { useEffect as useEffect8, useMemo as useMemo9 } from "react";
import { Button as Button10, DayPicker } from "@wbk/ui";
import { useGetTicketingEventSlots } from "@wbk/api/hooks";
import { formatDate as formatDate3, isEqual, splitDateTime } from "@wbk/utils";
import { twMerge as twMerge6 } from "tailwind-merge";
import { useRouter as useRouter8, useTranslation as useTranslation21 } from "@wbk/config";
import { Fragment as Fragment11, jsx as jsx25, jsxs as jsxs21 } from "react/jsx-runtime";
var CalendarSlots = () => {
  const { locale } = useRouter8();
  const { event, eventTickets, selectSlot, slotState, setSlotState, time_slots, isSeated } = useBooking_default();
  const { data, isLoading, error } = useGetTicketingEventSlots(
    {
      slug: event.slug,
      day: (slotState == null ? void 0 : slotState.selectedDay) || "",
      lang: locale
    },
    {
      enabled: !!(slotState == null ? void 0 : slotState.selectedDay)
    }
  );
  const { t } = useTranslation21(["ticketing_booking"]);
  const availableDates = (event == null ? void 0 : event.time_slots) || [];
  const firstAvailableThreeMonths = useMemo9(() => {
    const dates = [];
    const availableDates2 = (event == null ? void 0 : event.time_slots) || [];
    for (const day of availableDates2) {
      if (dates.length > 2) {
        break;
      }
      const year = new Date(day).getFullYear();
      const month = new Date(day).getMonth();
      const dayOfMonth = new Date(day).getDate();
      const exists = dates.some((m) => m.year === year && m.month === month);
      if (!exists) {
        dates.push({ year, month, day: dayOfMonth });
      }
    }
    return dates;
  }, [event == null ? void 0 : event.time_slots]);
  useEffect8(() => {
    var _a, _b;
    if ((data == null ? void 0 : data.length) === 1) {
      const hasCapacity = isSeated || hasSomeTicketsForSale(eventTickets, data[0]);
      const soldout = ((_a = data == null ? void 0 : data[0]) == null ? void 0 : _a.is_soldout) || !hasCapacity;
      if (!soldout && hasCapacity && (slotState == null ? void 0 : slotState.selectedDay) && !((_b = time_slots == null ? void 0 : time_slots[slotState.selectedDay]) == null ? void 0 : _b.length)) {
        selectSlot({ [slotState.selectedDay]: [data[0]] });
      }
    }
  }, [data, slotState == null ? void 0 : slotState.selectedDay]);
  useEffect8(() => {
    if (firstAvailableThreeMonths == null ? void 0 : firstAvailableThreeMonths.length) {
      const first = firstAvailableThreeMonths[0];
      setSlotState({ selectedMonth: new Date(first.year, first.month) });
    }
  }, [firstAvailableThreeMonths]);
  return /* @__PURE__ */ jsx25("div", { className: "relative space-y-4", children: !availableDates.length ? /* @__PURE__ */ jsx25(Fragment11, { children: /* @__PURE__ */ jsx25("div", { className: "relative inset-0 z-10 flex min-h-[300px] items-center justify-center", children: /* @__PURE__ */ jsx25(EmptyTickets_default, { text: t("ticketing_booking:no_time_slots") }) }) }) : /* @__PURE__ */ jsxs21("div", { children: [
    /* @__PURE__ */ jsx25("h2", { className: "pb-2 text-2xl", children: t("ticketing_booking:select_day_time") }),
    /* @__PURE__ */ jsx25(
      DayPicker,
      {
        className: "border-paper w-full rounded-xl border p-4",
        mode: "single",
        selected: slotState == null ? void 0 : slotState.selectedDate,
        month: slotState == null ? void 0 : slotState.selectedMonth,
        lang: locale,
        weekStartsOn: 0,
        components: {
          Caption() {
            return /* @__PURE__ */ jsx25("div", { className: "flex flex-wrap gap-2 pb-2", children: firstAvailableThreeMonths.map((date) => {
              var _a;
              const dateFromMonth = new Date(date.year, date.month);
              return /* @__PURE__ */ jsx25(
                MonthButton,
                {
                  lang: locale,
                  date: dateFromMonth.getTime(),
                  "data-testid": `ticketing_calendar_month_button_${date.month}`,
                  isActive: dateFromMonth.getMonth() === ((_a = slotState == null ? void 0 : slotState.selectedMonth) == null ? void 0 : _a.getMonth()),
                  onClick: () => {
                    setSlotState({ selectedMonth: dateFromMonth });
                  },
                  disabled: isLoading
                },
                `${date.year}-${date.month}`
              );
            }) });
          },
          Row: ({ dates }) => {
            const hasSelectedInRow = (slotState == null ? void 0 : slotState.selectedDate) && dates.some((date) => isEqual(date, slotState.selectedDate));
            return /* @__PURE__ */ jsxs21(Fragment11, { children: [
              /* @__PURE__ */ jsx25("tr", { className: "h-full", children: dates.map((date) => {
                const selected = (slotState == null ? void 0 : slotState.selectedDate) && isEqual(date, slotState.selectedDate);
                const day = splitDateTime(date, "en", {
                  month: "2-digit",
                  timeZone: void 0
                }).date;
                const available = availableDates.includes(day);
                return /* @__PURE__ */ jsx25("td", { className: "p-0", children: /* @__PURE__ */ jsx25(
                  "button",
                  {
                    name: "day",
                    "data-testid": `ticketing_calendar_day_button_${day}`,
                    className: twMerge6(
                      "hover:bg-primary/10 focus:bg-primary/20 flex w-full flex-col items-center justify-center rounded-md py-2 disabled:pointer-events-none disabled:cursor-default",
                      selected ? "border-primary bg-primary/20 text-primary focus:bg-primary focus:bg-primary/40 border-2 disabled:opacity-60" : "disabled:opacity-30"
                    ),
                    role: "gridcell",
                    type: "button",
                    disabled: isLoading || !available,
                    onClick: () => {
                      setSlotState({
                        selectedDate: date,
                        selectedMonth: date,
                        selectedDay: day
                      });
                      selectSlot();
                    },
                    children: /* @__PURE__ */ jsx25("p", { children: date.getDate() })
                  }
                ) }, date.getDate());
              }) }),
              hasSelectedInRow && /* @__PURE__ */ jsxs21(Fragment11, { children: [
                /* @__PURE__ */ jsx25("tr", { children: /* @__PURE__ */ jsx25("td", { className: "h-2" }) }),
                /* @__PURE__ */ jsx25("tr", { children: /* @__PURE__ */ jsxs21("td", { colSpan: 7, className: "bg-paper-level-1 mt-1 rounded-md p-2", children: [
                  /* @__PURE__ */ jsx25("p", { className: "text-text text-sm", children: t("ticketing_booking:preferred_time") }),
                  /* @__PURE__ */ jsx25("div", { className: "flex flex-wrap gap-2 py-2", children: isLoading ? /* @__PURE__ */ jsx25("div", { className: "flex flex-wrap gap-2", children: [1, 2, 3, 4].map((idx) => /* @__PURE__ */ jsx25(
                    "div",
                    {
                      className: "bg-body-level-2 h-8 w-32 animate-pulse rounded-md"
                    },
                    idx
                  )) }) : (data == null ? void 0 : data.length) ? data == null ? void 0 : data.map((slot, i) => {
                    var _a, _b, _c, _d;
                    const from = (_a = slot.time_from) == null ? void 0 : _a.split(" ");
                    const to = (_b = slot.time_to) == null ? void 0 : _b.split(" ");
                    const hasCapacity = isSeated || hasSomeTicketsForSale(eventTickets, slot);
                    const soldout = (slot == null ? void 0 : slot.is_soldout) || !hasCapacity;
                    const isSelected = ((_d = (_c = Object.values(time_slots || {})) == null ? void 0 : _c[0]) == null ? void 0 : _d[0]) === slot || (data == null ? void 0 : data.length) === 1 && !soldout;
                    const isSingleSlot = (data == null ? void 0 : data.length) === 1 && !soldout;
                    const slotLabel = slot.label ? slot.label : `${from[1] || from[0]} - ${to[1] || to[0]}`;
                    return /* @__PURE__ */ jsx25(
                      Button10,
                      {
                        shape: isSelected ? "solid" : "outlined",
                        theme: isSelected ? "primary" : "white",
                        "data-testid": `ticketing_calendar_timeslot_button_${slotLabel}`,
                        "aria-selected": isSelected,
                        className: `border-input-border ${slot.text_color ? "text-[var(--color)]" : "text-text"} ${slot.background ? "bg-[var(--bg)]" : ""} aria-selected:bg-primary-700 aria-selected:text-primary-contrast aria-selected:border-primary h-[34px] border px-2 text-sm disabled:border-none disabled:bg-transparent`,
                        style: {
                          "--color": slot.text_color || "",
                          "--bg": slot.background || ""
                        },
                        onClick: () => {
                          if (slotState == null ? void 0 : slotState.selectedDay) {
                            selectSlot({ [slotState.selectedDay]: [slot] });
                          }
                        },
                        phill: false,
                        rounded: true,
                        disabled: soldout || isSingleSlot,
                        children: /* @__PURE__ */ jsxs21("div", { className: "flex flex-col items-center", children: [
                          /* @__PURE__ */ jsx25("p", { className: `${soldout ? "line-through" : ""}`, children: slotLabel }),
                          /* @__PURE__ */ jsx25("p", { className: `${soldout ? "block text-xs" : "hidden"}`, children: t("ticketing_booking:sold_out") })
                        ] })
                      },
                      i
                    );
                  }) : /* @__PURE__ */ jsx25(
                    EmptyTickets_default,
                    {
                      text: (error == null ? void 0 : error.message) || t("ticketing_booking:no_tickets_available")
                    }
                  ) })
                ] }) })
              ] })
            ] });
          }
        }
      }
    )
  ] }) });
};
var MonthButton = (_a) => {
  var _b = _a, { lang, date, isActive, onClick } = _b, props = __objRest(_b, ["lang", "date", "isActive", "onClick"]);
  return /* @__PURE__ */ jsx25(
    Button10,
    __spreadProps(__spreadValues({
      onClick,
      shape: isActive ? "solid" : "outlined",
      theme: isActive ? "primary" : "white",
      "aria-selected": isActive,
      className: "border-input-border text-text/80 aria-selected:bg-primary-700 aria-selected:text-primary-contrast aria-selected:border-primary h-[34px] min-w-[80px] border px-2 text-sm",
      phill: false,
      rounded: true
    }, props), {
      children: formatDate3(date / 1e3, `${lang}-GB`, { month: "long", timeZone: void 0 })
    })
  );
};
var CalendarSlots_default = CalendarSlots;

// src/components/booking/summary/SummarySidebar.tsx
import { useMemo as useMemo11 } from "react";
import { BookingTotals } from "@wbk/payment";
import { Trans as Trans3, useTranslation as useTranslation26 } from "@wbk/config";

// src/components/booking/summary/EventSummary.tsx
import { formatDate as formatDate4 } from "@wbk/utils";
import { twMerge as twMerge7 } from "tailwind-merge";
import { ImageWithPlaceholder } from "@wbk/ui";
import { useRouter as useRouter9 } from "@wbk/config";
import { jsx as jsx26, jsxs as jsxs22 } from "react/jsx-runtime";
var EventSummary = ({ className }) => {
  const { locale } = useRouter9();
  const { event, eventType } = useBooking_default();
  const withTimeSlots = !!event.time_slots;
  const showBadge = /^(riyadh_season|premium|wbk(?!_not).*)$/.test(eventType || "");
  return /* @__PURE__ */ jsxs22("div", { className: twMerge7("flex items-center gap-4", className), children: [
    /* @__PURE__ */ jsxs22("div", { className: "rounded-S group relative h-[110px] w-[110px] shrink-0 overflow-hidden", children: [
      /* @__PURE__ */ jsx26(
        ImageWithPlaceholder,
        {
          src: event.mobile_poster || event.poster,
          className: "h-full w-full shrink-0 rounded-lg object-cover group-data-[poster=true]:h-24 group-data-[poster=true]:w-[107px]"
        }
      ),
      showBadge && /* @__PURE__ */ jsx26("div", { className: "ltr:rounded-tl-L rtl:rounded-tr-L absolute bottom-0 flex h-7 w-7 items-center justify-center bg-white ltr:right-0 rtl:left-0", children: /* @__PURE__ */ jsx26(
        "img",
        {
          src: eventType === "riyadh_season" ? "/@wbk/ticketing/season/riyadh_season.svg" : "/@wbk/ticketing/season/premium.svg",
          className: "h-4 w-4 shrink-0 translate-y-px ltr:translate-x-px rtl:-translate-x-px",
          alt: ""
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs22("div", { children: [
      /* @__PURE__ */ jsx26("p", { className: "line-clamp-2 text-lg font-semibold", children: event.title }),
      /* @__PURE__ */ jsx26("p", { className: "text-text-secondary text-sm", children: event.address }),
      /* @__PURE__ */ jsx26("p", { className: "text-text-secondary text-xs", children: withTimeSlots ? /* @__PURE__ */ jsx26(TimeSlotRange_default, {}) : formatDate4(event.start_date_time, locale, {
        dateStyle: "medium",
        timeStyle: "short",
        timeZone: void 0
      }) })
    ] })
  ] });
};
var EventSummary_default = EventSummary;

// src/components/booking/summary/TicketsSummary.tsx
import { useFormContext as useFormContext5 } from "react-hook-form";
import { useTranslation as useTranslation22 } from "@wbk/config";

// src/components/booking/summary/PlanSummaryRow.tsx
import { CurrencyPriceLabel as CurrencyPriceLabel5 } from "@wbk/currency";
import { dateAdd as dateAdd2, formatDate as formatDate5 } from "@wbk/utils";
import { Trans as Trans2, useRouter as useRouter10 } from "@wbk/config";
import { jsx as jsx27, jsxs as jsxs23 } from "react/jsx-runtime";
var PlanSummaryRow = ({ plan }) => {
  var _a;
  const { locale } = useRouter10();
  const { subscription } = useBooking_default();
  if (!subscription)
    return null;
  return /* @__PURE__ */ jsxs23("li", { className: "space-y-4", children: [
    /* @__PURE__ */ jsxs23("div", { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsxs23("div", { className: "flex grow items-center gap-2 text-xs sm:gap-2 md:text-sm", children: [
        /* @__PURE__ */ jsx27(
          "img",
          {
            src: plan.icon,
            alt: plan.name,
            width: 16,
            height: 16,
            className: "h-4 w-4 shrink-0"
          }
        ),
        /* @__PURE__ */ jsx27("p", { children: plan.name })
      ] }),
      /* @__PURE__ */ jsx27(
        CurrencyPriceLabel5,
        {
          className: "text-xs md:text-sm",
          originalPrice: plan.price + plan.vat,
          currency: plan.currency
        }
      )
    ] }),
    !subscription.plan.disable_auto_renewal && /* @__PURE__ */ jsx27("p", { className: "text-text-secondary text-sm", children: /* @__PURE__ */ jsxs23(
      Trans2,
      {
        i18nKey: "subscription_common:next_payment_for_subscription",
        values: {
          plan: subscription.plan.name,
          billing_option: ((_a = subscription.plan.payment_terms) == null ? void 0 : _a.toLowerCase()) || "",
          date: formatDate5(
            dateAdd2({
              date: /* @__PURE__ */ new Date(),
              interval: "day",
              value: Number(subscription.plan.duration) || 0
            }),
            locale,
            { year: "numeric", month: "short", day: "numeric" }
          )
        },
        children: [
          /* @__PURE__ */ jsx27("span", { className: "font-medium" }),
          /* @__PURE__ */ jsx27("span", { className: "font-medium" })
        ]
      }
    ) })
  ] });
};
var PlanSummaryRow_default = PlanSummaryRow;

// src/components/booking/summary/TicketsSummary.tsx
import { jsx as jsx28, jsxs as jsxs24 } from "react/jsx-runtime";
var TicketsSummary = ({ className }) => {
  const { t } = useTranslation22(["ticketing_booking", "subscription_common"]);
  const { plainTickets, seatTickets, checkout: checkout2, subscription, isSeated } = useBooking_default();
  const { handleSubmit } = useFormContext5();
  return /* @__PURE__ */ jsxs24("form", { className, id: "ticket-checkout-form", onSubmit: handleSubmit(checkout2), children: [
    /* @__PURE__ */ jsx28("h2", { className: "pb-3 text-2xl", children: t("ticketing_booking:summary") }),
    /* @__PURE__ */ jsx28("h3", { className: "pb-1 text-lg font-semibold", children: t("ticketing_booking:tickets") }),
    /* @__PURE__ */ jsx28("ul", { id: "event-tickets", className: "space-y-2", children: isSeated ? seatTickets.selectedTickets.map((ticket, idx) => /* @__PURE__ */ jsx28(TicketSummaryRow_default, { ticket, isSeated: true }, ticket._id + idx)) : plainTickets.map((ticket, idx) => /* @__PURE__ */ jsx28(TicketSummaryRow_default, { ticket }, idx)) }),
    subscription && /* @__PURE__ */ jsxs24("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx28("h3", { className: "text-lg font-semibold", children: t("ticketing_booking:subscriptions") }),
      /* @__PURE__ */ jsx28("ul", { id: "subscription-tickets", className: "space-y-1", children: /* @__PURE__ */ jsx28(PlanSummaryRow_default, { plan: subscription.plan }) })
    ] })
  ] });
};
var TicketsSummary_default = TicketsSummary;

// src/components/booking/summary/MerchandiseSummary.tsx
import { CurrencyPriceLabel as CurrencyPriceLabel7 } from "@wbk/currency";
import { BasketIcon } from "@wbk/svg";
import { Button as Button12, ImageWithFallback as ImageWithFallback2 } from "@wbk/ui";
import { useTranslation as useTranslation24 } from "@wbk/config";

// src/components/booking/merchandise/BookProductModal.tsx
import { useMemo as useMemo10, useRef as useRef3 } from "react";
import { useGetMerchandiseProduct, useHoldProducts } from "@wbk/api/hooks";
import { useDeviceDetect as useDeviceDetect4 } from "@wbk/hooks";
import { BottomSheet as BottomSheet3, Button as Button11, ImageWithPlaceholder as ImageWithPlaceholder2, Modal as Modal3, Toast as Toast2, ToggleGroup as ToggleGroup4 } from "@wbk/ui";
import { Controller as Controller5, FormProvider as FormProvider2, useForm as useForm3, useFormContext as useFormContext6 } from "react-hook-form";
import { useAuth as useAuth3 } from "@wbk/auth";
import { AddIcon as AddIcon2, MinusIcon as MinusIcon2 } from "@wbk/svg";
import { useRouter as useRouter11, useTranslation as useTranslation23 } from "@wbk/config";

// src/components/booking/merchandise/ProductPrice.tsx
import { CurrencyPriceLabel as CurrencyPriceLabel6 } from "@wbk/currency";
import { calculareDiscountPercentage } from "@wbk/utils";
import { jsx as jsx29, jsxs as jsxs25 } from "react/jsx-runtime";
var ProductPrice = ({ product, className }) => {
  const salePrice = getActualProductPrice(product);
  const originalPrice = getOriginalProductPrice(product);
  const hasDiscount = salePrice < originalPrice;
  return /* @__PURE__ */ jsxs25("div", { className, children: [
    hasDiscount && /* @__PURE__ */ jsxs25("div", { className: "flex items-center gap-1 text-xs", children: [
      /* @__PURE__ */ jsx29(
        CurrencyPriceLabel6,
        {
          className: "text-text-secondary line-through",
          originalPrice,
          currency: "SAR"
        }
      ),
      /* @__PURE__ */ jsx29("p", { className: "bg-success-light/15 text-success-light rounded-sm px-1 py-0.5", children: `${calculareDiscountPercentage(originalPrice, salePrice)}%` })
    ] }),
    /* @__PURE__ */ jsx29(CurrencyPriceLabel6, { originalPrice: salePrice, currency: "SAR" })
  ] });
};
var ProductPrice_default = ProductPrice;

// src/components/booking/merchandise/BookProductModal.tsx
import { Fragment as Fragment12, jsx as jsx30, jsxs as jsxs26 } from "react/jsx-runtime";
var BookProductModal = ({ render, productId, defaultValues }) => {
  const { isMobile } = useDeviceDetect4();
  const { locale } = useRouter11();
  const { t } = useTranslation23(["ticketing_common"]);
  const form = useForm3({ defaultValues });
  const toast = useRef3(void 0);
  const { data, isPending, error, refetch } = useGetMerchandiseProduct(
    {
      lang: locale,
      id: productId.toString()
    },
    {
      enabled: false,
      staleTime: Infinity,
      gcTime: Infinity
    }
  );
  const handleError = (error2) => {
    var _a, _b;
    const errorData = error2;
    (_b = toast.current) == null ? void 0 : _b.publish({
      title: ((_a = errorData == null ? void 0 : errorData.error) == null ? void 0 : _a.message) || t("ticketing_common:unknown_error"),
      type: "error",
      icon: true
    });
  };
  const handleSuccess = () => {
    var _a;
    (_a = toast.current) == null ? void 0 : _a.publish({
      title: t("ticketing_booking:merchandise.product_added_to_cart"),
      type: "success",
      icon: true
    });
  };
  return /* @__PURE__ */ jsxs26(Fragment12, { children: [
    /* @__PURE__ */ jsx30(Toast2, { ref: toast }),
    /* @__PURE__ */ jsx30(FormProvider2, __spreadProps(__spreadValues({}, form), { children: isMobile ? /* @__PURE__ */ jsx30(
      BottomSheet3,
      {
        className: "z-[100] pb-28",
        render: (props) => {
          return render(__spreadProps(__spreadValues({}, props), {
            open: () => {
              refetch();
              props.open();
            }
          }));
        },
        body: ({ close }) => {
          if (isPending) {
            return /* @__PURE__ */ jsx30(Skeleton, {});
          }
          if (error || !data) {
            return /* @__PURE__ */ jsxs26("div", { className: "text-error p-6 text-center", children: [
              /* @__PURE__ */ jsx30("p", { children: (error == null ? void 0 : error.message) || t("ticketing_booking:merchandise.no_products_found") }),
              /* @__PURE__ */ jsx30(Button11, { theme: "action", shape: "outlined", onClick: close, className: "mt-4", children: t("ticketing_common:close") })
            ] });
          }
          return /* @__PURE__ */ jsx30(
            Body,
            {
              close,
              product: data,
              onError: handleError,
              onSuccess: handleSuccess
            }
          );
        },
        stickyFooter: () => /* @__PURE__ */ jsx30(Footer, { product: data })
      }
    ) : /* @__PURE__ */ jsx30(
      Modal3,
      {
        size: "4xl",
        className: "pb-28",
        render: (props) => {
          return render(__spreadProps(__spreadValues({}, props), {
            open: () => {
              refetch();
              props.open();
            }
          }));
        },
        closeButton: true,
        body: ({ close }) => {
          if (isPending) {
            return /* @__PURE__ */ jsx30(Skeleton, {});
          }
          if (error || !data) {
            return /* @__PURE__ */ jsxs26("div", { className: "text-error p-6 text-center", children: [
              /* @__PURE__ */ jsx30("p", { children: (error == null ? void 0 : error.message) || t("ticketing_booking:merchandise.no_products_found") }),
              /* @__PURE__ */ jsx30(Button11, { theme: "action", shape: "outlined", onClick: close, className: "mt-4", children: t("ticketing_common:cancel") })
            ] });
          }
          return /* @__PURE__ */ jsx30(
            Body,
            {
              close,
              product: data,
              onError: handleError,
              onSuccess: handleSuccess
            }
          );
        },
        stickyFooter: () => /* @__PURE__ */ jsx30(Footer, { product: data })
      }
    ) }))
  ] });
};
var Body = ({
  close,
  product,
  onError,
  onSuccess
}) => {
  const { addMerchandiseProduct } = useBooking_default();
  const { locale } = useRouter11();
  const { t } = useTranslation23(["ticketing_common", "ticketing_booking"]);
  const { user } = useAuth3();
  const { watch, control, handleSubmit, setValue } = useFormContext6();
  const variation = watch("variation");
  const { mutateAsync: holdProduct } = useHoldProducts();
  const onSubmit = (values) => __async(void 0, null, function* () {
    var _a;
    try {
      setValue("loading", true);
      yield holdProduct({
        userId: (user == null ? void 0 : user._id) || "",
        email: (user == null ? void 0 : user.email) || "",
        products: [{ id: ((_a = values.variation) == null ? void 0 : _a.ID) || product.ID, quantity: values.qty }],
        lang: locale
      });
      addMerchandiseProduct({ qty: values.qty, product, variation });
      onSuccess == null ? void 0 : onSuccess();
      close();
    } catch (error) {
      onError == null ? void 0 : onError(error);
    } finally {
      setValue("loading", false);
    }
  });
  return /* @__PURE__ */ jsxs26(
    "form",
    {
      onSubmit: handleSubmit(onSubmit),
      id: "addProductForm",
      className: "flex flex-col gap-6 p-6 lg:flex-row",
      children: [
        /* @__PURE__ */ jsx30("div", { className: "mx-auto max-w-md shrink-0 lg:max-w-sm", children: /* @__PURE__ */ jsx30(
          ImageWithPlaceholder2,
          {
            src: (variation == null ? void 0 : variation.image_url) || product.featured_image_url,
            className: "w-full rounded-xl",
            alt: product.title.rendered
          }
        ) }),
        /* @__PURE__ */ jsxs26("div", { className: "grow space-y-6", children: [
          /* @__PURE__ */ jsxs26("div", { className: "space-y-4", children: [
            /* @__PURE__ */ jsx30("h1", { className: "text-3xl", children: product.title.rendered }),
            /* @__PURE__ */ jsx30(ProductPrice_default, { product, className: "flex flex-row-reverse justify-end gap-1" })
          ] }),
          product.variations && /* @__PURE__ */ jsx30(
            Controller5,
            {
              control,
              name: "variation",
              rules: { required: t("ticketing_common:validation.required") },
              render: ({ field, fieldState: { error } }) => {
                var _a, _b;
                return /* @__PURE__ */ jsx30(
                  ToggleGroup4,
                  __spreadProps(__spreadValues({
                    error: error == null ? void 0 : error.message,
                    type: "single",
                    phill: true
                  }, field), {
                    label: /* @__PURE__ */ jsx30("span", { children: t("ticketing_booking:merchandise.size") }),
                    value: (_a = field.value) == null ? void 0 : _a.ID.toString(),
                    onChange: (value) => {
                      var _a2;
                      field.onChange((_a2 = product.variations) == null ? void 0 : _a2.find((v) => v.ID.toString() === value));
                    },
                    options: ((_b = product.variations) == null ? void 0 : _b.map((variation2) => ({
                      text: /* @__PURE__ */ jsx30("span", { className: "uppercase", children: variation2.attributes.pa_size }),
                      value: variation2.ID.toString()
                    }))) || []
                  })
                );
              }
            }
          )
        ] })
      ]
    }
  );
};
var Footer = ({ product }) => {
  var _a;
  const { t } = useTranslation23(["ticketing_common", "ticketing_booking"]);
  const { control, watch } = useFormContext6();
  const [loading, variation] = watch(["loading", "variation"]);
  const maxQty = Math.max(
    (((_a = product == null ? void 0 : product.variations) == null ? void 0 : _a.length) ? variation == null ? void 0 : variation.stock_quantity : product == null ? void 0 : product.stock_quantity) || 0,
    0
  );
  const soldOut = useMemo10(() => {
    var _a2;
    if (!product)
      return false;
    return (((_a2 = product.variations) == null ? void 0 : _a2.length) ? product.variations.reduce((acc, c) => acc + c.stock_quantity, 0) === 0 : product.stock_quantity === 0) || !!variation && maxQty === 0;
  }, [product, variation, maxQty]);
  if (!product)
    return null;
  return /* @__PURE__ */ jsxs26("div", { className: "relative flex h-24 justify-end gap-4 p-6", children: [
    soldOut ? /* @__PURE__ */ jsx30("div", { className: "text-error grow self-center text-end text-xs", children: t("ticketing_booking:merchandise.out_of_stock") }) : /* @__PURE__ */ jsx30(
      Controller5,
      {
        control,
        name: "qty",
        defaultValue: 1,
        shouldUnregister: true,
        render: ({ field }) => /* @__PURE__ */ jsxs26("div", { className: "flex shrink-0 items-center gap-1", children: [
          /* @__PURE__ */ jsx30(
            Button11,
            {
              disabled: field.value === 1,
              onClick: () => field.onChange(field.value - 1),
              shape: "outlined",
              theme: "action",
              className: "flex h-11 w-11 items-center justify-center p-1",
              children: /* @__PURE__ */ jsx30(MinusIcon2, {})
            }
          ),
          /* @__PURE__ */ jsx30("span", { className: "px-2 text-2xl font-semibold", children: field.value }),
          /* @__PURE__ */ jsx30(
            Button11,
            {
              disabled: field.value >= maxQty,
              onClick: () => field.onChange(field.value + 1),
              shape: "outlined",
              theme: "action",
              className: "flex h-11 w-11 items-center justify-center p-1",
              children: /* @__PURE__ */ jsx30(AddIcon2, {})
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx30(
      Button11,
      {
        type: "submit",
        form: "addProductForm",
        className: "min-w-[140px] grow lg:grow-0",
        loading,
        disabled: soldOut,
        children: soldOut ? t("ticketing_booking:merchandise.unavailable") : t("ticketing_booking:merchandise.add_to_booking")
      }
    )
  ] });
};
var Skeleton = () => {
  return /* @__PURE__ */ jsxs26(Fragment12, { children: [
    /* @__PURE__ */ jsxs26("div", { className: "flex w-full flex-col gap-6 p-6 lg:flex-row", children: [
      /* @__PURE__ */ jsx30("div", { className: "mx-auto w-full max-w-md lg:max-w-[356px]", children: /* @__PURE__ */ jsx30("div", { className: "aspect-1 bg-body-level-2 w-full animate-pulse rounded-xl" }) }),
      /* @__PURE__ */ jsxs26("div", { className: "w-full space-y-4", children: [
        /* @__PURE__ */ jsxs26("div", { className: "space-y-4", children: [
          /* @__PURE__ */ jsx30("div", { className: "bg-body-level-2 h-6 w-1/2 animate-pulse rounded" }),
          /* @__PURE__ */ jsx30("div", { className: "bg-body-level-2 h-6 w-1/4 animate-pulse rounded" })
        ] }),
        /* @__PURE__ */ jsxs26("div", { className: "space-y-4", children: [
          /* @__PURE__ */ jsx30("div", { className: "bg-body-level-2 h-6 w-1/2 animate-pulse rounded" }),
          /* @__PURE__ */ jsx30("div", { className: "bg-body-level-2 h-6 w-1/4 animate-pulse rounded" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx30("div", { className: "bg-body-level-2 m-4 h-12 animate-pulse rounded" })
  ] });
};
var BookProductModal_default = BookProductModal;

// src/components/booking/summary/MerchandiseSummary.tsx
import { jsx as jsx31, jsxs as jsxs27 } from "react/jsx-runtime";
var MerchandiseSummary = ({ className = "" }) => {
  const { t } = useTranslation24(["ticketing_booking", "subscription_common"]);
  const { merchandise, event } = useBooking_default();
  if (!merchandise.length)
    return null;
  return /* @__PURE__ */ jsxs27("div", { className: `${className} space-y-2`, children: [
    /* @__PURE__ */ jsx31("h3", { className: "text-lg font-semibold", children: t("ticketing_booking:merchandise.merchandise") }),
    /* @__PURE__ */ jsx31("ul", { id: "event-tickets", className: "space-y-1", children: merchandise.map((item) => {
      var _a, _b;
      const id = ((_a = item.variation) == null ? void 0 : _a.ID) || item.product.ID;
      const price = getActualProductPrice(item.product, item.variation);
      const image = ((_b = item.variation) == null ? void 0 : _b.image_url) || item.product.featured_image_url;
      const title = item.product.title.rendered + `${item.variation ? ` (${item.variation.attributes.pa_size})`.toUpperCase() : ""}`;
      return /* @__PURE__ */ jsx31("li", { children: /* @__PURE__ */ jsx31(
        BookProductModal_default,
        {
          productId: item.product.ID,
          defaultValues: { variation: item.variation },
          render: ({ open }) => /* @__PURE__ */ jsxs27(
            Button12,
            {
              shape: "text",
              theme: "white",
              className: "flex w-full items-center justify-between gap-2 p-0",
              onClick: open,
              children: [
                /* @__PURE__ */ jsxs27("div", { className: "flex grow items-center gap-1 overflow-hidden text-xs sm:gap-2 md:text-sm", children: [
                  /* @__PURE__ */ jsx31("span", { className: "min-w-3 shrink-0 text-start", children: item.qty }),
                  /* @__PURE__ */ jsx31("span", { children: "x" }),
                  /* @__PURE__ */ jsx31(
                    ImageWithFallback2,
                    {
                      width: 20,
                      height: 20,
                      src: image,
                      className: "h-5 w-5 shrink-0 rounded object-cover"
                    }
                  ),
                  /* @__PURE__ */ jsx31("p", { className: "truncate text-xs md:text-sm", children: title })
                ] }),
                /* @__PURE__ */ jsx31(
                  CurrencyPriceLabel7,
                  {
                    className: "shrink-0 text-end text-xs md:text-sm",
                    originalPrice: Number(price) * item.qty,
                    currency: "SAR"
                  }
                )
              ]
            }
          )
        }
      ) }, id);
    }) }),
    event.webook_shop_message && /* @__PURE__ */ jsxs27("div", { className: "border-paper !mt-4 flex gap-2 rounded-md border p-4", children: [
      /* @__PURE__ */ jsx31(BasketIcon, { className: "h-6 w-6 shrink-0" }),
      /* @__PURE__ */ jsx31(
        "div",
        {
          dangerouslySetInnerHTML: { __html: event.webook_shop_message },
          className: "text-sm"
        }
      )
    ] })
  ] });
};
var MerchandiseSummary_default = MerchandiseSummary;

// src/components/booking/summary/AddonsSummary.tsx
import { CurrencyPriceLabel as CurrencyPriceLabel8 } from "@wbk/currency";
import { ImageWithFallback as ImageWithFallback3 } from "@wbk/ui";
import { useTranslation as useTranslation25 } from "@wbk/config";
import { jsx as jsx32, jsxs as jsxs28 } from "react/jsx-runtime";
var AddonsSummary = ({ className = "" }) => {
  const { t } = useTranslation25(["ticketing_booking"]);
  const { addons, event } = useBooking_default();
  if (!addons.length)
    return null;
  return /* @__PURE__ */ jsxs28("div", { className: `${className} space-y-2`, children: [
    /* @__PURE__ */ jsx32("h3", { className: "text-lg font-semibold", children: t("ticketing_booking:addons") }),
    /* @__PURE__ */ jsx32("ul", { id: "event-tickets", className: "space-y-1", children: addons.map((item) => {
      return /* @__PURE__ */ jsxs28("li", { className: "flex items-center justify-between gap-2", children: [
        /* @__PURE__ */ jsxs28("div", { className: "flex grow items-center gap-1 overflow-hidden text-xs sm:gap-2 md:text-sm", children: [
          /* @__PURE__ */ jsx32("span", { className: "min-w-3 shrink-0 text-start", children: item.qty }),
          /* @__PURE__ */ jsx32("span", { children: "x" }),
          /* @__PURE__ */ jsx32(
            ImageWithFallback3,
            {
              width: 20,
              height: 20,
              src: item.thumbnail,
              className: "h-5 w-5 shrink-0 rounded object-cover"
            }
          ),
          /* @__PURE__ */ jsx32("p", { className: "truncate text-xs md:text-sm", children: item.name })
        ] }),
        /* @__PURE__ */ jsx32(
          CurrencyPriceLabel8,
          {
            className: "shrink-0 text-end text-xs md:text-sm",
            originalPrice: item.price,
            currency: event.currency
          }
        )
      ] }, item._id);
    }) })
  ] });
};
var AddonsSummary_default = AddonsSummary;

// src/components/booking/summary/SummarySidebar.tsx
import { Fragment as Fragment13, jsx as jsx33, jsxs as jsxs29 } from "react/jsx-runtime";
var SummarySidebar = () => {
  var _a;
  const { t } = useTranslation26(["ticketing_booking", "subscription_common"]);
  const { totalTickets, totals, appliedBundle, subscriptionBookingLimit, plainTickets, event } = useBooking_default();
  const isPaid = totals.gross > 0;
  const discount = useMemo11(() => {
    if (!appliedBundle)
      return 0;
    if (appliedBundle.title)
      return appliedBundle.title;
    return /* @__PURE__ */ jsx33(
      Trans3,
      {
        ns: "ticketing_booking",
        i18nKey: appliedBundle.type === "order" ? "bundle_order_offer" : "bundle_ticket_offer",
        values: {
          percentage: appliedBundle.discount,
          count: Object.values(appliedBundle.event_tickets)[0]
        },
        children: /* @__PURE__ */ jsx33("span", { className: "text-green-600" })
      }
    );
  }, [appliedBundle]);
  const subscriptionCredits = useMemo11(() => {
    var _a2, _b, _c, _d, _e, _f, _g;
    if (!event.is_live_streaming)
      return void 0;
    const selectedTicketTypeId = (_a2 = plainTickets[0]) == null ? void 0 : _a2.subscription_ticket_type_id;
    const remaining = ((_b = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _b[selectedTicketTypeId || ""]) || 0;
    const used = ((_c = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.quantities) == null ? void 0 : _c[selectedTicketTypeId || ""]) || 0;
    const plan = (_g = (_f = (_e = (_d = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.subscriptions) == null ? void 0 : _d[0]) == null ? void 0 : _e.plan) == null ? void 0 : _f.plan_group) == null ? void 0 : _g.name;
    return {
      remaining,
      used,
      plan
    };
  }, [subscriptionBookingLimit, plainTickets, event]);
  return /* @__PURE__ */ jsxs29("div", { className: "sticky top-4 space-y-6", children: [
    /* @__PURE__ */ jsxs29("div", { className: "border-paper bg-body space-y-4 rounded-xl border p-4", children: [
      /* @__PURE__ */ jsx33(EventSummary_default, {}),
      /* @__PURE__ */ jsx33("hr", { className: "border-paper" }),
      totalTickets ? /* @__PURE__ */ jsxs29(Fragment13, { children: [
        /* @__PURE__ */ jsx33(TicketsSummary_default, {}),
        /* @__PURE__ */ jsx33(MerchandiseSummary_default, {}),
        /* @__PURE__ */ jsx33(AddonsSummary_default, {}),
        isPaid && /* @__PURE__ */ jsxs29(Fragment13, { children: [
          /* @__PURE__ */ jsx33("hr", { className: "border-paper" }),
          /* @__PURE__ */ jsx33(
            BookingTotals,
            {
              totals,
              discount,
              subscriptionCredits
            }
          )
        ] })
      ] }) : /* @__PURE__ */ jsxs29("div", { className: "space-y-4 py-4 text-center", children: [
        /* @__PURE__ */ jsx33("img", { src: "/@wbk/ticketing/empty_tickets.svg", alt: "", className: "mx-auto h-52 w-40" }),
        /* @__PURE__ */ jsx33("p", { className: "", children: t("ticketing_booking:select_ticket_continue") })
      ] })
    ] }),
    ((_a = event == null ? void 0 : event.organization) == null ? void 0 : _a.slug) === ALDANA_SLUG && /* @__PURE__ */ jsx33("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx33(WbkContactUs_default, {}) }),
    /* @__PURE__ */ jsx33(PerksBanner_default, {})
  ] });
};
var SummarySidebar_default = SummarySidebar;

// src/components/booking/summary/SummaryScreen.tsx
import { useMemo as useMemo12 } from "react";
import { Button as Button13, Checkbox as Checkbox2, Typography as Typography6 } from "@wbk/ui";
import { CurrencyPriceLabel as CurrencyPriceLabel9 } from "@wbk/currency";
import {
  BookingTotals as BookingTotals2,
  MAX_PAYMENT_AMOUNT as MAX_PAYMENT_AMOUNT2,
  PaymentMethodSelector,
  RedeemForm,
  usePayment as usePayment6
} from "@wbk/payment";
import { Controller as Controller6, useFormContext as useFormContext7 } from "react-hook-form";
import { Link, Trans as Trans4, useCheckoutConfig, useRouter as useRouter12, useTranslation as useTranslation27 } from "@wbk/config";
import { Fragment as Fragment14, jsx as jsx34, jsxs as jsxs30 } from "react/jsx-runtime";
var SummaryScreen = () => {
  const {
    resell: { terms }
  } = useTicketing();
  const checkout2 = useCheckoutConfig();
  const { locale } = useRouter12();
  const {
    event,
    subscription,
    totals,
    checkoutError,
    appliedBundle,
    merchandise,
    plainTickets,
    subscriptionBookingLimit
  } = useBooking_default();
  const { control } = useFormContext7();
  const { coupon } = usePayment6();
  const { t } = useTranslation27(["subscription_common", "ticketing_common", "ticketing_booking"]);
  const { isValid } = usePayment6();
  const errorMessage = checkoutError == null ? void 0 : checkoutError.message;
  const paymentAmountLimit = totals.net_after_discount <= MAX_PAYMENT_AMOUNT2;
  const isCouponAppliedToAll = useMemo12(() => {
    return event == null ? void 0 : event.event_tickets.every((event2) => coupon.ticket_ids.includes(event2._id));
  }, [event, coupon.ticket_ids]);
  const canRedeem = !subscription;
  const isPaid = totals.gross > 0;
  const needPay = totals.net_after_discount > 0;
  const hideWallet = !!subscription || merchandise.length > 0;
  const discount = useMemo12(() => {
    if (!appliedBundle)
      return 0;
    if (appliedBundle.title)
      return appliedBundle.title;
    return /* @__PURE__ */ jsx34(
      Trans4,
      {
        ns: "ticketing_booking",
        i18nKey: appliedBundle.type === "order" ? "bundle_order_offer" : "bundle_ticket_offer",
        values: {
          percentage: appliedBundle.discount,
          count: Object.values(appliedBundle.event_tickets)[0]
        },
        children: /* @__PURE__ */ jsx34("span", { className: "text-green-600" })
      }
    );
  }, [appliedBundle]);
  const subscriptionCredits = useMemo12(() => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!event.is_live_streaming)
      return void 0;
    const selectedTicketTypeId = (_a = plainTickets[0]) == null ? void 0 : _a.subscription_ticket_type_id;
    const remaining = ((_b = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _b[selectedTicketTypeId || ""]) || 0;
    const used = ((_c = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.quantities) == null ? void 0 : _c[selectedTicketTypeId || ""]) || 0;
    const plan = (_g = (_f = (_e = (_d = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.subscriptions) == null ? void 0 : _d[0]) == null ? void 0 : _e.plan) == null ? void 0 : _f.plan_group) == null ? void 0 : _g.name;
    return {
      remaining,
      used,
      plan
    };
  }, [subscriptionBookingLimit, plainTickets, event]);
  return /* @__PURE__ */ jsxs30("div", { className: "space-y-8", children: [
    /* @__PURE__ */ jsxs30("div", { className: "flex flex-col-reverse space-y-4 lg:flex-col", children: [
      needPay && /* @__PURE__ */ jsx34(
        Controller6,
        {
          control,
          name: "payment_method",
          rules: {
            required: t("ticketing_booking:select_payment_method"),
            validate: () => {
              return isValid || t("ticketing_booking:complete_payment_information");
            }
          },
          render: ({ field, fieldState: { error } }) => /* @__PURE__ */ jsx34(
            PaymentMethodSelector,
            {
              className: "pt-4 lg:pt-0",
              totals,
              tabby: merchandise.length <= 0,
              applePay: !subscription,
              ref: field.ref,
              error: error == null ? void 0 : error.message
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs30("div", { className: "!mt-0 space-y-4 lg:hidden", children: [
        /* @__PURE__ */ jsx34(TicketsSummary_default, {}),
        /* @__PURE__ */ jsx34(MerchandiseSummary_default, {}),
        /* @__PURE__ */ jsx34(AddonsSummary_default, {}),
        /* @__PURE__ */ jsx34("hr", { className: "border-paper" }),
        isPaid && /* @__PURE__ */ jsxs30(Fragment14, { children: [
          /* @__PURE__ */ jsx34(
            BookingTotals2,
            {
              totals,
              discount,
              subscriptionCredits
            }
          ),
          /* @__PURE__ */ jsx34("hr", { className: "border-paper" })
        ] })
      ] })
    ] }),
    canRedeem && /* @__PURE__ */ jsx34(
      RedeemForm,
      {
        totals,
        isCouponAppliedToAll,
        hideWallet
      }
    ),
    /* @__PURE__ */ jsxs30("div", { className: "space-y-4 p-0.5", children: [
      /* @__PURE__ */ jsx34("h2", { className: "text-2xl", children: t("ticketing_booking:important_to_know") }),
      /* @__PURE__ */ jsx34(
        Controller6,
        {
          control,
          name: "acceptedTerms.webookTerms",
          rules: { required: t("ticketing_common:validation.required") },
          render: ({ field, fieldState: { error } }) => {
            return /* @__PURE__ */ jsx34(
              Checkbox2,
              {
                groupClassName: "text-sm",
                className: "mt-px",
                "data-testid": "ticketing_summary_terms_checkbox",
                ref: field.ref,
                error: error == null ? void 0 : error.message,
                label: /* @__PURE__ */ jsx34("p", { children: /* @__PURE__ */ jsxs30(Trans4, { i18nKey: "agree", ns: "ticketing_booking", children: [
                  /* @__PURE__ */ jsx34(
                    Button13,
                    {
                      as: Link,
                      shape: "text",
                      "data-testid": "ticketing_summary_terms_page_link",
                      className: "px-0.5 py-0 font-semibold underline",
                      href: `/${locale}/terms`,
                      target: "_blank",
                      rel: "noreferrer",
                      children: " "
                    }
                  ),
                  /* @__PURE__ */ jsx34(
                    Button13,
                    {
                      as: Link,
                      shape: "text",
                      "data-testid": "ticketing_summary_privacy_page_link",
                      className: "px-0.5 py-0 font-semibold underline",
                      href: `/${locale}/privacy`,
                      target: "_blank",
                      rel: "noreferrer",
                      children: " "
                    }
                  )
                ] }) }),
                checked: field.value,
                onChange: () => field.onChange(!field.value)
              }
            );
          }
        }
      ),
      checkout2.sendTicketsTerms && /* @__PURE__ */ jsx34(
        Controller6,
        {
          control,
          name: "acceptedTerms.sendTicketsTerms",
          rules: { required: t("ticketing_common:validation.required") },
          render: ({ field, fieldState: { error } }) => {
            return /* @__PURE__ */ jsx34(
              Checkbox2,
              {
                label: t("ticketing_booking:send_tickets_agree"),
                groupClassName: "text-sm",
                className: "mt-px",
                "data-testid": "send_tickets_agree_terms_checkbox",
                checked: field.value,
                onChange: () => field.onChange(!field.value),
                error: error == null ? void 0 : error.message,
                ref: field.ref
              }
            );
          }
        }
      ),
      !event.is_live_streaming && /* @__PURE__ */ jsx34(
        Controller6,
        {
          control,
          name: "acceptedTerms.resellTerms",
          rules: { required: t("ticketing_common:validation.required") },
          render: ({ field, fieldState: { error } }) => {
            return /* @__PURE__ */ jsx34(
              Checkbox2,
              {
                label: terms,
                groupClassName: "text-sm",
                className: "mt-px",
                "data-testid": "ticketing_summary_resell_terms_checkbox",
                checked: field.value,
                onChange: () => field.onChange(!field.value),
                error: error == null ? void 0 : error.message,
                ref: field.ref
              }
            );
          }
        }
      ),
      subscription && /* @__PURE__ */ jsx34(
        Controller6,
        {
          control,
          name: "acceptedTerms.subscriptionTerms",
          rules: { required: t("ticketing_common:validation.required") },
          render: ({ field, fieldState: { error } }) => {
            var _a, _b;
            return /* @__PURE__ */ jsx34(
              Checkbox2,
              {
                groupClassName: "text-sm",
                className: "mt-px",
                label: /* @__PURE__ */ jsxs30("div", { children: [
                  /* @__PURE__ */ jsx34("p", { children: t("subscription_common:recurring_payment_term", {
                    plan: ((_a = subscription == null ? void 0 : subscription.plan) == null ? void 0 : _a.name) || ""
                  }) }),
                  /* @__PURE__ */ jsxs30("div", { className: "space-y-3", children: [
                    /* @__PURE__ */ jsx34("p", { className: "text-text-secondary text-sm", children: t("subscription_common:recurring_payment_term_agree", {
                      plan: ((_b = subscription == null ? void 0 : subscription.planGroup) == null ? void 0 : _b.name) || ""
                    }) }),
                    /* @__PURE__ */ jsx34("p", { className: "text-text-secondary text-sm", children: t("subscription_common:recurring_payment_term_understand") })
                  ] })
                ] }),
                checked: field.value,
                onChange: () => field.onChange(!field.value),
                error: error == null ? void 0 : error.message,
                ref: field.ref
              }
            );
          }
        }
      ),
      (event == null ? void 0 : event.has_consent) && /* @__PURE__ */ jsx34(
        Controller6,
        {
          control,
          name: "acceptedTerms.consent",
          render: ({ field, fieldState: { error } }) => {
            return /* @__PURE__ */ jsx34(
              Checkbox2,
              {
                label: /* @__PURE__ */ jsx34(Typography6, { variant: "body-S", children: /* @__PURE__ */ jsx34(Trans4, { i18nKey: "consent", ns: "ticketing_booking", children: /* @__PURE__ */ jsx34(
                  Button13,
                  {
                    as: Link,
                    shape: "text",
                    className: "px-0.5 py-0 font-semibold underline",
                    href: "https://r2.webook.com/consent_diriyah_season.pdf",
                    target: "_blank",
                    rel: "noreferrer",
                    children: " "
                  }
                ) }) }),
                groupClassName: "text-sm",
                className: "mt-px",
                "data-testid": "consent_checkbox",
                checked: field.value,
                onChange: () => field.onChange(!field.value),
                error: error == null ? void 0 : error.message,
                ref: field.ref
              }
            );
          }
        }
      ),
      errorMessage && /* @__PURE__ */ jsx34(Typography6, { as: "div", variant: "body-S", color: "error", children: errorMessage }),
      !paymentAmountLimit && /* @__PURE__ */ jsxs30(Typography6, { as: "div", variant: "body-S", color: "error", children: [
        t("ticketing_booking:payment_maximum_amount"),
        /* @__PURE__ */ jsx34(
          CurrencyPriceLabel9,
          {
            originalPrice: MAX_PAYMENT_AMOUNT2,
            currency: event.currency,
            className: "ms-0.5 inline-block [&_svg]:h-3 [&_svg]:w-3",
            priceClassName: "text-body-S"
          }
        )
      ] })
    ] })
  ] });
};
var SummaryScreen_default = SummaryScreen;

// src/components/booking/addons/AddonsSection.tsx
import { useMemo as useMemo17 } from "react";
import { ShopIcon as ShopIcon2 } from "@wbk/svg";
import { useGetEventAddonsById } from "@wbk/api/hooks";
import { Button as Button18 } from "@wbk/ui";
import { useRouter as useRouter15, useTranslation as useTranslation30 } from "@wbk/config";

// src/components/booking/merchandise/ProductsGrid.tsx
import { useMemo as useMemo14 } from "react";
import { useMerchandiseProducts } from "@wbk/api/hooks";
import { ShopIcon } from "@wbk/svg";
import { Button as Button15 } from "@wbk/ui";
import { useRouter as useRouter14, useTranslation as useTranslation29 } from "@wbk/config";

// src/components/booking/merchandise/ProductCard.tsx
import { useMemo as useMemo13, useRef as useRef4 } from "react";
import { Button as Button14, ImageWithPlaceholder as ImageWithPlaceholder3, Spinner, Toast as Toast3 } from "@wbk/ui";
import { AddIcon as AddIcon3, CartIcon, MinusIcon as MinusIcon3, TrashIcon } from "@wbk/svg";
import { useHoldProducts as useHoldProducts2 } from "@wbk/api/hooks";
import { useAuth as useAuth4 } from "@wbk/auth";
import { useRouter as useRouter13, useTranslation as useTranslation28 } from "@wbk/config";
import { Fragment as Fragment15, jsx as jsx35, jsxs as jsxs31 } from "react/jsx-runtime";
var ProductCard = ({ product }) => {
  const toast = useRef4(void 0);
  const { merchandise, addMerchandiseProduct, removeMerchandiseProduct } = useBooking_default();
  const totals = useMemo13(() => {
    return merchandise.reduce(
      (acc, item) => {
        if (item.product.ID === product.id) {
          acc.qty += item.qty;
          acc.variations += 1;
        }
        return acc;
      },
      { qty: 0, variations: 0 }
    );
  }, [merchandise, product.id]);
  const { user } = useAuth4();
  const { locale } = useRouter13();
  const { t } = useTranslation28(["ticketing_common"]);
  const { mutateAsync: holdProduct, isPending } = useHoldProducts2();
  const handleAddSimple = () => __async(void 0, null, function* () {
    var _a, _b, _c, _d;
    try {
      const item = merchandise.find((item2) => item2.product.ID === product.id);
      yield holdProduct({
        userId: (user == null ? void 0 : user._id) || "",
        email: (user == null ? void 0 : user.email) || "",
        products: [{ id: ((_a = item == null ? void 0 : item.variation) == null ? void 0 : _a.ID) || product.id, quantity: 1 }],
        lang: locale
      });
      addMerchandiseProduct({ qty: 1, product: __spreadValues({ ID: product.id }, product) });
      (_b = toast.current) == null ? void 0 : _b.publish({
        title: t("ticketing_booking:merchandise.product_added_to_cart"),
        type: "success",
        icon: true
      });
    } catch (error) {
      const errorData = error;
      (_d = toast.current) == null ? void 0 : _d.publish({
        title: ((_c = errorData == null ? void 0 : errorData.error) == null ? void 0 : _c.message) || t("ticketing_common:unknown_error"),
        type: "error",
        icon: true
      });
    }
  });
  return /* @__PURE__ */ jsxs31(Fragment15, { children: [
    /* @__PURE__ */ jsx35(Toast3, { ref: toast }),
    /* @__PURE__ */ jsx35(
      BookProductModal_default,
      {
        productId: product.id,
        render: ({ open }) => {
          return /* @__PURE__ */ jsxs31(
            Button14,
            {
              theme: "transparent",
              shape: "text",
              className: "flex-col items-start gap-2 p-px",
              onClick: open,
              children: [
                /* @__PURE__ */ jsxs31("div", { className: "relative", children: [
                  /* @__PURE__ */ jsx35(
                    ImageWithPlaceholder3,
                    {
                      src: product.featured_image_url,
                      alt: product.title.rendered,
                      className: "aspect-[2/3] rounded-xl object-cover"
                    }
                  ),
                  totals.qty ? /* @__PURE__ */ jsxs31("div", { className: "bg-primary absolute bottom-3 flex h-10 items-center gap-1 rounded-lg p-1 shadow-md ltr:right-3 rtl:left-3", children: [
                    /* @__PURE__ */ jsx35(
                      Button14,
                      {
                        as: "a",
                        href: "#",
                        role: "button",
                        shape: "text",
                        theme: "action",
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          removeMerchandiseProduct(product.id, totals.variations > 1);
                        },
                        className: "flex h-8 w-8 items-center justify-center p-1",
                        children: totals.qty === 1 || totals.variations > 1 ? /* @__PURE__ */ jsx35(TrashIcon, { className: "h-4 w-4" }) : /* @__PURE__ */ jsx35(MinusIcon3, { className: "h-4 w-4" })
                      }
                    ),
                    /* @__PURE__ */ jsx35("span", { className: "px-2 text-xl font-semibold", children: totals.qty }),
                    /* @__PURE__ */ jsx35(
                      Button14,
                      {
                        as: "a",
                        href: "#",
                        role: "button",
                        shape: "text",
                        theme: "action",
                        className: "flex h-8 w-8 items-center justify-center p-1",
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (totals.variations === 1)
                            return handleAddSimple();
                          open();
                        },
                        children: isPending ? /* @__PURE__ */ jsx35(Spinner, { width: 16 }) : /* @__PURE__ */ jsx35(AddIcon3, { className: "h-4 w-4" })
                      }
                    )
                  ] }) : /* @__PURE__ */ jsx35(Fragment15, { children: /* @__PURE__ */ jsx35(
                    "a",
                    {
                      role: "button",
                      href: "#",
                      tabIndex: product.type === "simple" ? 0 : -1,
                      className: "absolute bottom-3 h-11 w-11 rounded-lg bg-white text-black shadow-md ltr:right-3 rtl:left-3",
                      onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (product.type === "simple") {
                          handleAddSimple();
                        } else {
                          open();
                        }
                      },
                      children: /* @__PURE__ */ jsx35("div", { className: "relative flex h-full w-full cursor-pointer items-center justify-center", children: isPending ? /* @__PURE__ */ jsx35(Spinner, {}) : /* @__PURE__ */ jsx35(CartIcon, { className: "h-6 w-6 shrink-0" }) })
                    }
                  ) })
                ] }),
                /* @__PURE__ */ jsxs31("div", { className: "space-y-1 text-start", children: [
                  /* @__PURE__ */ jsx35("p", { children: product.title.rendered }),
                  /* @__PURE__ */ jsx35(ProductPrice_default, { product, className: "space-y-0.5" })
                ] })
              ]
            }
          );
        }
      }
    )
  ] });
};
var ProductCard_default = ProductCard;

// src/components/booking/merchandise/ProductsGrid.tsx
import { Fragment as Fragment16, jsx as jsx36, jsxs as jsxs32 } from "react/jsx-runtime";
var PER_PAGE = 6;
var ProductsGrid = () => {
  const { locale } = useRouter14();
  const { event, favoriteTeam } = useBooking_default();
  const { t } = useTranslation29(["ticketing_booking"]);
  const query = useMemo14(() => {
    let authorIds = [];
    let tags = [];
    if (!event.webook_authors) {
      return { authorIds, tags };
    }
    if (favoriteTeam) {
      const teams = event.webook_authors.filter(
        (author) => author.team === favoriteTeam || !author.team
      );
      authorIds = teams.flatMap((author) => author.author_id);
      tags = teams.flatMap((author) => author.tags || []).filter(Boolean);
    } else {
      authorIds = event.webook_authors.flatMap((author) => author.author_id);
      tags = event.webook_authors.flatMap((author) => author.tags || []).filter(Boolean);
    }
    return { authorIds, tags };
  }, [event.webook_authors, favoriteTeam]);
  const {
    data: products,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useMerchandiseProducts({
    lang: locale,
    authorIds: query.authorIds,
    tags: query.tags,
    perPage: PER_PAGE
  });
  if (!isLoading && !(products == null ? void 0 : products.length))
    return null;
  return /* @__PURE__ */ jsxs32(
    "div",
    {
      id: "merchandise",
      className: "border-paper space-y-6 overflow-hidden rounded-xl lg:space-y-0 lg:border",
      children: [
        /* @__PURE__ */ jsxs32("div", { className: "border-paper flex items-center gap-4 lg:border-b lg:px-6 lg:py-4", children: [
          /* @__PURE__ */ jsx36(ShopIcon, { className: "hidden h-9 w-9 lg:block" }),
          /* @__PURE__ */ jsxs32("div", { children: [
            /* @__PURE__ */ jsx36("h2", { className: "text-2xl", children: t("ticketing_booking:merchandise.merchandise") }),
            /* @__PURE__ */ jsx36("p", { className: "text-text-secondary", children: t("ticketing_booking:merchandise.featured_products") })
          ] })
        ] }),
        /* @__PURE__ */ jsx36("div", { className: "border-paper lg:border-b lg:p-6", children: isLoading ? /* @__PURE__ */ jsx36(Skeleton2, {}) : error ? /* @__PURE__ */ jsx36("p", { className: "text-error py-10 text-center", children: (error == null ? void 0 : error.message) || t("ticketing_booking:merchandise.no_products_found") }) : (products == null ? void 0 : products.length) ? /* @__PURE__ */ jsxs32("ul", { className: "grid grid-cols-2 gap-6 sm:grid-cols-[repeat(auto-fill,minmax(165px,1fr))]", children: [
          products.map((product, i) => {
            return /* @__PURE__ */ jsx36("li", { children: /* @__PURE__ */ jsx36(ProductCard_default, { product }) }, `${product.id}-${i}`);
          }),
          isFetchingNextPage && /* @__PURE__ */ jsx36(Fragment16, { children: [...Array(PER_PAGE)].map((_, index) => /* @__PURE__ */ jsx36(ItemSkeleton, {}, index)) })
        ] }) : /* @__PURE__ */ jsx36("p", { className: "text-center", children: t("ticketing_booking:merchandise.no_products_found") }) }),
        hasNextPage && /* @__PURE__ */ jsx36("div", { className: "p-1", children: /* @__PURE__ */ jsx36(
          Button15,
          {
            theme: "transparent",
            shape: "text",
            className: "border-text mx-auto block w-full max-w-sm border p-2 text-lg font-semibold lg:max-w-none lg:border-none lg:p-4",
            onClick: () => fetchNextPage(),
            disabled: isFetchingNextPage || isLoading,
            children: t("ticketing_booking:merchandise.load_more_products")
          }
        ) })
      ]
    }
  );
};
var Skeleton2 = () => {
  return /* @__PURE__ */ jsx36("ul", { className: "grid grid-cols-2 gap-6 sm:grid-cols-[repeat(auto-fill,minmax(165px,1fr))]", children: [...Array(PER_PAGE)].map((_, index) => /* @__PURE__ */ jsx36(ItemSkeleton, {}, index)) });
};
var ItemSkeleton = () => {
  return /* @__PURE__ */ jsxs32("li", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx36("div", { className: "aspect-1 bg-body-level-1 animate-pulse rounded-xl" }),
    /* @__PURE__ */ jsx36("div", { className: "bg-body-level-1 h-6 w-4/5 animate-pulse rounded-md" }),
    /* @__PURE__ */ jsx36("div", { className: "bg-body-level-1 h-4 w-3/4 animate-pulse rounded-md" })
  ] });
};
var ProductsGrid_default = ProductsGrid;

// src/components/booking/addons/Addons.tsx
import { Fragment as Fragment17, useMemo as useMemo16 } from "react";

// src/components/booking/addons/AddonItem.tsx
import { useMemo as useMemo15 } from "react";
import { AddIcon as AddIcon4, MinusIcon as MinusIcon4 } from "@wbk/svg";
import { Button as Button16 } from "@wbk/ui";
import { CurrencyPriceLabel as CurrencyPriceLabel10 } from "@wbk/currency";
import { jsx as jsx37, jsxs as jsxs33 } from "react/jsx-runtime";
var AddonItem = ({ addon }) => {
  const { addons, event, addAddon, removeAddon } = useBooking_default();
  const quantity = useMemo15(() => {
    const currentAddon = addons.find((a) => a._id === addon._id);
    return {
      quantity: (currentAddon == null ? void 0 : currentAddon.qty) || 0,
      reachedMax: currentAddon && currentAddon.qty >= addon.max_per_order
    };
  }, [addon._id, addon.max_per_order, addons]);
  return /* @__PURE__ */ jsxs33("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ jsxs33("div", { className: "flex items-start gap-4", children: [
      /* @__PURE__ */ jsx37("div", { className: "mt-1 flex w-6 items-center justify-center rounded bg-[#1D58FF] p-1 text-xs md:w-8 md:text-sm", children: addon.name.slice(0, 2).toUpperCase() }),
      /* @__PURE__ */ jsxs33("div", { children: [
        /* @__PURE__ */ jsx37("p", { className: "text-sm sm:text-base sm:font-semibold", children: addon.name }),
        /* @__PURE__ */ jsx37("p", { className: "text-text-secondary text-sm", children: addon.subtitle }),
        /* @__PURE__ */ jsx37(
          CurrencyPriceLabel10,
          {
            className: "text-sm",
            originalPrice: +addon.price,
            currency: event.currency
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs33("div", { className: "flex items-center gap-3 font-sans text-3xl leading-none", children: [
      /* @__PURE__ */ jsx37(
        Button16,
        {
          onClick: () => {
            removeAddon(addon, 1);
          },
          disabled: quantity.quantity <= 0,
          shape: "outlined",
          theme: "action",
          "data-testid": "ticketing_addons_decrease_addon_button",
          className: "remove-from-cart flex h-8 w-8 items-center justify-center p-1",
          children: /* @__PURE__ */ jsx37(MinusIcon4, {})
        }
      ),
      /* @__PURE__ */ jsxs33("div", { className: "text-xl font-semibold", children: [
        " ",
        quantity.quantity
      ] }),
      /* @__PURE__ */ jsx37(
        Button16,
        {
          onClick: () => addAddon(addon, 1),
          disabled: quantity.reachedMax,
          className: "add-addon flex h-8 w-8 items-center justify-center p-1",
          "data-testid": "ticketing_addons_increase_addon_button",
          "data-event-name": event.title,
          shape: "outlined",
          theme: "action",
          children: /* @__PURE__ */ jsx37(AddIcon4, {})
        }
      )
    ] })
  ] });
};
var AddonItem_default = AddonItem;

// src/components/booking/addons/Addons.tsx
import { jsx as jsx38, jsxs as jsxs34 } from "react/jsx-runtime";
var Addons = ({ addons }) => {
  const groupedAddons = useMemo16(() => groupAddonsByGroupName(addons), [addons]);
  const groupKeys = useMemo16(() => Object.keys(groupedAddons), [groupedAddons]);
  return /* @__PURE__ */ jsx38("div", { className: "space-y-8 lg:space-y-6", children: groupKeys.map((groupId) => {
    var _a, _b, _c;
    const group = groupedAddons[groupId];
    return /* @__PURE__ */ jsxs34(
      "div",
      {
        id: groupId,
        className: "border-paper space-y-6 rounded-xl lg:space-y-0 lg:overflow-hidden lg:border",
        children: [
          /* @__PURE__ */ jsxs34("div", { className: "border-paper flex items-center gap-4 lg:border-b lg:px-6 lg:py-4", children: [
            /* @__PURE__ */ jsx38("img", { src: (_a = group[0]) == null ? void 0 : _a.addon_groups.icon, alt: "", className: "hidden h-9 w-9 lg:block" }),
            /* @__PURE__ */ jsxs34("div", { children: [
              /* @__PURE__ */ jsx38("h2", { className: "text-2xl", children: (_b = group[0]) == null ? void 0 : _b.addon_groups.title }),
              /* @__PURE__ */ jsx38(
                "div",
                {
                  className: "text-text-secondary text-xs",
                  dangerouslySetInnerHTML: { __html: (_c = group[0]) == null ? void 0 : _c.addon_groups.subtitle }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx38("div", { className: "lg:p-6", children: /* @__PURE__ */ jsx38("ul", { children: group.map((addon, index) => /* @__PURE__ */ jsxs34(Fragment17, { children: [
            /* @__PURE__ */ jsx38("li", { className: "border-paper overflow-hidden rounded-xl border p-4 lg:rounded-none lg:border-none lg:p-0", children: /* @__PURE__ */ jsx38(AddonItem_default, { addon }) }),
            index < group.length - 1 && /* @__PURE__ */ jsx38("hr", { className: "border-paper my-4" })
          ] }, addon._id)) }) })
        ]
      },
      groupId
    );
  }) });
};
var Addons_default = Addons;

// src/components/booking/addons/AddonsSkeleton.tsx
import { jsx as jsx39, jsxs as jsxs35 } from "react/jsx-runtime";
var AddonsSkeleton = () => {
  return /* @__PURE__ */ jsx39("ul", { className: "flex flex-col gap-6", children: [1, 2].map((index) => /* @__PURE__ */ jsxs35("li", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx39("div", { className: "bg-body-level-1 h-8 w-3/5 animate-pulse rounded-md" }),
    /* @__PURE__ */ jsx39("div", { className: "bg-body-level-1 h-8 w-3/4 animate-pulse rounded-md" })
  ] }, index)) });
};
var AddonsSkeleton_default = AddonsSkeleton;

// src/components/booking/addons/Categories.tsx
import { Button as Button17 } from "@wbk/ui";
import { jsx as jsx40, jsxs as jsxs36 } from "react/jsx-runtime";
var AddonCategories = ({ categories }) => {
  const { activeId, setActiveId } = addons_default({
    groupIds: categories.map((cat) => cat.key)
  });
  return /* @__PURE__ */ jsx40("div", { className: "bg-body sticky top-9 z-10 !mt-2 flex items-center gap-3 overflow-auto pb-2 lg:top-0 lg:py-2.5", children: categories.map((item) => {
    return /* @__PURE__ */ jsxs36(
      Button17,
      {
        theme: "action",
        shape: "outlined",
        "aria-selected": activeId === item.key,
        className: "border-paper aria-selected:border-text shrink-0 space-x-1 rounded-full",
        onClick: () => {
          const el = document.getElementById(item.key);
          if (el) {
            window.scrollTo({ top: el.offsetTop, behavior: "smooth" });
          }
          setActiveId(item.key);
        },
        children: [
          item.icon && /* @__PURE__ */ jsx40("span", { children: item.icon }),
          /* @__PURE__ */ jsx40("span", { children: item.title })
        ]
      },
      item.key
    );
  }) });
};
var Categories_default = AddonCategories;

// src/components/booking/addons/AddonsSection.tsx
import { jsx as jsx41, jsxs as jsxs37 } from "react/jsx-runtime";
var AddonsSection = () => {
  var _a;
  const { locale } = useRouter15();
  const { t } = useTranslation30(["ticketing_booking"]);
  const { event, seatTickets, plainTickets, setCheckoutMode, isSeated } = useBooking_default();
  const eventTicketIds = useMemo17(() => {
    if (isSeated && seatTickets.selectedTickets.length > 0) {
      return seatTickets.selectedTickets.map((ticket) => ticket.ticket_id || ticket._id);
    }
    return plainTickets.map((ticket) => (ticket == null ? void 0 : ticket.ticket_id) || ticket._id);
  }, [isSeated, plainTickets, seatTickets == null ? void 0 : seatTickets.selectedTickets]);
  const { data, isLoading, error } = useGetEventAddonsById({
    event_id: event._id,
    ticket_ids: eventTicketIds,
    lang: locale
  });
  const hasMerchandise = !!((_a = event.webook_authors) == null ? void 0 : _a.length);
  const groupedAddons = useMemo17(() => groupAddonsByGroupName(data || []), [data]);
  const groupKeys = useMemo17(() => Object.keys(groupedAddons), [groupedAddons]);
  const categories = useMemo17(() => {
    const result = hasMerchandise ? [
      {
        title: t("ticketing_booking:merchandise.merchandise"),
        icon: /* @__PURE__ */ jsx41(ShopIcon2, { className: "h-5 w-5" }),
        key: "merchandise"
      }
    ] : [];
    return result.concat(
      groupKeys.map((key) => {
        var _a2, _b;
        const group = groupedAddons[key];
        return {
          title: (_a2 = group[0]) == null ? void 0 : _a2.addon_groups.title,
          icon: /* @__PURE__ */ jsx41("img", { src: (_b = group[0]) == null ? void 0 : _b.addon_groups.icon, alt: "", className: "h-5 w-5" }),
          key
        };
      })
    );
  }, [groupKeys, groupedAddons, hasMerchandise, t]);
  return /* @__PURE__ */ jsxs37("div", { className: "space-y-8 lg:space-y-6", children: [
    /* @__PURE__ */ jsx41("h1", { className: "text-2xl font-semibold md:text-3xl", children: t("ticketing_booking:merchandise.upgrade_your_experience") }),
    /* @__PURE__ */ jsx41(Categories_default, { categories }),
    hasMerchandise && /* @__PURE__ */ jsx41(ProductsGrid_default, {}),
    isLoading ? /* @__PURE__ */ jsx41(AddonsSkeleton_default, {}) : error ? /* @__PURE__ */ jsx41("p", { className: "text-error py-10 text-center", children: (error == null ? void 0 : error.message) || "No addons found" }) : (data == null ? void 0 : data.length) ? /* @__PURE__ */ jsx41(Addons_default, { addons: data }) : hasMerchandise ? null : /* @__PURE__ */ jsxs37("div", { className: "space-y-3 text-center", children: [
      /* @__PURE__ */ jsx41("p", { children: t("ticketing_booking:no_addons") }),
      /* @__PURE__ */ jsx41(Button18, { shape: "outlined", theme: "action", onClick: () => setCheckoutMode("summary"), children: t("ticketing_booking:merchandise.skip_to_payment") })
    ] })
  ] });
};
var AddonsSection_default = AddonsSection;

// src/components/booking/Booking.tsx
import { jsx as jsx42, jsxs as jsxs38 } from "react/jsx-runtime";
var Booking = () => {
  var _a;
  const { checkoutMode, event } = useBooking_default();
  const { isWebView } = useDeviceDetect5();
  return /* @__PURE__ */ jsxs38(
    "section",
    {
      "data-webview": isWebView,
      "data-overflow": checkoutMode === "addons",
      className: "container relative flex max-w-screen-2xl grow flex-col overflow-hidden pb-36 data-[overflow=true]:overflow-visible lg:flex-row lg:gap-4 lg:overflow-visible",
      children: [
        /* @__PURE__ */ jsxs38("div", { className: "space-y-4 pb-4 lg:hidden", children: [
          /* @__PURE__ */ jsx42(EventSummary_default, {}),
          /* @__PURE__ */ jsx42("hr", { className: "border-paper" })
        ] }),
        /* @__PURE__ */ jsx42(BookingWrapper_default, { mode: checkoutMode, children: checkoutMode === "teams" ? /* @__PURE__ */ jsx42(TeamsSelection_default, {}) : checkoutMode === "calendar" ? /* @__PURE__ */ jsx42(CalendarSlots_default, {}) : checkoutMode === "summary" ? /* @__PURE__ */ jsx42(SummaryScreen_default, {}) : checkoutMode === "addons" ? /* @__PURE__ */ jsx42(AddonsSection_default, {}) : /* @__PURE__ */ jsx42(BookingSection_default, {}) }),
        ((_a = event == null ? void 0 : event.organization) == null ? void 0 : _a.slug) === ALDANA_SLUG && /* @__PURE__ */ jsxs38("div", { className: "space-y-4 py-4 lg:hidden", children: [
          /* @__PURE__ */ jsx42(Divider, {}),
          /* @__PURE__ */ jsx42(WbkContactUs_default, {})
        ] }),
        /* @__PURE__ */ jsx42(BookingFooter_default, {}),
        /* @__PURE__ */ jsx42("aside", { className: "mx-auto hidden w-full max-w-lg shrink-0 space-y-4 lg:block lg:max-w-md", children: /* @__PURE__ */ jsx42(SummarySidebar_default, {}) })
      ]
    }
  );
};
var Booking_default = Booking;

// src/components/booking/streaming/Streaming.tsx
import { useEffect as useEffect9 } from "react";
import { LiveTvIcon } from "@wbk/svg";
import { RadioGroup as RadioGroup2 } from "@wbk/ui";
import { useTranslation as useTranslation34 } from "@wbk/config";

// src/components/booking/streaming/BookingFooter.tsx
import { Button as Button20 } from "@wbk/ui";
import { useDeviceDetect as useDeviceDetect7 } from "@wbk/hooks";
import { scrollToTop as scrollToTop3 } from "@wbk/utils";
import { SubscriptionIcon as SubscriptionIcon3 } from "@wbk/svg";
import { TicketBookingLimitsTrigger as TicketBookingLimitsTrigger2 } from "@wbk/subscription";
import { useTranslation as useTranslation32 } from "@wbk/config";
import { usePayment as usePayment8 } from "@wbk/payment";

// src/components/booking/streaming/FreeAction.tsx
import { useDeviceDetect as useDeviceDetect6 } from "@wbk/hooks";
import { BottomSheet as BottomSheet4, Button as Button19, Modal as Modal4 } from "@wbk/ui";
import { usePayment as usePayment7 } from "@wbk/payment";
import { useCheckoutStreamWithCredit } from "@wbk/api/hooks";
import { stringToBase64 as stringToBase642 } from "@wbk/utils";
import { useAuth as useAuth5 } from "@wbk/auth";
import { useAppSource as useAppSource2, useRouter as useRouter16, useTranslation as useTranslation31 } from "@wbk/config";
import { Fragment as Fragment18, jsx as jsx43, jsxs as jsxs39 } from "react/jsx-runtime";
var StreamingUseCreditAction = () => {
  const { isMobile } = useDeviceDetect6();
  return isMobile ? /* @__PURE__ */ jsx43(
    BottomSheet4,
    {
      closeButton: true,
      className: "z-[999]",
      sectionClassName: "pb-44 px-4",
      render: ({ open }) => /* @__PURE__ */ jsx43(Action, { open }),
      body: () => /* @__PURE__ */ jsx43(Body2, {}),
      stickyFooter: ({ close }) => /* @__PURE__ */ jsx43(Footer2, { close })
    }
  ) : /* @__PURE__ */ jsx43(
    Modal4,
    {
      closeButton: true,
      size: "xl",
      className: "p-6",
      contentClassName: "pb-16",
      render: ({ open }) => /* @__PURE__ */ jsx43(Action, { open }),
      body: () => /* @__PURE__ */ jsx43(Body2, {}),
      stickyFooter: ({ close }) => /* @__PURE__ */ jsx43(Footer2, { close })
    }
  );
};
var Body2 = () => {
  const { t } = useTranslation31(["ticketing_booking"]);
  return /* @__PURE__ */ jsxs39("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsx43("h2", { className: "text-2xl font-semibold", children: t("ticketing_booking:confirm_and_watch") }),
    /* @__PURE__ */ jsx43("hr", { className: "border-paper" }),
    /* @__PURE__ */ jsxs39("div", { className: "space-y-6", children: [
      /* @__PURE__ */ jsx43("p", { className: "text-2xl font-semibold", children: t("ticketing_booking:stream_balance_to_watch_for_free") }),
      /* @__PURE__ */ jsx43(EventSummary_default, {})
    ] })
  ] });
};
var Footer2 = ({ close }) => {
  const { locale, push } = useRouter16();
  const { bookingSource } = useAppSource2();
  const { plainTickets } = useBooking_default();
  const { paymentMethod } = usePayment7();
  const { user } = useAuth5();
  const { mutateAsync, isPending, error } = useCheckoutStreamWithCredit();
  const { t } = useTranslation31(["ticketing_common", "ticketing_booking"]);
  const handleUseStreamCredit = () => __async(void 0, null, function* () {
    try {
      const order = {
        redirect: window.origin + `/${locale}/payment-success`,
        redirect_failed: window.origin + `/${locale}/payment-failed`,
        booking_source: bookingSource,
        lang: locale,
        payment_method: paymentMethod,
        tickets: plainTickets.map((t2) => ({
          qty: t2.qty,
          id: t2._id
        }))
      };
      const data = yield mutateAsync({ order, locale, email: user == null ? void 0 : user.email });
      push(`/${locale}/payment-success/${stringToBase642(data.order_id)}`);
    } catch (error2) {
    }
  });
  return /* @__PURE__ */ jsxs39(Fragment18, { children: [
    (error == null ? void 0 : error.message) && /* @__PURE__ */ jsx43("p", { className: "text-error px-4 pt-2", children: error.message }),
    /* @__PURE__ */ jsxs39("div", { className: "xs:flex-row xs:justify-end xs:gap-2 flex flex-col-reverse items-center gap-4 p-4", children: [
      /* @__PURE__ */ jsx43(Button19, { theme: "action", shape: "text", className: "xs:w-auto w-full", onClick: close, children: t("ticketing_common:cancel") }),
      /* @__PURE__ */ jsx43(
        Button19,
        {
          theme: "action",
          className: "xs:w-auto w-full",
          onClick: handleUseStreamCredit,
          loading: isPending,
          children: t("ticketing_booking:free_stream_credit")
        }
      )
    ] })
  ] });
};
var Action = ({ open }) => {
  const { isSubscriptionCreditsEnabled } = usePayment7();
  const { canCheckout } = useBooking_default();
  const { t } = useTranslation31(["ticketing_booking"]);
  return /* @__PURE__ */ jsx43(
    Button19,
    {
      className: "mx-auto h-12 w-full max-w-sm lg:mx-0 lg:w-auto",
      "data-testid": "ticketing_preferences_to_payment_button",
      onClick: open,
      disabled: !canCheckout,
      children: t(
        `ticketing_booking:${isSubscriptionCreditsEnabled ? "confirm_booking" : "free_stream_credit"}`
      )
    }
  );
};
var FreeAction_default = StreamingUseCreditAction;

// src/components/booking/streaming/BookingFooter.tsx
import { jsx as jsx44, jsxs as jsxs40 } from "react/jsx-runtime";
var StreamingBookingFooter = () => {
  var _a;
  const { t } = useTranslation32(["subscription_common", "ticketing_booking"]);
  const { isWebView } = useDeviceDetect7();
  const {
    event,
    setCheckoutMode,
    checkoutMode,
    plainTickets,
    subscriptionBookingLimit,
    setSubscription,
    totalTickets
  } = useBooking_default();
  const { isSubscriptionCreditsEnabled } = usePayment8();
  const handleGoToSummary = () => {
    setCheckoutMode("summary");
    setTimeout(scrollToTop3, 0);
  };
  const mustHavePlan = subscriptionBookingLimit.mustUpgradeToPlans.mustHavePlan;
  const mustUpgrade = !!mustHavePlan && checkoutMode === "tickets";
  return /* @__PURE__ */ jsx44(
    "div",
    {
      "data-webview": isWebView,
      className: `bg-body border-paper group fixed inset-x-0 bottom-0 z-[99] w-full border-t lg:z-[49] ${isWebView ? "pb-6" : "safe-bottom"}`,
      children: /* @__PURE__ */ jsxs40(BookingWrapper_default, { mode: checkoutMode, className: "relative z-50 mx-auto grow overflow-hidden", children: [
        mustUpgrade && /* @__PURE__ */ jsx44(
          "div",
          {
            className: "animate-in slide-in-from-bottom-6 fade-in-100 rounded-t-lg bg-violet-700 lg:rounded-t-none",
            style: { background: (_a = mustHavePlan == null ? void 0 : mustHavePlan.plan_group) == null ? void 0 : _a.background_color },
            children: /* @__PURE__ */ jsxs40("div", { className: "container flex items-center gap-4 p-4 text-sm lg:text-base", children: [
              mustHavePlan ? /* @__PURE__ */ jsx44("img", { src: mustHavePlan.icon, width: 24, height: 24, className: "h-6 w-6", alt: "" }) : /* @__PURE__ */ jsx44(SubscriptionIcon3, { className: "text-primary h-5 w-5 shrink-0" }),
              /* @__PURE__ */ jsx44("p", { className: "grow", children: mustHavePlan ? t("subscription_common:must_have_plan_title", {
                plan: mustHavePlan.plan_group.name
              }) : t("subscription_common:upgrade_to_get_free_stream") })
            ] })
          }
        ),
        /* @__PURE__ */ jsx44("div", { className: "container flex h-[72px] items-center justify-end text-center", children: isSubscriptionCreditsEnabled && checkoutMode === "summary" ? /* @__PURE__ */ jsx44(FreeAction_default, {}) : mustUpgrade ? /* @__PURE__ */ jsx44(
          TicketBookingLimitsTrigger2,
          {
            event,
            className: "mx-auto h-12 w-full max-w-sm lg:mx-0 lg:w-auto",
            selectedTickets: plainTickets,
            ticketBenefits: __spreadProps(__spreadValues({}, subscriptionBookingLimit), {
              mustUpgradeToPlans: __spreadProps(__spreadValues({}, subscriptionBookingLimit.mustUpgradeToPlans), {
                allPlans: {}
              })
            }),
            onSelect: (plan) => {
              setSubscription(plan);
              handleGoToSummary();
            }
          }
        ) : checkoutMode === "summary" ? /* @__PURE__ */ jsx44(ProceedButton_default, { className: "mx-auto h-12 w-full max-w-sm lg:mx-0 lg:w-auto" }) : /* @__PURE__ */ jsx44(
          Button20,
          {
            theme: "action",
            className: "mx-auto h-12 w-full max-w-sm lg:mx-0 lg:w-auto",
            "data-testid": "ticketing_preferences_to_payment_button",
            onClick: () => {
              handleGoToSummary();
            },
            disabled: !totalTickets,
            children: t("ticketing_booking:next_payment")
          }
        ) })
      ] })
    }
  );
};
var BookingFooter_default2 = StreamingBookingFooter;

// src/components/booking/streaming/TicketRow.tsx
import { useState as useState9 } from "react";
import { CurrencyPriceLabel as CurrencyPriceLabel11 } from "@wbk/currency";
import { addVatToPrice as addVatToPrice4 } from "@wbk/utils";
import { Button as Button21 } from "@wbk/ui";
import { ChevronIcon as ChevronIcon4 } from "@wbk/svg";
import { motion as motion6 } from "motion/react";
import { useTranslation as useTranslation33 } from "@wbk/config";
import { jsx as jsx45, jsxs as jsxs41 } from "react/jsx-runtime";
var StreamingTicketRow = ({ ticket }) => {
  var _a;
  const { event, subscriptionBookingLimit } = useBooking_default();
  const { t } = useTranslation33(["ticketing_common", "ticketing_booking"]);
  const [open, setOpen] = useState9(false);
  const hasOffer = ticket.price !== ticket.original_price;
  const price = Number(ticket.priceWithFee) + Number(ticket.vatWithFee);
  const isSoldOut = ticket.remaining <= 0;
  const freeTicket = !!((_a = subscriptionBookingLimit == null ? void 0 : subscriptionBookingLimit.benefitValue) == null ? void 0 : _a[ticket.subscription_ticket_type_id || ""]);
  return /* @__PURE__ */ jsxs41("div", { className: "grow space-y-1", children: [
    /* @__PURE__ */ jsxs41("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ jsx45("p", { children: ticket.title }),
      /* @__PURE__ */ jsxs41("div", { className: "text-sm", children: [
        hasOffer && !isSoldOut && /* @__PURE__ */ jsx45(
          CurrencyPriceLabel11,
          {
            className: "text-text-secondary line-through",
            originalPrice: addVatToPrice4(ticket == null ? void 0 : ticket.originalPriceWithFee, +(event == null ? void 0 : event.vat_percent)),
            currency: ticket.currency,
            zeroAsFree: true
          }
        ),
        isSoldOut ? /* @__PURE__ */ jsx45("p", { className: "text-error text-lg", children: t("ticketing_booking:sold_out") }) : /* @__PURE__ */ jsx45(
          CurrencyPriceLabel11,
          {
            className: freeTicket ? "text-text-secondary line-through" : "",
            originalPrice: price,
            currency: ticket.currency,
            zeroAsFree: true
          }
        ),
        freeTicket && /* @__PURE__ */ jsx45("p", { className: "text-sm text-green-500", children: t("ticketing_booking:free_for_you") })
      ] })
    ] }),
    !!ticket.description && /* @__PURE__ */ jsxs41("div", { className: "border-input-border !mt-3 border-t pt-2", children: [
      /* @__PURE__ */ jsxs41(
        Button21,
        {
          onClick: () => setOpen((prev) => !prev),
          shape: "text",
          theme: "transparent",
          "aria-label": "expand description",
          className: "-mx-1 flex items-center gap-1 p-1 text-sm underline",
          children: [
            /* @__PURE__ */ jsx45("span", { children: t("ticketing_booking:more_details") }),
            /* @__PURE__ */ jsx45(ChevronIcon4, { className: `h-3 w-3 ${open ? "-rotate-90" : "rotate-90"}` })
          ]
        }
      ),
      !!ticket.description && /* @__PURE__ */ jsx45(
        motion6.div,
        {
          initial: { height: 0 },
          animate: { height: open ? "auto" : 0 },
          className: "text-text max-w-full overflow-hidden whitespace-pre-wrap",
          transition: { duration: 0.25, ease: "easeInOut" },
          "data-testid": "collapsable-text",
          children: /* @__PURE__ */ jsx45("div", { dangerouslySetInnerHTML: { __html: ticket.description }, className: "grow" })
        }
      )
    ] })
  ] });
};
var TicketRow_default2 = StreamingTicketRow;

// src/components/booking/streaming/Streaming.tsx
import { Fragment as Fragment19, jsx as jsx46, jsxs as jsxs42 } from "react/jsx-runtime";
var Streaming = () => {
  var _a;
  const { t } = useTranslation34([
    "currency_common",
    "payment_common",
    "subscription_common",
    "ticketing_common",
    "ticketing_event"
  ]);
  const { eventTickets, plainTickets, replacePlain, checkoutMode, setCheckoutMode } = useBooking_default();
  useEffect9(() => {
    if (eventTickets.length === 1) {
      replacePlain(eventTickets[0], 1);
      if (plainTickets.length > 0) {
        setCheckoutMode("summary");
      }
    }
  }, [eventTickets.length, plainTickets.length]);
  return /* @__PURE__ */ jsxs42("section", { className: "container relative flex max-w-screen-2xl grow flex-col gap-4 overflow-hidden pb-36 lg:flex-row lg:overflow-visible lg:px-6", children: [
    (eventTickets == null ? void 0 : eventTickets.length) > 0 ? /* @__PURE__ */ jsxs42(Fragment19, { children: [
      /* @__PURE__ */ jsxs42("div", { className: "space-y-4 pt-2 lg:hidden", children: [
        /* @__PURE__ */ jsx46(EventSummary_default, {}),
        /* @__PURE__ */ jsx46("hr", { className: "border-paper" })
      ] }),
      /* @__PURE__ */ jsx46(BookingWrapper_default, { mode: checkoutMode, children: checkoutMode === "summary" ? /* @__PURE__ */ jsx46(SummaryScreen_default, {}) : /* @__PURE__ */ jsx46("div", { className: "grow space-y-6", children: /* @__PURE__ */ jsx46(
        RadioGroup2,
        {
          name: "streaming-tickets",
          label: /* @__PURE__ */ jsx46("div", { children: /* @__PURE__ */ jsx46("h2", { className: "pb-2 text-2xl font-semibold", children: t("ticketing_event:stream.select_stream_type") }) }),
          className: "items-start",
          value: ((_a = plainTickets[0]) == null ? void 0 : _a._id) || "",
          options: eventTickets.map((ticket) => {
            return {
              text: /* @__PURE__ */ jsx46(TicketRow_default2, { ticket }),
              value: ticket._id
            };
          }),
          onChange: (id) => {
            const selected = eventTickets.find((tick) => tick._id === id);
            if (selected) {
              replacePlain(selected, 1);
            }
          }
        }
      ) }) }),
      /* @__PURE__ */ jsx46(BookingFooter_default2, {})
    ] }) : /* @__PURE__ */ jsxs42("div", { className: "w-full space-y-2 py-12 text-center text-sm", children: [
      /* @__PURE__ */ jsx46(LiveTvIcon, { className: "mx-auto h-32 w-32 opacity-30" }),
      /* @__PURE__ */ jsx46("p", { children: t("ticketing_event:stream.empty") })
    ] }),
    /* @__PURE__ */ jsx46("aside", { className: "mx-auto hidden w-full max-w-lg shrink-0 space-y-4 lg:block lg:max-w-md", children: /* @__PURE__ */ jsx46(SummarySidebar_default, {}) })
  ] });
};
var Streaming_default = Streaming;

// src/components/booking/earlyBird/WithEarlyBird.tsx
import { useMemo as useMemo18 } from "react";
import { useAuth as useAuth6 } from "@wbk/auth";
import { Button as Button22 } from "@wbk/ui";
import { useTranslation as useTranslation35 } from "@wbk/config";
import { jsx as jsx47, jsxs as jsxs43 } from "react/jsx-runtime";
var WithEarlyBird = ({ event, children }) => {
  var _a;
  const { user } = useAuth6();
  const { t } = useTranslation35(["ticketing_common"]);
  const isEligible = useMemo18(() => {
    const shouldCheck = event.early_bird_qualifiers;
    if (!shouldCheck) {
      return true;
    }
    return user == null ? void 0 : user.early_bird.some((eb) => eb.event_id === event._id || eb.season_id === event._id);
  }, [event._id, event.early_bird_qualifiers, user == null ? void 0 : user.early_bird]);
  if (!isEligible) {
    return /* @__PURE__ */ jsxs43("div", { className: "container", children: [
      /* @__PURE__ */ jsx47("div", { className: "py-2", children: /* @__PURE__ */ jsx47(Back_default, { text: t("ticketing_common:back") }) }),
      /* @__PURE__ */ jsxs43("div", { className: "mx-auto max-w-xl space-y-6 py-12 text-center", children: [
        /* @__PURE__ */ jsx47(
          "div",
          {
            className: "prose space-y-4 text-xl",
            dangerouslySetInnerHTML: { __html: (_a = event.early_bird_message) == null ? void 0 : _a.trim() }
          }
        ),
        event.early_bird_cta_link && event.early_bird_cta_title && /* @__PURE__ */ jsx47(Button22, { theme: "action", as: "a", href: event.early_bird_cta_link, children: event.early_bird_cta_title })
      ] })
    ] });
  }
  return children;
};
var WithEarlyBird_default = WithEarlyBird;

// src/components/booking/Page.tsx
import { jsx as jsx48, jsxs as jsxs44 } from "react/jsx-runtime";
var WbkBookingPage = (_a) => {
  var _b = _a, { event, slug, showResell, isPerks } = _b, props = __objRest(_b, ["event", "slug", "showResell", "isPerks"]);
  const { locale } = useRouter17();
  const { viewItemBook } = useAnalytics3();
  const { user } = useAuth7();
  const { data, isLoading } = useGetTicketingEvent(
    {
      slug,
      lang: locale
    },
    { enabled: !event }
  );
  const localEvent = event || data;
  const { data: perks, isFetching: perksLoading } = useGetEventPerks(
    { slug: (localEvent == null ? void 0 : localEvent.slug) || "", lang: locale },
    { enabled: !!(localEvent == null ? void 0 : localEvent.slug) && !!isPerks, placeholderData: [] }
  );
  const loading = isLoading || perksLoading;
  const mustNafath = !(user == null ? void 0 : user.is_nafath_verified) && (localEvent == null ? void 0 : localEvent.force_nafath);
  useEffect10(() => {
    if (data) {
      setTimeout(() => {
        var _a2;
        viewItemBook({
          event: __spreadProps(__spreadValues({}, data), { zone: (_a2 = data == null ? void 0 : data.zone) == null ? void 0 : _a2.slug }),
          price: data.event_start_price + data.event_start_price_vat
        });
      }, 0);
    }
  }, [data]);
  if (loading) {
    return /* @__PURE__ */ jsx48(BookingPageSkeleton_default, {});
  }
  if (!localEvent) {
    throw new Error(`Ticketing event "${slug}" not found`);
  }
  if (isPerks && !(perks == null ? void 0 : perks.length)) {
    return /* @__PURE__ */ jsx48("div", { className: "container flex justify-center py-8 md:py-24", children: /* @__PURE__ */ jsx48(Typography7, { variant: "body-L", children: /* @__PURE__ */ jsx48(Trans5, { i18nKey: "ticketing_booking:perks.not_eligble", values: { event: localEvent.title }, children: /* @__PURE__ */ jsx48(
      Button23,
      {
        theme: "transparent",
        shape: "text",
        className: "text-text-link p-0 underline",
        as: Link2,
        href: `/${locale}/events/${localEvent.slug}`
      }
    ) }) }) });
  }
  return /* @__PURE__ */ jsxs44(WithEarlyBird_default, { event: localEvent, children: [
    /* @__PURE__ */ jsx48(WebviewUnload, { loading }),
    /* @__PURE__ */ jsx48(WithGrecaptcha, { children: mustNafath ? /* @__PURE__ */ jsx48(NafathCheckPoint, {}) : /* @__PURE__ */ jsx48(
      WbkPaymentProvider,
      {
        currency: localEvent.currency,
        inlinePaytabs: localEvent.is_managed_form_enabled,
        isApplePayEnabled: localEvent.is_apple_pay_allowed,
        isBenefitPayEnabled: localEvent.is_benefit_pay_allowed,
        isStcPayEnabled: localEvent.is_stc_pay_allowed,
        isSaudiRewardsEnabled: localEvent.is_saudi_rewards_enabled,
        isQitafEnabled: localEvent.is_qitaf_enabled,
        isWalletEnabled: localEvent.is_wallet_enabled,
        isTabbyEnabled: localEvent.is_tabby === "1",
        event: localEvent,
        children: /* @__PURE__ */ jsx48(
          provider_default,
          __spreadProps(__spreadValues({
            event: localEvent,
            perks,
            isStream: !!(localEvent == null ? void 0 : localEvent.is_live_streaming) || !!(localEvent == null ? void 0 : localEvent.is_live_streaming),
            showResell: showResell || (localEvent == null ? void 0 : localEvent.has_resale_tickets)
          }, props), {
            children: /* @__PURE__ */ jsxs44(
              PurchasePriorityCheck,
              {
                prepend: /* @__PURE__ */ jsx48(EventSummary_default, { className: "mx-auto mb-8 w-full max-w-xl" }),
                event: localEvent,
                children: [
                  /* @__PURE__ */ jsx48(CountdownSection_default, {}),
                  localEvent.is_live_streaming ? /* @__PURE__ */ jsx48(Streaming_default, {}) : /* @__PURE__ */ jsx48(Booking_default, {})
                ]
              }
            )
          }),
          locale
        )
      }
    ) })
  ] });
};

export {
  WbkBookingPage
};
//# sourceMappingURL=chunk-RDAP7A7L.mjs.map